<template src="./reservationDetailVue.template.html"></template>
<script>
import moment from "moment-timezone";
import VeeValidate from "vee-validate";
import * as axios from "axios";
import { focus } from "vue-focus";
import VueGoogleAutocomplete from "vue-google-autocomplete";
import accounting from "accounting";
import io from "socket.io-client";
// import Vue from "vue";

import foliomodal from "./folioRecalculateConfirmationModal.vue";
import balanceTransferModal from "./balanceTransferFolioModal.vue";
import folioSettingModal from "../../guestProfile/guestProfileDetailVue/folioSettingModal.vue";
import foliomodal_new from "../../reservations/reservationDetailVue/folioRecalculateConfirmationModal.vue";  // assignOrUnassignModal

// import * as jsPDF from 'jspdf'
const phoneOrEmailRule = {
  getMessage(field, args) {
    console.log("fieldfield", field, args);

    // if(field == "phoneNumber"){
    return `The ${field} must be a valid phone number`;
    // }
    // else{
    //   return `The ${field} must be a valid email`;
    // }
  },
  validate(value, args) {
    // Custom regex for a phone number
    console.log("value", value);
    const MOBILEREG = /^[- +()]*[0-9][- +()0-9]*/;

    // Check for either of these to return true
    return VeeValidate.Rules.email(value) || MOBILEREG.test(value);
  },
};
VeeValidate.Validator.extend("phoneOrEmail", phoneOrEmailRule);
// VeeValidate.Validator.extend('email', phoneOrEmailRule);
// const dictionary = {
//   en: {
//     messages: {
//       email: function () {
//          required: 'Your email is empty'
//       },
//       phoneOrEmail: function () {
//         // return "I really dont like your email"
//       }
//     }
//   }
// };
// Vue.use(VeeValidate,{
//     fieldsBagName: 'vFields',
//     dictionary: {
//       en: {
//         custom: {
//           email: {
//             required: 'Your email is empty' // messages can be strings as well.
//           },
//           name: {
//             required: 'Your name is empty'
//           }
//        }
//     }
//   }
// });

// VeeValidate.Validator.updateDictionary(dictionary);

export default {
  directives: { focus: focus },
  name: "reservationDetailVue",
  props: [],
  data() {
    let RatePlanList = [];
    return {
      guestData: "",
      defaultSendQuoteTemplateHTML: "",
      timeout: null,
      refreshtagcomponent: true,
      prevRoute: "",
      folioItemsToVoid: [],
      previewItems: [],
      dontOpenPannel: false,
      dontOpenCompanyPannel: false,
      showPreviewButton: true,
      fromSummaryPannel: false,
      apiUrl:
        window.location.protocol +
        "//" +
        window.location.hostname +
        (window.location.port ? ":1339" : ""),
      // showBookedBy: true,
      showguestinfo: false,
      guestList: [],
      triggerevent: false,
      // checkinTime: {
      //   a: "am",
      //   hh: "00",
      //   mm: "00"
      // },
      // checkoutTime: {
      //   a: "am",
      //   hh: "00",
      //   mm: "00"
      // },
      // showphone:true,
      // eyeicon: true,
      // PaymentOption:true,
      // visibleCC: false,
      entitlements: {},
      Tagdisable: true,
      checkInOutAndStatusbutton: true,
      showPaymentbutton: true,
      checkinedit: true,
      // visibleCC:false,
      SourceEditBtn: true,
      checkoutedit: true,
      // eyeicon:true,
      isSelectedFromDropdown: false,
      checkinput: false,
      checkoutput: false,
      isSelectedFromDropdown: false,
      selectedLedger: {
        dateEffective: null,
        ledgerAccountID: null,
        defaultAmount: null,
        paymentInfoId: null,
        folioItemId: null,
        TaxAmount: null,
      },
      today: moment().format("YYYY-MM-DD HH:mm:ss"),
      showGuestInfoButton: true,
      showAccomodationInfoButton: true,
      showFolioDetailButton: true,
      showNotesDetailButton: true,
      selectedFilterColumn: null,
      isBgColor1: false,
      isBgColor2: false,
      isBgColor3: false,
      isBgColor4: true,
      isBgColor5: false,

      Color: "active",
      time: null,
      display: false,
      focused: false,
      isBgColor6: false,
      isBgColor7:false,

      // showCityDropdown: true,
      isVerfiedEmailDomain: false,
      displaySectionValue: "showBookedBy",
      displayGuestInfo: null,
      displayAccomodationInfo: null,
      displayNotesDetail: null,
      displayFolioDetail: null,
      radioCheck: null,
      // isDateBeforeOrAfterSixMonths: false,
      filteredUnitClasses: [],
      filteredProperties: [],
      filteredUnitTypes: [],
      filteredPromocode: [],
      filteredRatePlans: [],
      filterSearchUnitClassText: null,
      filterSearchPropertyText: null,
      filterSearchUnitTypeText: null,
      filterSearchPromoCodeText: null,
      filterSearchRatePlanText: null,
      showactualinventory: true,
      CreateGuestProfile: null,
      CreateCompanyProfile: null,
      searchByUnit: false,
      unitClassList: [],
      propertyList: [],
      unitTypeList: [],
      ratePlanList: [],
      promoCodeList: [],
      sourceList: [],
      subSourceList: [],
      guestInfo: {
        // GuestProfileId: -1,
        // ReservationId: -1,
        SourceName: "Tempo",
        SubSourceName: "",
        SourceId: 1,
      },
      selectedStateAndCountry: {},
      checkInTime: "00:00 AM",
      checkOutTime: "00:00 AM",
      checkedItems: [],
      roomInfo: {
        // dateObj: {},
        // numberOfPersonsInfo: {},
        // selectedRoom: {},
        // checkInTime: "12:00 AM",
        // checkOutTime: "12:00 AM",
        Persons: null,
        NumberOfAdults: null,
        NumberOfChildren: null,
        formattedStartDate: null,
        formattedEndDate: null,
        isActive: false,
        StartDate: null,
        EndDate: null,
      },
      folioCharges: {},
      itemToEdit: null,
      // isNoteStatusActive: null,
      notesActions: [
        // {
        //   noteStatusId: 1,
        //   class: "fas fa-check",
        //   isNoteStatusActive: null
        // },
        // {
        //   noteStatusId: 2,
        //   class: "fas fa-times",
        //   isNoteStatusActive: null
        // },

        {
          noteStatusId: 2,
          class: "far fa-times",
          isNoteStatusActive: null,
        },
      ],
      reservationStatusList: [],
      selectedCityObj: {},
      countryList: [],
      startAndEnddates: {},
      cityList: [],
      stateList: [],
      Reservation_Status: {
        StatusId: 10,
        StatusName: "Inquiry",
      },
      loading: true,
      cardDetails: null,
      showPayments: false,
      ShowDiv: false,
      noOfNights: null,
      show: false,
      showAmenitiesList: false,
      ShowDropdown: false,
      availableRoomsList: null,
      folioItemsDetails: [],
      folioItemsCharges: {},
      LedgerAcounts: [],
      notes: [],
      showMore: false,
      showLess: true,
      reservationUrl: -1,
      showRooms: false,
      displayConfirmationDropDown: false,
      // paymentsNotManual: [],
      // paymentsManual: [],
      DefaultProperty: null,
      selectedRoomFlag: false,
      // selectedRoom: {},
      updateTime: true,
      folioSummaryDetail: [],
      folioSummaryCharges: {},
      invoiceDetails: {
        // propertyAndClientDetails: {},
        // guestDetails: {},
        // folioItemDetails:{},
        // folioCharges:{}
      },
      ShowLessfolioItemsDetails: [],
      // selectedStateAndCountry: {},
      searchCity: "",
      searchState: "",
      searchCountry: "",
      enableStateCountry: false,
      AmenitiesList: null,
      filteredAmenities: [],
      tagDetails: null,
      additionalEmails: [],
      additionalPhoneNumbers: [],
      paymentDetails: {},
      pendingPaymentDetails: [],
      paymentCharges: {},
      notesDetailById: {
        noteId: -1,
      },
      notesTypeDropdown: [],
      taskTypeDropdown: [],
      tagsList: [],
      searchTag: null,
      showAutoComplete: false,
      showPaymentDetails: false,
      guestPaymentCards: [],
      paymentCardInfo: {
        CreditCard: null,
        NameOnCard: null,
        ExpirationMonth: "-1",
        ExpirationYear: "-1",
        PaymentTypeId: null,
        PaymentInfoId: -1,
        CCLast4Digits: null,
        CardType: null,
        CvvCode: null,
        IsDefault: false,
        AddressDetails: null,
        PostalCode: null,
      },
      months: [
        { name: "January", value: "01" },
        { name: "February", value: "02" },
        { name: "March", value: "03" },
        { name: "April", value: "04" },
        { name: "May", value: "05" },
        { name: "June", value: "06" },
        { name: "July", value: "07" },
        { name: "August", value: "08" },
        { name: "September", value: "09" },
        { name: "October", value: "10" },
        { name: "November", value: "11" },
        { name: "December", value: "12" },
      ],
      paymentLedgerAcounts: [],
      // paymentLedgerAcountsManual: [],
      selectedPaymentCardDetails: null,
      showPaymentOptions: false,
      showPaymentList: true,
      showAddPaymentDetail: false,
      // previousRoomInfo:{},
      // previousNumberOfPersonsInfo:{},
      // previousDateObj :{},
      previousRoomInfo: {
        // dateObj: {},
        // numberOfPersonsInfo: {},
        // selectedRoom: {}
      },
      selectedRoom: {},
      selectedFolioItemToEdit: null,
      selectedFolioItemActualJson: null,
      folioUpdate: false,
      displayVoidItems: false,
      displayAvailableUnits: false,
      isCitySelected: false,
      opens: "right",
      isFolioDirty: false,
      voidedItemsCount: 0,
      searchCityOldValue: "",
      searchStateOldValue: "",
      searchCountryOldValue: "",
      isModalVisible: false,
      modalParams: null,
      tempSaveAssignRoomParams: null,
      ShowCheckOut: false,
      ShowCheckIn: false,
      showicon: true,
      unassignbutton: true,
      isModalVisible: false,
      showSourceEditTool: false,
      crsList: [],
      allowEdit: false,
      stripe: null,
      card: null,
      showStripeElements: true,
      cardTokenFromStripe: null,
      editMode: false,
      fromFolio: false,
      paymentProcessMethod: null,
      stripePlatformAccount: {},
      stripeConnectedAccount: {},
      commissionAmmount: {},
      chargeItem: {},
      paymentProcessList: [],
      PendingchildPaymentitems: [],
      parentPaymentitemObj: {},
      showChildPaymentDetails: false,
      showNextProcessButton: true,
      paymentStatusId: null,
      paymentCardType: null,
      showGatewayResponseData: false,
      addressAndZipcodeShow: false,
      stripecardId: null,
      isVisible: false,
      list: [],
      buttonName: null,
      checkAmount: null,
      disabledMultiSave: false,
      disableMultiProcess: false,
      // DefaultSettingforSyncCard: "",
      isAccountConflict: null,
      PaymentMode: null,
      FeeCollected: null,
      currSearchObj: {},
      // currDetailObj: {},
      PostalCode: "",
      isFromGuestPannel: false,
      showGuestProfileDetail: false,
      showMessages: true,
      pannelOpened: false,
      guestPriorStays: [],
      ratePlanId: null,
      Promocode: null,
      previousFolioItemDetails: [],
      RatePlanList: RatePlanList,
      myValue: null,
      notificationAmount: null,
      ajax: {
        url:
          window.location.protocol +
          "//" +
          window.location.hostname +
          (window.location.port ? ":1339" : "") +
          "/getRates",
        // window.location.protocol + '//' + window.location.hostname + (window.location.port ? ":1339" : '')
        // port:
        type: "POST",
        data: function (params) {
          var query = {
            Tagtext: params.term,
            SearchText: "",
            StatusId: 1,
            type: "public",
            systemParams: {
              Source: "Web",
              SourceId: window.location.hostname,
              token: window.localStorage.getItem("rttoken"),
            },
          };

          // Query parameters will be ?search=[term]&type=public
          return query;
        },
        // success: function (response) {
        // },
        // error: function (d) {
        // },
        processResults: function (data) {
          // Tranforms the top-level key of the response object from 'items' to 'results'
          console.log("data,", data);

          return {
            RatePlanList: data[1],
            results: data[1],
          };
        },
      },
      showRatePlanSave: false,
      actualMyValue: [],
      selectedRatePlan: null,
      splitReservations: null,
      selectedItemCount: true,
      selectedVoidItem: false,
      selectAllFolio: false,
      folioDateChange: false,
      ratePlanResMinStay: null,
      emailList: [],
      guestProfileDetails: {},
      guestAdditionalEmail: [],
      guestAdditionalPhone: [],
      guestProfilePaymentDetails: [],
      guestTagsList: [],
      previousSelectedSectio: "",
      DetailedOrConsolidated: null,
      honourFolio: false,
      ActualInventoryValue: null,
      conversationId: 278,
      guestBookings: {},
      notificationEventId: null,
      lastMessageObject: {},
      showdeclineRequestReservation: false,
      ShowCompanyData: "Guest",
      additionalCompanyEmails: [{ ReservationId: "", Emailaddress: "" }],
      additionalCompanyPhoneNumbers: [{ ReservationId: "", PhoneNumber: "" }],
      companyInfo: {},
      companyAdditionalEmail: [{ ReservationId: "", Emailaddress: "" }],
      companyAdditionalPhone: [{ ReservationId: "", PhoneNumber: "" }],
      companyProfilePaymentDetails: [],
      infoType: null,
      showCompanyProfileData: false,
      showGuestProfileData: false,
      showEditDetails: false,
      surchargeAmount: null,
      balanceTransferFolioDetail: [],
      totalBTAmount: 0,
      isBalanceTransferModalVisible: false,
      showBTInvoice: false,
      balanceTransferDetails: [],
      isDateRange: null,
      showBTFolioDetails: false,
      balanceTransferInvoiceDetails: [],
      totalBalanceTransfer: null,
      totalAmountVal: null,
      totalTaxVal: null,
      selectedInvoiceId: "-99",
      corporateFolioId: null,
      showSettingModal: false,
      folioSettingDetails: {
        NextInvoiceDate: null,
        rateplanid: null,
        TempoConfirmationNumber: null,
        NegotiatedAmount: 0,
        NegotiatedCyclePeriod: 30,
        NegotiatedCyclePeriodType: "day",
        InvoiceFrequency: 30,
        InvoiceFrequencyType: "day",
        InvoicePaymentTerms: 30,
        InvoicePaymentTermsType: "day",
        isDailyEnabled: false,
        PastInvoiceNo: "",
        IsAutoGenerated: true,
        InvoicePriorGenerationPeriod: 0,
        InvoicePriorGenerationPeriodType: "day",
      },
      declineReasonsList: [],
      selectAllInvocies: false,
      // SyncToGuestProfile: false,
      selectedProfileId:null,
      showBTVoidItems: false,
      selectedNote:{},
      docuSignDetailNotes:[{}],
      customFieldsList:[{}],
      showLovList:false,
      selectedLovDropdown:null,
      propertyId: '',
      assignOrUnassignPopup: false,  // assignOrUnassignModal  
      assignOrUnassignModalParams:{}  // assignOrUnassignModal
    };
  },
  methods: {
    getGuestAddress(guestDetail) {
      const { CityName, StateName, ZipCode } = guestDetail;
      const addressArr = [CityName, StateName, ZipCode].filter(Boolean);
      return addressArr.join(", ");
    },
    getPropertyAddress(propertyDetail) {
      const { cityName, stateName, ZipCode } = propertyDetail;
      const addressArr = [cityName, stateName, ZipCode].filter(Boolean);
      return addressArr.join(", ");
    },
    getClientAddress(clientDetail) {
      const { ClientCity, ClientState, ClientZipCode } = clientDetail;
      const addressArr = [ClientCity, ClientState, ClientZipCode].filter(
        Boolean
      );
      return addressArr.join(", ");
    },
    displayAddress(guestDetail, accountType, companyDetail) {
      let displayAddress = [];
      console.log(
        "guestDetail.CountryName = ",
        guestDetail,
        accountType,
        guestDetail.CountryName,
        companyDetail
      );
      if (accountType == "guest") {
        if (
          guestDetail.CountryName &&
          guestDetail.CountryName.toUpperCase() != "UNITED STATES" &&
          guestDetail.CountryName.toUpperCase() != "US" &&
          guestDetail.CountryName.toUpperCase() != "USA"
        ) {
          if (guestDetail.CityName) {
            displayAddress.push(guestDetail.CityName);
          } else {
            if (guestDetail.StateName) {
              displayAddress.push(guestDetail.StateName);
            }
          }
          if (guestDetail.CountryName) {
            displayAddress.push(guestDetail.CountryName);
          }
        } else if (
          (guestDetail.CountryName &&
            (guestDetail.CountryName.toUpperCase() == "UNITED STATES" ||
              guestDetail.CountryName.toUpperCase() == "US" ||
              guestDetail.CountryName.toUpperCase() == "USA")) ||
          !guestDetail.CountryName
        ) {
          if (guestDetail.CityName) {
            displayAddress.push(guestDetail.CityName);
          }
          if (guestDetail.StateName) {
            displayAddress.push(guestDetail.StateName);
          }
          if (!guestDetail.CityName && !guestDetail.StateName) {
            if (guestDetail.CountryName) {
              displayAddress.push(guestDetail.CountryName);
            }
          }
        }
      } else if (accountType == "company") {
        if (
          companyDetail &&
          companyDetail.AccountType == 7 &&
          (companyDetail.CityName != "" ||
            companyDetail.StateName != "" ||
            companyDetail.CountryName != "")
        ) {
          if (
            companyDetail.CountryName &&
            companyDetail.CountryName.toUpperCase() != "UNITED STATES" &&
            companyDetail.CountryName.toUpperCase() != "US" &&
            companyDetail.CountryName.toUpperCase() != "USA"
          ) {
            if (companyDetail.CityName) {
              displayAddress.push(companyDetail.CityName);
            } else {
              if (companyDetail.StateName) {
                displayAddress.push(companyDetail.StateName);
              }
            }
            if (companyDetail.CountryName) {
              displayAddress.push(companyDetail.CountryName);
            }
          } else if (
            (companyDetail.CountryName &&
              (companyDetail.CountryName.toUpperCase() == "UNITED STATES" ||
                companyDetail.CountryName.toUpperCase() == "US" ||
                companyDetail.CountryName.toUpperCase() == "USA")) ||
            !companyDetail.CountryName
          ) {
            if (companyDetail.CityName) {
              displayAddress.push(companyDetail.CityName);
            }
            if (companyDetail.StateName) {
              displayAddress.push(companyDetail.StateName);
            }
            if (!companyDetail.CityName && !companyDetail.StateName) {
              if (companyDetail.CountryName) {
                displayAddress.push(companyDetail.CountryName);
              }
            }
          }
        } else {
          if (
            guestDetail.CompanyProfileCountryName &&
            guestDetail.CompanyProfileCountryName.toUpperCase() !=
              "UNITED STATES" &&
            guestDetail.CompanyProfileCountryName.toUpperCase() != "US" &&
            guestDetail.CompanyProfileCountryName.toUpperCase() != "USA"
          ) {
            if (guestDetail.CompanyProfileCity) {
              displayAddress.push(guestDetail.CompanyProfileCity);
            } else {
              if (guestDetail.CompanyProfileState) {
                displayAddress.push(guestDetail.CompanyProfileState);
              }
            }
            if (guestDetail.CompanyProfileCountryName) {
              displayAddress.push(guestDetail.CompanyProfileCountryName);
            }
          } else if (
            (guestDetail.CompanyProfileCountryName &&
              (guestDetail.CompanyProfileCountryName.toUpperCase() ==
                "UNITED STATES" ||
                guestDetail.CompanyProfileCountryName.toUpperCase() == "US" ||
                guestDetail.CompanyProfileCountryName.toUpperCase() ==
                  "USA")) ||
            !guestDetail.CompanyProfileCountryName
          ) {
            if (guestDetail.CompanyProfileCity) {
              displayAddress.push(guestDetail.CompanyProfileCity);
            }
            if (guestDetail.CompanyProfileState) {
              displayAddress.push(guestDetail.CompanyProfileState);
            }
            if (
              !guestDetail.CompanyProfileCity &&
              !guestDetail.CompanyProfileState
            ) {
              if (guestDetail.CompanyProfileCountryName) {
                displayAddress.push(guestDetail.CompanyProfileCountryName);
              }
            }
          }
        }
      }
      console.log("displayAddress.join(", ") = ", displayAddress.join(", "));
      return displayAddress.join(", ");
    },
    checkBalanceColor(balance) {
      let formatBalance = Number(balance.replace(/,/g, ""));
      console.log("typeof ===== >", formatBalance);
      if (formatBalance < 0) {
        return "negativeBalance";
      } else if (formatBalance == 0) {
        return "zeroBalance";
      } else if (formatBalance > 0) {
        return "positiveBalance";
      } else {
        return "fail nuber";
      }
    },
    setValue(value) {
      let vm = this;
      vm.DetailedOrConsolidated = value;
    },
    firstname(value) {
      let vm = this;
      console.log("here1 checkit", value.which);
      // if ((vm.guestInfo.ReservationId == -1 || vm.guestInfo.ReservationId == "") && value) {
      console.log("here2values", value);
      // clearTimeout(vm.timeout);
      // vm.timeout = setTimeout(function () {

      if (
        ((value.which <= 90 && value.which >= 48) ||
          value.which == 8 ||
          value.which == 46 ||
          value.which == 96 ||
          value.which == 97 ||
          value.which == 98 ||
          value.which == 99 ||
          value.which == 100 ||
          value.which == 101 ||
          value.which == 102 ||
          value.which == 103 ||
          value.which == 104 ||
          value.which == 105) &&
        !value.ctrlKey &&
        value.code != "MetaLeft"
      ) {
        if (
          (((vm.guestInfo.ReservationId == -1 ||
            vm.guestInfo.ReservationId == "") &&
            vm.ShowCompanyData == "Guest") ||
            (!vm.guestInfo.CompanyProfileId &&
              vm.ShowCompanyData != "Guest" &&
              (vm.$route.params.ReservationId == "-1" ||
                vm.guestInfo.ReservationId))) &&
          value &&
          value.key != "Tab"
        ) {
          console.log("searching:", value);
          vm.GetGuestProfile_BySearchText();
        }
      }

      // }, 3000);
      // }
    },
    formatArrivalDate(date) {
      let vm = this;
      return moment(date).format("DD-MMM-YYYY");
    },
    formatInvoiceUtcDate(date) {
      let vm = this;
      return moment.utc(date).format("DD MMM YYYY");
    },
    formatInvoiceUtcDateRange(date1,date2){

      date1 = moment(date1);
      date2 = moment(date2);
      
      const year1 = date1.format('YYYY'); // Since both dates are in the same year, we can use the year from any date
      const year2 = date2.format('YYYY');
      // Combine the formatted strings
      if(year1 == year2){
        let year = date1.format('YYYY')
        // const formattedDate1 = date1.format('DD MMM');
        // const formattedDate2 = date2.format('DD MMM');
        const formattedDate1 = moment.utc(date1).format("DD MMM");
        const formattedDate2 = moment.utc(date2).format("DD MMM");
        return `${formattedDate1} to ${formattedDate2} ${year}`
      }else{
        const formattedDate1 = date1.format('DD MMM YYYY');
        const formattedDate2 = date2.format('DD MMM YYYY');
        return `${formattedDate1} - ${formattedDate2}`
      }
    },
    formatCancelledDate(date) {
      let vm = this;
      if (date) {
        return moment(date).format("DD MMM YYYY");
      }
    },
    removeGuestProfileSummary() {
      let vm = this;
      if (vm.isBgColor1) {
        vm.displaySectionValue = "reservation1";
        vm.showguestinfo = true;
      } else if (vm.isBgColor2) {
        vm.displaySectionValue = "reservation2";
      } else if (vm.isBgColor3) {
        vm.showPaymentOptions = false;
        vm.displaySectionValue = "reservation3";
      } else if (vm.isBgColor4) {
        vm.displaySectionValue = "reservation4";
      } else if (vm.isBgColor5) {
        vm.displaySectionValue = "reservation3";
        vm.showPaymentOptions = true;
      } else {
        vm.displaySectionValue = "reservation1";
        vm.showguestinfo = true;
        vm.isBgColor1 = true;
      }
      vm.showGuestProfileDetail = false;
      // vm.displaySectionValue = vm.previousSelectedSectio;
    },
    ShowGuestProfileDetailClick(event, profileId, accountType) {
      let vm = this;
      vm.guestProfileDetails = {};
      vm.showMessages = false;
      vm.showEditDetails = false;
      vm.showGuestProfileDetail = false;
      // vm.$store.dispatch("dataRequestHandler", {
      //   key: "Get_GuestProfile_Detail",
      //   params: {
      //     ModuleAction: "Get_GuestProfile_Detail",
      //     GuestProfileId: vm.guestInfo.GuestProfileId

      //   },
      //   callback: function (err, response) {
      //     if (err) {
      //       return;
      //     }
      //     if (response) {
      //       console.log("response Get_GuestProfile_Detail", response);
      //       console.log(vm.guestInfo)
      //       vm.guestProfileDetails = response[0][0];
      //       vm.guestTagsList = response[2];
      //       vm.guestPriorStays = response[3];
      //       vm.guestAdditionalEmail = response[5];
      //       vm.guestAdditionalPhone = response[6];
      //       vm.guestProfilePaymentDetails = response[1];
      // setTimeout(function () {

      // vm.loading = true;
      vm.previousSelectedSectio = vm.displaySectionValue;
      vm.showguestinfo = false;
      vm.showBookedBy = false;
      vm.displaySectionValue = "";
      vm.showGuestProfileData = accountType === "guest" ? true : false;
      vm.Color = null;
      vm.showPaymentOptions = false;
      vm.showCompanyProfileData = accountType === "company" ? true : false;
      vm.$store.dispatch("dataRequestHandler", {
        key: "Get_GuestProfile_Detail",
        params: {
          ModuleAction: "Get_GuestProfile_Detail",
          GuestProfileId: profileId,
        },
        callback: function (err, response) {
          if (err) {
            return;
          }
          if (response) {
            console.log(
              "response Get_GuestProfile_Detail",
              response,
              vm.guestInfo.DefaultSettingforCompanyprofile
            );
            console.log(vm.guestInfo);
            // vm.loading = false;
            vm.guestProfileDetails = response[0][0];
            vm.guestTagsList = response[2];
            vm.guestPriorStays = response[3];
            vm.guestAdditionalEmail = response[5];
            vm.guestAdditionalPhone = response[6];
            vm.guestProfilePaymentDetails = response[1];
            vm.guestBookings = response[4][0];
            setTimeout(function () {
              vm.showGuestProfileDetail = true;
            }, 10);
          }
        },
      });

      // vm.Get_GuestProfile_Detail(profileId, "iconClick")
      event.stopPropagation();
      // }, 20);
      // vm.loading = false;

      //     }
      //   }
      // })
    },

    Get_GuestProfile_Detail(guestProfileId, fromCall) {
      let vm = this;
      console.log("Get_GuestProfile_Detail here", guestProfileId);
      vm.$store.dispatch("dataRequestHandler", {
        key: "Get_GuestProfile_Detail",
        params: {
          ModuleAction: "Get_GuestProfile_Detail",
          GuestProfileId: guestProfileId
            ? guestProfileId
            : vm.guestInfo.GuestProfileId,
        },
        callback: function (err, response) {
          if (err) {
            return;
          }
          if (response) {
            console.log(
              "response Get_GuestProfile_Detail",
              response,
              vm.guestInfo
            );
            console.log(vm.guestInfo);

            if (guestProfileId && fromCall != "iconClick") {
              const oldObject = response[0][0];
              let noReservationId = Object.assign({}, oldObject, {
                ReservationId: vm.guestInfo.ReservationId,
                GuestProfileId:
                  vm.guestInfo.GuestProfileId == -1
                    ? response[4] && response[4][0].GuestProfileId
                    : vm.guestInfo.GuestProfileId,
                    // account issue fix next 5 line
                CompanyProfileId: oldObject.AccountType == 7 ? oldObject.GuestProfileId : vm.guestInfo.CompanyProfileId,
                CompanyProfileName: oldObject.AccountType == 7 ? oldObject.CompanyProfileName :vm.guestInfo.CompanyProfileName,
                CompanyProfileState: oldObject.AccountType == 7 ? oldObject.CompanyProfileState :vm.guestInfo.CompanyProfileState,
                CompanyProfileCity: oldObject.AccountType == 7 ? oldObject.CompanyProfileCity :vm.guestInfo.CompanyProfileCity,
                CompanyProfileCountryName:
                oldObject.AccountType == 7 ? oldObject.CompanyProfileCountryName : vm.guestInfo.CompanyProfileCountryName,
                SourceId: vm.guestInfo.SourceId,
                SourceName: vm.guestInfo.SourceName,
                SubSourceName: vm.guestInfo.SubSourceName,
                SubsourceId: vm.guestInfo.SubsourceId,
                TempoConfirmationNumber: vm.guestInfo.TempoConfirmationNumber,
                ClientCode: vm.guestInfo.ClientCode,
                ClientEmail: vm.guestInfo.ClientEmail,
                ClientEmailPassword: vm.guestInfo.ClientEmailPassword,
                ConfirmationNumber: vm.guestInfo.ConfirmationNumber,
                CrsConfirmationNumber: vm.guestInfo.CrsConfirmationNumber,
                CrsId: vm.guestInfo.CrsId,
                CrsName: vm.guestInfo.CrsName,
                Ext_ConfirmationNumber: vm.guestInfo.Ext_ConfirmationNumber,
                IsHostMode: vm.guestInfo.IsHostMode,
                LastminuteBooking: vm.guestInfo.LastminuteBooking,
                Promocode: vm.guestInfo.Promocode,
                PropertyAddress: vm.guestInfo.PropertyAddress,
                PropertyOwnerName: vm.guestInfo.PropertyOwnerName,
                RatePlanId: vm.guestInfo.RatePlanId,
                RateplanName: vm.guestInfo.RateplanName,
                ReservationNumber: vm.guestInfo.ReservationNumber,
                SubSourceConfirmationNumber:
                  vm.guestInfo.SubSourceConfirmationNumber,
                emailservice: vm.guestInfo.emailservice,
                sendemail: vm.guestInfo.sendemail,
                DefaultSettingforGuestprofile:
                  vm.guestInfo.DefaultSettingforGuestprofile,
                DefaultSettingforCompanyprofile:
                  vm.guestInfo.DefaultSettingforCompanyprofile,
              });
              // noFoo is { foo: undefined, baz: 42 }
              // this call is also equivalent to this
              noReservationId = {
                ...oldObject,
                ReservationId: vm.guestInfo.ReservationId,
                GuestProfileId:
                  vm.guestInfo.GuestProfileId == -1
                    ? response[4] && response[4][0].GuestProfileId
                    : vm.guestInfo.GuestProfileId,
                CompanyProfileId: oldObject.AccountType == 7 ? oldObject.GuestProfileId : vm.guestInfo.CompanyProfileId,
                CompanyProfileName: oldObject.AccountType == 7 ? oldObject.CompanyProfileName :vm.guestInfo.CompanyProfileName,
                CompanyProfileState: oldObject.AccountType == 7 ? oldObject.CompanyProfileState :vm.guestInfo.CompanyProfileState,
                CompanyProfileCity: oldObject.AccountType == 7 ? oldObject.CompanyProfileCity :vm.guestInfo.CompanyProfileCity,
                CompanyProfileCountryName:
                oldObject.AccountType == 7 ? oldObject.CompanyProfileCountryName : vm.guestInfo.CompanyProfileCountryName,
                SourceId: vm.guestInfo.SourceId,
                SourceName: vm.guestInfo.SourceName,
                SubSourceName: vm.guestInfo.SubSourceName,
                SubsourceId: vm.guestInfo.SubsourceId,
                TempoConfirmationNumber: vm.guestInfo.TempoConfirmationNumber,
                ClientCode: vm.guestInfo.ClientCode,
                ClientEmail: vm.guestInfo.ClientEmail,
                ClientEmailPassword: vm.guestInfo.ClientEmailPassword,
                ConfirmationNumber: vm.guestInfo.ConfirmationNumber,
                CrsConfirmationNumber: vm.guestInfo.CrsConfirmationNumber,
                CrsId: vm.guestInfo.CrsId,
                CrsName: vm.guestInfo.CrsName,
                Ext_ConfirmationNumber: vm.guestInfo.Ext_ConfirmationNumber,
                IsHostMode: vm.guestInfo.IsHostMode,
                LastminuteBooking: vm.guestInfo.LastminuteBooking,
                Promocode: vm.guestInfo.Promocode,
                PropertyAddress: vm.guestInfo.PropertyAddress,
                PropertyOwnerName: vm.guestInfo.PropertyOwnerName,
                RatePlanId: vm.guestInfo.RatePlanId,
                RateplanName: vm.guestInfo.RateplanName,
                ReservationNumber: vm.guestInfo.ReservationNumber,
                SubSourceConfirmationNumber:
                  vm.guestInfo.SubSourceConfirmationNumber,
                emailservice: vm.guestInfo.emailservice,
                sendemail: vm.guestInfo.sendemail,
                DefaultSettingforGuestprofile:
                  vm.guestInfo.DefaultSettingforGuestprofile,
                DefaultSettingforCompanyprofile:
                  vm.guestInfo.DefaultSettingforCompanyprofile,
              };
              console.log("noReservationId", noReservationId);
              if (response[0][0] && response[0][0].AccountType == 3) {
                vm.guestInfo = noReservationId;
                if (vm.guestInfo.hasOwnProperty("AddressDetails2")) {
                  vm.guestInfo.AddressDetails2 = vm.guestInfo.Address2;
                } else {
                  vm.$set(
                    vm.guestInfo,
                    "AddressDetails2",
                    vm.guestInfo.Address2
                  );
                }

                // console.log("Get_GuestProfile_Detail---",vm.guestInfo);
                vm.guestInfo.IsGuestProfilelinked = true;
                vm.CreateGuestProfile = false;
                if (response[5] && response[5][0]) {
                  vm.additionalEmails = [];
                  for (var i = 0; i < response[5].length; i++) {
                    vm.additionalEmails.push({
                      ReservationId: "",
                      Emailaddress:
                        response[5] &&
                        response[5][i] &&
                        response[5][i].Emailaddress
                          ? response[5][i].Emailaddress
                          : "",
                    });
                  }
                }
                if (response[6] && response[6][0]) {
                  vm.additionalPhoneNumbers = [];
                  for (var i = 0; i < response[6].length; i++) {
                    vm.additionalPhoneNumbers.push({
                      ReservationId: "",
                      PhoneNumber:
                        response[6] &&
                        response[6][i] &&
                        response[6][i].PhoneNumber
                          ? response[6][i].PhoneNumber
                          : "",
                    });
                  }
                }
                // vm.displaySectionValue = "reservation1";
                vm.showguestinfo = true;
              } else if (response[0][0] && response[0][0].AccountType == 7) {
                vm.companyInfo = noReservationId;
                vm.guestInfo.CompanyProfileId = vm.$route.params.guestProfileId && vm.$route.params.accountType && vm.$route.params.accountType == 7
                  ? vm.$route.params.guestProfileId
                  : response[4][0].GuestProfileId;
                vm.companyAdditionalEmail = response[5];
                vm.companyAdditionalPhone = response[6];
                vm.companyProfilePaymentDetails = response[1];
                vm.CreateCompanyProfile = false;
                vm.guestTagsList = response[2];
                vm.guestPriorStays = response[3];
                console.log("companyInfo----", vm.companyInfo);
                vm.loading = false;
                vm.guestBookings = response[4][0];
                if (response[5] && response[5][0]) {
                  vm.additionalCompanyEmails = [];
                  for (var i = 0; i < response[5].length; i++) {
                    vm.additionalCompanyEmails.push({
                      ReservationId: "",
                      Emailaddress:
                        response[5] &&
                        response[5][i] &&
                        response[5][i].Emailaddress
                          ? response[5][i].Emailaddress
                          : "",
                    });
                  }
                }
                if (response[6] && response[6][0]) {
                  vm.additionalCompanyPhoneNumbers = [];
                  for (var i = 0; i < response[6].length; i++) {
                    vm.additionalCompanyPhoneNumbers.push({
                      ReservationId: "",
                      PhoneNumber:
                        response[6] &&
                        response[6][i] &&
                        response[6][i].PhoneNumber
                          ? response[6][i].PhoneNumber
                          : "",
                    });
                  }
                }
                // vm.displaySectionValue = "companyProfile";
                vm.ShowCompanyData = "company";
              }
              // vm.showGuestInfoButton = false;
              // vm.displayGuestInfo = 'guestInfo'
            }
            if (fromCall == "redirectfromaccount") {
              vm.displaySectionValue = "reservation1";
              vm.ShowCompanyData = "Guest";
              vm.showguestinfo = true;
            }
            vm.guestProfileDetails = response[0][0];
            vm.guestTagsList = response[2];
            vm.guestPriorStays = response[3];
            vm.guestAdditionalEmail = response[5];
            vm.guestAdditionalPhone = response[6];
            vm.guestProfilePaymentDetails = response[1];
            vm.loading = false;
            vm.guestBookings = response[4][0];
          }
        },
      });
    },
    redirectToGuestProfileDetail(
      guestProfileId,
      companyProfileId,
      accountType,
      selectedProfileId
    ) {
      let vm = this;
      // let profileId = accountType == 3 ? guestProfileId : companyProfileId;
      if (guestProfileId == companyProfileId) {
        vm.selectedProfileId = selectedProfileId;
      } else {
        vm.selectedProfileId = accountType === 3 ? guestProfileId : companyProfileId;
      }
      if (accountType == 3) {
        vm.$router.push("/guestProfileDetail/" + vm.selectedProfileId);
      } else if (accountType == 7) {
        vm.$router.push("/companyProfileDetail/" + vm.selectedProfileId);
      }
    },
    GetGuestProfile_BySearchText(from) {
      let vm = this;
      console.log("from", from);
      if (from == "fromSearch") {
        vm.dontOpenPannel = false;
      }
      // if(vm.slectedClosedprofiletype != vm.ShowCompanyData && vm.dontOpenPannel){
      //   vm.dontOpenPannel = false
      // }
      vm.pannelOpened = true;
      vm.triggerevent = true;

      if (
        (vm.dontOpenPannel == false && vm.ShowCompanyData == "Guest") ||
        (vm.dontOpenCompanyPannel == false && vm.ShowCompanyData == "company")
      ) {
        console.log(
          "searcheddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddd"
        );
        console.log("searchhhhhhhhhhhh", vm.guestInfo.GuestFirstName);
        let guestfirstnamelist = [],
          guestLastNameList = [],
          searchName = "";
        if (vm.ShowCompanyData == "company") {
          searchName = vm.companyInfo.GuestFirstName;
        } else {
          searchName = vm.guestInfo.GuestFirstName;
        }
        if (searchName) {
          guestfirstnamelist = searchName.match(/\S+/g);
          guestfirstnamelist = guestfirstnamelist.map((i) => i + "*");
          console.log("guestfirstnamelist = ", guestfirstnamelist);
        } else {
          guestfirstnamelist = [];
        }
        if (vm.guestInfo.GuestLastName && vm.ShowCompanyData != "company") {
          guestLastNameList = vm.guestInfo.GuestLastName.match(/\S+/g);
          guestLastNameList = guestLastNameList.map((i) => i + "*");
          console.log("guestlastnamelist = ", guestLastNameList);
        } else {
          guestLastNameList = [];
        }
        vm.currSearchObj = {
          GuestFirstName:
            guestfirstnamelist.length > 0 ? guestfirstnamelist.join(",") : null,
          GuestLastName:
            guestLastNameList.length > 0 ? guestLastNameList.join(",") : null,
          Email:
            vm.ShowCompanyData == "Guest"
              ? vm.additionalEmails[0].Emailaddress
              : vm.additionalCompanyEmails[0].Emailaddress,
          PhoneNumber:
            vm.ShowCompanyData == "Guest"
              ? vm.additionalPhoneNumbers[0].PhoneNumber
              : vm.additionalCompanyPhoneNumbers[0].PhoneNumber,
          Address:
            vm.ShowCompanyData == "Guest"
              ? vm.guestInfo.Address
                ? vm.guestInfo.Address
                : null
              : vm.companyInfo.Address
              ? vm.companyInfo.Address
              : null,
          Address2:
            vm.ShowCompanyData == "Guest"
              ? vm.guestInfo.AddressDetails2
                ? vm.guestInfo.AddressDetails2
                : null
              : vm.companyInfo.AddressDetails2
              ? vm.companyInfo.AddressDetails2
              : null,
          CityName:
            vm.ShowCompanyData == "Guest"
              ? vm.guestInfo.CityName
                ? vm.guestInfo.CityName
                : null
              : vm.companyInfo.CityName
              ? vm.companyInfo.CityName
              : null,
          StateName:
            vm.ShowCompanyData == "Guest"
              ? vm.guestInfo.StateName
                ? vm.guestInfo.StateName
                : null
              : vm.companyInfo.StateName
              ? vm.companyInfo.StateName
              : null,
          CountryName:
            vm.ShowCompanyData == "Guest"
              ? vm.guestInfo.CountryName
                ? vm.guestInfo.CountryName
                : null
              : vm.companyInfo.CountryName
              ? vm.companyInfo.CountryName
              : null,
          PostalCode:
            vm.ShowCompanyData == "Guest"
              ? vm.guestInfo.PostalCode
                ? vm.guestInfo.PostalCode
                : null
              : vm.companyInfo.PostalCode
              ? vm.companyInfo.PostalCode
              : null,
          profileType: vm.ShowCompanyData == "company" ? 7 : 3,
        };
      }

      // vm.$store.dispatch("dataRequestHandler", {
      //   key: "GetGuestProfile_BySearchText",
      //   params: {
      //     SearchText: vm.guestInfo.GuestFirstName
      //   },
      //   callback: function (err, response) {
      //     if (err) {
      //       console.log("Error in GetGuestProfile_BySearchText => ", err);
      //       return;
      //     }
      //     if (response) {
      //       console.log("response in GetGuestProfile_BySearchText => ", response);
      //     }
      //   }
      // });
    },
    propagation(event) {
      event.stopPropagation();
    },
    selectAllFolioItems(e) {
      let vm = this;
      if (e.target.checked) {
        vm.folioItemsToVoid.splice(0);
        vm.checkedItems.splice(0);
        for (let folioItem of vm.folioItemsDetails) {
          if (!folioItem.IsVoided) {
            folioItem.Ischecked = true;
            vm.folioItemsToVoid.push(folioItem.ItemId);
            vm.checkedItems.push(folioItem);
          }
        }
        vm.selectedVoidItem = true;
        vm.selectedItemCount = false;
      } else {
        for (let folioItem of vm.folioItemsDetails) {
          folioItem.Ischecked = false;
        }
        vm.checkedItems.splice(0);
        vm.folioItemsToVoid.splice(0);
        vm.itemToEdit = null;
        vm.selectedVoidItem = false;
        vm.selectedItemCount = true;
      }
    },
    changeSplitReservations() {
      let vm = this;
      if (vm.searchByUnit) {
        vm.splitReservations = false;
      }
    },
    selectFolioitem(e, item) {
      let vm = this;
      // e.stopPropagation();
      if (e.target.checked) {
        item.Ischecked = true;
      } else {
        item.Ischecked = false;
      }
      let selectedFolioItems = vm.folioItemsDetails.filter((folioitem) => {
        return folioitem.Ischecked;
      });
      let voidFolioItemIds = selectedFolioItems.map((item) => {
        return item.ItemId;
      });
      vm.folioItemsToVoid.splice(
        0,
        vm.folioItemsToVoid.length,
        ...voidFolioItemIds
      );
      if (selectedFolioItems.length == 1) {
        vm.selectedVoidItem = true;
        vm.selectedItemCount = true;
      } else if (selectedFolioItems.length > 1) {
        vm.selectedItemCount = false;
        vm.selectedVoidItem = true;
        // vm.itemToEdit = null
      } else {
        vm.selectedVoidItem = false;
        vm.selectedItemCount = true;
        // vm.itemToEdit = null
      }
      if (item.Ischecked == true) {
        vm.checkedItems.push(item);
      } else if (item.Ischecked == false) {
        var index = vm.checkedItems.indexOf(item);
        if (index > -1) {
          vm.checkedItems.splice(index, 1);
        }
      }

      if (vm.checkedItems.length == 1) {
        vm.itemToEdit = vm.checkedItems[0];
      } else {
        vm.itemToEdit = null;
      }
    },
    scrollDown(length) {
      console.log("lengthlength", $(".dTBodyRow.newFolio").length);
      console.log("lengthlength", $(".dTBodyRow.updatedFolio").length);
      // if(($('.dTBodyRow.newFolio').length + $('.dTBodyRow.updatedFolio').length) < 3){
      //   $(".dTBody.folioBody").scrollTop((30))

      // }
      // else{
      $(".dTBody.folioBody").scrollTop(
        ($(".dTBodyRow.newFolio").length +
          $(".dTBodyRow.updatedFolio").length) *
          55
      );
      // }
    },
    scrollToCalender(index, length) {
      console.log("index", index, "+", length);
      let scrollTo = (index - 1) * 55;
      // if(index != 1 && index != 2 && index != 3 && index != 4 && (index != 5 && index <= length) && (index != 6 && index <= length)){
      $(".dTBody.folioBody").scrollTop(scrollTo);
      // }
    },
    myRatePlanSelectEvent(e) {
      // alert("hai");
      // let ratePlanValue = this.actualMyValue && this.actualMyValue[0] ? this.actualMyValue[0].id : null
      // if (newValue && oldValue && newValue != ratePlanValue) {
      console.log("mySelectEvent == > ", e);
      // let ratePlanValue = this.RatePlanList.filter(obj => obj.text == e.text);
      // this.myValue = ratePlanValue[0].id;
      // let RatePlanId = this.RatePlanList.filter(obj => obj.id == this.myValue);
      this.ratePlanId = e ? e.RatePlanId : null;
      this.ratePlanResMinStay = e ? e.MinStay : null;
      this.Promocode = e ? e.PromoCodes : null;
      this.guestInfo.RateplanName = e ? e.RatePlan_DisplayName : null;
      this.guestInfo.Promocode = this.Promocode;
      this.showRatePlanSave = true;
      this.selectedFolioItemToEdit = true;
      this.ShowDropdown = true;
      this.GetFolioLedgerTransDetails_beforesave();
      // }
    },
    onChangeRatePlan() {
      let vm = this;
      // let RatePlanId = vm.RatePlanList.filter(obj => obj.id == vm.myValue);
      // vm.ratePlanId = RatePlanId && RatePlanId[0] ? RatePlanId[0].RatePlanId : null;
      // vm.Promocode = RatePlanId && RatePlanId[0] ? RatePlanId[0].PromoCodes : null;
      // vm.guestInfo.RateplanName = RatePlanId && RatePlanId[0] ? RatePlanId[0].RatePlan_DisplayName : null;
      // vm.guestInfo.Promocode = vm.Promocode;
      // vm.GetFolioLedgerTransDetails_beforesave()
      vm.isModalVisible = true;
      vm.modalParams = {
        popupTitle: "Folio has to be re-calculated",
        popupMessage: "Do you want to re-calculate Folio ?",
        displayYesNoButtons: true,
        yesButtontext: "Yes",
        noButtonText: "No",
        yesButtonCallback: vm.ratePlanFolioRecalculateYesCallback,
        noButtonCallback: vm.ratePlanFolioRecalculateNoCallback,
        cancelbuttonCallback: vm.resetRateplanSave,
        isFrom: "resFolio",
      };
    },
    resetRateplanSave() {
      let vm = this;
      // setTimeout(function () {
      vm.cancelRatePlanEdit();
      // }, 300)
    },
    // GetFolioLedgerTransDetails_beforesave
    ratePlanFolioRecalculateYesCallback() {
      let vm = this;
      vm.isModalVisible = false;
      // if (vm.roomInfo.Nights < vm.ratePlanResMinStay) {
      //   vm.$store.dispatch("toastr", {
      //     type: "warning",
      //     header: "Warning!",
      //     message: "Check the dates rateplan has a restriction"
      //   });
      //   vm.cancelRatePlanEdit();
      //   return
      // }
      vm.getLogIdsByEventID(2, 9);
      vm.save_Notification(2, 9, vm.notificationAmount);
      vm.Folio_RatePlanEdit(true);
    },
    ratePlanFolioRecalculateNoCallback() {
      let vm = this;
      vm.isModalVisible = false;
      // vm.honourFolio = false;
      // if (vm.roomInfo.Nights < vm.ratePlanResMinStay) {
      //   vm.$store.dispatch("toastr", {
      //     type: "warning",
      //     header: "Warning!",
      //     message: "Check the dates rateplan has a restriction"
      //   });
      //   vm.cancelRatePlanEdit();
      //   return
      // }
      // vm.GetFolioLedgerTransDetails_beforesave();
      vm.Folio_RatePlanEdit(false);
    },
    Folio_RatePlanEdit(recalculateFolio) {
      let vm = this;
      vm.showRatePlanSave = false;
      vm.selectedFolioItemToEdit = false;
      vm.ShowDropdown = false;
      vm.$store.dispatch("dataRequestHandler", {
        key: "Folio_RatePlanEdit",
        params: {
          ReservationId: vm.guestInfo.ReservationId,
          RatePlanId: vm.ratePlanId,
          RecalculateFolio: recalculateFolio,
          Promocode: vm.Promocode,
          UnitId: vm.roomInfo.UnitId,
        },
        callback: function (err, response) {
          if (err) {
            console.log("Error in Folio_RatePlanEdit => ", err);
            return;
          }
          if (response) {
            console.log("response in Folio_RatePlanEdit => ", response[0]);
            vm.$store.dispatch("toastr", {
              type: "success",
              header: "Success",
              message: "Updated rateplan successfully",
            });
            vm.actualMyValue = vm.RatePlanList.filter(
              (obj) =>
                obj.RatePlan_DisplayName == vm.guestInfo.RateplanName &&
                obj.PromoCodes == vm.guestInfo.Promocode
            );
            vm.guestInfo.RatePlanId =
              vm.actualMyValue && vm.actualMyValue[0]
                ? vm.actualMyValue[0].RatePlanId
                : null;
            vm.getFolioSummary(false);
          }
        },
      });
    },
    disableAddOrUpdate(paymentProcessId) {
      let vm = this;
      if (paymentProcessId == 6 || paymentProcessId == 8) {
        if (
          vm.fncIsPaymentUpdate &&
          vm.fncIsPaymentUpdate.isAssigned === -1 &&
          vm.fncIsPaymentUpdate.functionState === 2
        ) {
          return false;
        } else {
          return true;
        }
      } else if (paymentProcessId == 2) {
        if (
          vm.fncIsPaymentAdd &&
          vm.fncIsPaymentAdd.isAssigned === -1 &&
          vm.fncIsPaymentAdd.functionState === 2
        ) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    addOrUpdate(paymentProcessId) {
      let vm = this;
      if (paymentProcessId == 6 || paymentProcessId == 8) {
        if (
          vm.fncIsPaymentUpdate &&
          (vm.fncIsPaymentUpdate.isAssigned === 1 ||
            (vm.fncIsPaymentUpdate.isAssigned === -1 &&
              vm.fncIsPaymentUpdate.functionState === 2))
        ) {
          return true;
        } else {
          return false;
        }
      } else if (paymentProcessId == 2) {
        if (
          vm.fncIsPaymentAdd &&
          (vm.fncIsPaymentAdd.isAssigned === 1 ||
            (vm.fncIsPaymentAdd.isAssigned === -1 &&
              vm.fncIsPaymentAdd.functionState === 2))
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    // ChangeIt(){
    //   console.log("input changeddddddddddddddddddddddddddddddddddddddd")
    // },
    resetAddress() {
      let vm = this;
      // console.log("heeeeeeeeeeeeeeeeeeeeeeeeeeeeee")
      // vm.$set(vm.guestInfo, "Address", "");
      // vm.guestInfo.Address = "";
      // vm.$set(vm.guestInfo, "shortAddress", "");
      // if(vm.CreateGuestProfile){
      //   vm.$set(vm.guestInfo, "PostalCode", "");
      // vm.$set(vm.guestInfo, 'CityName', "");
      // vm.$set(vm.guestInfo, 'StateName', "");
      // vm.$set(vm.guestInfo, 'CountryName', "");

      // }
    },
    // getAddress(address) {
    //   let vm = this;
    //   console.log("splitdataAddress==>", address);
    //   vm.guestInfo.Address = address;
    //   // vm.$set( vm.guestInfo,'Address', address);
    //   // var add = address.split(",");
    //   // vm.guestInfo.Address = add[0];
    //   // vm.$set( vm.guestInfo,'Address', add[0]);
    //   // console.log("vm.guestInfo.Address", vm.guestInfo.Address);
    // },
    getAddressData: function (addressData, placeResultData, id) {
      let vm = this;
      console.log("addressData", addressData);
      if (vm.ShowCompanyData == "Guest") {
        if (addressData && addressData.street_number && addressData.route) {
          this.guestInfo.Address =
            addressData.street_number + " " + addressData.route;
        } else {
          this.guestInfo.Address = addressData.route;
        }
        if (addressData && addressData.locality) {
          this.$set(this.guestInfo, "CityName", addressData.locality);
        } else if (addressData && addressData.administrative_area_level_2) {
          this.$set(
            this.guestInfo,
            "CityName",
            addressData.administrative_area_level_2
          );
        } else {
          this.$set(this.guestInfo, "CityName", "");
        }
        this.$set(this.guestInfo, "PostalCode", addressData.postal_code);
        this.$set(
          this.guestInfo,
          "StateName",
          addressData.administrative_area_level_1
        );
        this.$set(this.guestInfo, "CountryName", addressData.country);
        this.$set(this.guestInfo, "shortAddress", this.guestInfo.Address);
        console.log("this.guestInfo.PostalCode", this.guestInfo.PostalCode);
      } else {
        if (addressData && addressData.street_number && addressData.route) {
          this.companyInfo.Address =
            addressData.street_number + " " + addressData.route;
        } else {
          this.companyInfo.Address = addressData.route;
        }
        if (addressData && addressData.locality) {
          this.$set(this.companyInfo, "CityName", addressData.locality);
        } else if (addressData && addressData.administrative_area_level_2) {
          this.$set(
            this.companyInfo,
            "CityName",
            addressData.administrative_area_level_2
          );
        } else {
          this.$set(this.companyInfo, "CityName", "");
        }
        this.$set(this.companyInfo, "PostalCode", addressData.postal_code);
        this.$set(
          this.companyInfo,
          "StateName",
          addressData.administrative_area_level_1
        );
        this.$set(this.companyInfo, "CountryName", addressData.country);
        this.$set(this.companyInfo, "shortAddress", this.companyInfo.Address);
        console.log("this.companyInfo.PostalCode", this.companyInfo.PostalCode);
      }
      // if ((vm.guestInfo.ReservationId == -1 || vm.guestInfo.ReservationId == "")) {
      // console.log("here2values", value);
      clearTimeout(vm.timeout);
      vm.timeout = setTimeout(function () {
        // console.log('searching:', value);
        if (
          vm.guestInfo.ReservationId == -1 ||
          vm.guestInfo.ReservationId == ""
        ) {
          vm.GetGuestProfile_BySearchText();
        }
      }, 3000);
      // }
      // this.PostalCode = addressData.postal_code;
    },
    showAddressAndZipcode() {
      let vm = this;
      vm.addressAndZipcodeShow = !vm.addressAndZipcodeShow;
    },
    lastMessageObjectFunc(lastMessageObject) {
      let vm = this;
      vm.lastMessageObject = lastMessageObject;
    },
    AcceptorDecline(acceptorDeclineVal, event) {
      console.log("Airbnb",this.guestInfo.ReservationNumber);
      console.log("acceptdeclinevalue",acceptorDeclineVal)
      let vm = this;
      if (acceptorDeclineVal == 0 && vm.previousRoomInfo.Reservation_Status != "14") { 
        if(event) event.stopPropagation();
        const dataToPost = {
          externalReservationId: vm.lastMessageObject,
          ConfirmationNumber: vm.guestInfo.ReservationNumber,
          unitId: vm.roomInfo.UnitId,
          clientId: vm.RatePlanList[0].ClientId,
        };

        axios
          .post(`${this.apiUrl}/getAirbnbDeclineResons`, dataToPost)
          .then((response) => {
            console.log("Declined Reasons", response.data);
            vm.displaySectionValue = "declineRequestReservation";
            vm.showdeclineRequestReservation = true;
            vm.showMessages = false;
            vm.declineReasonsList.splice(0,vm.declineReasonsList.length,...response.data)
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
          });

        // vm.displaySectionValue = "declineRequestReservation";
        // vm.showdeclineRequestReservation = true
        // // event.stopPropagation();
        // vm.declineReasonsList=[{ reason: 'dates_not_available' }, { reason: 'not_a_good_fit' }, { reason: 'waiting_for_better_reservation' }, { reason: 'not_comfortable' }]


        return;
      }


      // vm.$store.dispatch("toastr", {
      //   type: "warning",
      //   header: "Warning!",
      //   message: "Please wait for few seconds don't perfome any action",
      // });
      // alert(acceptorDeclineVal + ' = Accept/Decline')
      if(vm.Reservation_Status.StatusId == '14'){
              // vm.reservationStatusList.push({
              //   StatusId: 9,
              //   StatusName: "Deleted",
              // })
              vm.viewReservationDetailById({ReservationId:vm.roomInfo.OriginalReservationId})
      }
      vm.$store.dispatch("dataRequestHandler", {
        key: "AcceptorDecline",
        params: {
          lastMessageObject: vm.lastMessageObject,
          acceptorDeclineVal: acceptorDeclineVal,
          unitId: vm.roomInfo.UnitId,
          previousResStatusId: vm.Reservation_Status.StatusId,
          extAlterationId:vm.roomInfo.AlterationId?vm.roomInfo.AlterationId:null,
          propertyId:vm.roomInfo.PropertyId,
          alterationResId:vm.guestInfo?.ReservationId
        },
        callback: function (err, response) {
          if (err) {
            return;
          }
          if (response) {
            console.log("response",response)
            vm.showdeclineRequestReservation = false;
            vm.showMessages = true;
            vm.displaySectionValue = "showBookedBy";
            setTimeout(() => {
              vm.getReservationDetailById()
            }, 5000);
            if(acceptorDeclineVal){

              if(vm.previousRoomInfo.Reservation_Status == '14' || vm.previousRoomInfo.Reservation_Status == '9' ){
                vm.Reservation_Status = {
                StatusId: 9,
                StatusName: "Deleted",
              };
              }
              else{
                vm.Reservation_Status = {
                StatusId: 1,
                StatusName: "Reserved",
              };
              }
                //
              // vm.onChangeStatus(vm.Reservation_Status);

              if (vm.$route.params.ReservationId != -1) {
                vm.getFolioSummary(false, null);
                if (
                  (vm.previousRoomInfo.Reservation_Status == "4" ||
                    vm.previousRoomInfo.Reservation_Status == "10" ||
                    vm.previousRoomInfo.Reservation_Status == "11" ||
                    vm.previousRoomInfo.Reservation_Status == "12"  ) && 
                    vm.Reservation_Status.StatusId == "1"
                ) {
              //     // vm.roomInfo.reservationMode = 1;
                  vm.saveRoomInfo(1, "fromStatusChange");   
              //     setTimeout(function () {
              //       vm.get_JobDetails(deleteEvent);
              //       for (let event of NotificationEventID) {
              //         vm.save_Notification(
              //           event.notificationEventId,
              //           event.NotiSubEventId,
              //           vm.notificationAmount
              //         );
              //       }

              //       for (let event of EventID) {
              //         vm.getLogIdsByEventID(event.eventId, event.subEventId);
              //       }
              //     }, 1000);
              //   } else {
              //     vm.getReservationDetailById();
              //     vm.get_JobDetails(deleteEvent);
              //     for (let event of NotificationEventID) {
              //       vm.save_Notification(
              //         event.notificationEventId,
              //         event.NotiSubEventId,
              //         vm.notificationAmount
              //       );
              //     }

              //     for (let event of EventID) {
              //       vm.getLogIdsByEventID(event.eventId, event.subEventId);
              //     }
                }
              }
            }
          }
        },
      });
    },
    cancelRequestDeclineAction(cancelRequestDeclineActionval) {
      let vm = this;
      vm.showdeclineRequestReservation = false;
      vm.showMessages = true;
      vm.displaySectionValue = "showBookedBy";
      // if (cancelRequestDeclineActionval) {
        // setTimeout(() => {
          vm.getReservationDetailById()
        // }, 5000);
        // vm.Reservation_Status = {cancelRequestDeclineActionVal
        //   StatusId: 11,
        //   StatusName: "No Show",
        // };
        // vm.onChangeStatus(vm.Reservation_Status);
      // }
    },
    sendQuote() {
      let vm = this;

      // vm.isVisible = true;
      // $('.modal-backdrop').css('display','block');
      // getBE_List

      let list = [];
      vm.$store.dispatch("dataRequestHandler", {
        key: "getBE_List",

        params: {
          IsActive: 1,
          UnitId: vm.roomInfo.UnitId
        },
        callback: function (err, response) {
          if (err) {
            console.log("Error in getBE_List => ", err);
            return;
          }
          if (response) {
            console.log("response in getBE_List => ", response[0]);
            console.log(
              "defaultSendQuoteTemplateHTML response in getBE_List => ",
              response[1]
            );

            vm.list = response[0];
            vm.defaultSendQuoteTemplateHTML = response[1];
            vm.modalParams = {
              popupTitle: "Select a Booking Engine to send Quote",
              popupMessage: "",
              displayYesNoButtons: false,
              sendQuoteButton: true,
              sendQuoteCallback: vm.sendQuoteCallbackFunc,
              listValues: vm.list,
            };
          }
        },
      });

      vm.isModalVisible = true;
    },
    sendQuoteCallbackFunc(BE_Id) {
      let vm = this;

      vm.isModalVisible = false;

      if (vm.defaultSendQuoteTemplateHTML.length == 0) {
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning!",
          message: "Please select templete at client level",
        });
        return;
      }

      vm.$store.dispatch("dataRequestHandler", {
        key: "sendQuote",
        params: {
          ReservationId: vm.guestInfo.ReservationId,
          BE_Id: BE_Id,
          protocol: window.location.protocol,
          defaultSendQuoteTemplateHTML: vm.defaultSendQuoteTemplateHTML[0],
        },
        callback: function (err, response) {
          if (err) {
            console.log("Error in sendQuote => ", err);
            vm.$store.dispatch("toastr", {
              type: "error",
              header: "Error!",
              message: "Error in sending send quote",
            });
            return;
          }
          if (response) {
            console.log("response in sendQuote => ", response);
            if (response == "sendEmailError") {
              vm.$store.dispatch("toastr", {
                type: "warning",
                header: "Warning!",
                message: "Please enable 'send email' to send quote",
              });
            } else {
              vm.$store.dispatch("toastr", {
                type: "success",
                header: "Success!",
                message: "Email Sent Successfully.",
              });
            }
          }
        },
      });
    },
    enableInlineEdit(payment) {
      let vm = this;
      if (payment.CardType != "Cash") {
        vm.editMode = true;
      } else {
        vm.editMode = false;
      }
    },
    selectPaymentMethod(paymentId) {
      let vm = this;
      if (
        paymentId == 7 ||
        paymentId == 8 ||
        paymentId == 9 ||
        paymentId == 10
      ) {
        // vm.showStripeElements = true;
        vm.stripe = Stripe("pk_test_DejIhmt6UlHrc2m01PhmXAWX");

        // Create an instance of Elements.
        var elements = vm.stripe.elements();
        // Custom styling can be passed to options when creating an Element.
        // (Note that this demo uses a wider set of styles than the guide below.)
        var style = {
          base: {
            color: "#32325d",
            fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
            fontSmoothing: "antialiased",
            fontSize: "16px",
            "::placeholder": {
              color: "#aab7c4",
            },
          },
          invalid: {
            color: "#fa755a",
            iconColor: "#fa755a",
          },
        };

        // Create an instance of the card Element.
        vm.card = elements.create("card", { style: style });

        // Add an instance of the card Element into the `card-element` <div>.
        // vm.card.mount("#card-element");
      } else {
        // vm.showStripeElements = false;
        vm.card.unmount("#card-element");
      }
    },
    getCardTokenBY() {
      let vm = this;
      console.log("vm.paymentCardInfo", vm.paymentCardInfo);
      let currentYear = moment().format("YYYY");
      let currentMonth = moment().format("MM");
      if (
        vm.paymentCardInfo.PaymentInfoId == -1 ||
        !vm.paymentCardInfo.CardToken
      ) {
        vm.generateCardToken();
      } else {
        vm.updateCardInfo();
      }
    },
    updateCardInfo() {
      let vm = this;
      if (vm.paymentCardInfo.ParentStatusId != 0) {
        let currentYear = moment().format("YYYY");
        let currentMonth = moment().format("MM");
        if (vm.stripeConnectedAccount == null) {
          vm.$store.dispatch("toastr", {
            type: "warning",
            header: "Warning!",
            message: "Please connect to stripe account",
          });
        } else if (
          Number(vm.paymentCardInfo.ExpirationMonth) < currentMonth &&
          Number(vm.paymentCardInfo.ExpirationYear) <= currentYear
        ) {
          vm.$store.dispatch("toastr", {
            type: "warning",
            header: "Warning!",
            message: "Please select valid expiry month/year",
          });
        } else {
          vm.disabledMultiSave = true;
          vm.$store.dispatch("dataRequestHandler", {
            key: "UpdateCardToken",
            params: {
              cardInfo: vm.paymentCardInfo,
              sk_token: vm.stripePlatformAccount.SecretKey,
              stripeConnectedAccount: vm.stripeConnectedAccount,
              guestInfo: vm.guestInfo,
            },
            callback: function (err, response) {
              if (err) {
                console.log("Error in UpdateCardToken ==========> ", err);
                vm.disabledMultiSave = false;
                return;
              }
              if (response) {
                vm.disabledMultiSave = false;
                console.log("getCardToken", response);
                if (response.message) {
                  console.log("getCardToken d=>", response.message.message);
                  vm.Save_ErrorLogs(response.message.message);

                  vm.$store.dispatch("toastr", {
                    type: "warning",
                    header: "Warning!",
                    message: "Error in updating card",
                  });
                } else {
                  let request = vm.paymentCardInfo;
                  request.ExpirationMonth = response.exp_month
                    ? moment()
                        .month(Math.abs(response.exp_month - 1))
                        .format("MM")
                    : response.token.exp_month;
                  request.ExpirationYear = response.exp_year;
                  request.CCLast4Digits = response.last4;
                  request.CardType = response.brand;
                  request.AddressDetails = response.address_line1;
                  request.PostalCode = response.address_zip;
                  request.CreditCard = null;
                  request.CvvCode = null;
                  vm.cardTokenFromStripe = response.customer;
                  vm.stripecardId = response.id;
                  vm.savePaymentCardInfo();
                  // if (vm.DefaultSettingforSyncCard == true) {
                  //   console.log("guest==================>", vm.DefaultSettingforSyncCard)
                  //   // vm.savePaymentCardInfoforGuest();
                  // }
                }
              }
            },
          });
        }
      } else {
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning!",
          message: "Unable to Save  Inactive card",
        });
      }
    },
    generateCardToken() {
      let vm = this;
      let currentYear = moment().format("YYYY");
      let currentMonth = moment().format("MM");
      if (vm.stripeConnectedAccount == null) {
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning!",
          message: "Please connect to an account",
        });
      } else if (
        !vm.paymentCardInfo.CreditCard ||
        vm.paymentCardInfo.CreditCard.length < 10
      ) {
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning!",
          message: "Please enter card number",
        });
      } else if (isNaN(vm.paymentCardInfo.CreditCard)) {
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning!",
          message: "Please enter valid card number",
        });
      } else if (vm.paymentCardInfo.ExpirationMonth == -1) {
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning!",
          message: "Please select expiry month",
        });
      } else if (vm.paymentCardInfo.ExpirationYear == -1) {
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning!",
          message: "Please select expiry year",
        });
      } else if (
        Number(vm.paymentCardInfo.ExpirationMonth) < currentMonth &&
        Number(vm.paymentCardInfo.ExpirationYear) <= currentYear
      ) {
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning!",
          message: "Please select valid expiry month/year",
        });
      }
      // else if (!vm.paymentCardInfo.CvvCode || vm.paymentCardInfo.CvvCode.length < 3 || vm.paymentCardInfo.CvvCode.length > 4) {
      //   vm.$store.dispatch("toastr", {
      //     type: "warning",
      //     header: "Warning!",
      //     message: "Please enter valid CVV"
      //   });
      // }
      else {
        vm.disabledMultiSave = true;
        vm.$store.dispatch("dataRequestHandler", {
          key: "getCardToken",
          params: {
            cardInfo: vm.paymentCardInfo,
            sk_token: vm.stripePlatformAccount.SecretKey,
            stripeConnectedAccount: vm.stripeConnectedAccount,
            guestInfo: vm.guestInfo,
            email:
              vm.additionalEmails.length > 0
                ? vm.additionalEmails[0].Emailaddress
                : "",
            phone:
              vm.additionalPhoneNumbers.length > 0
                ? vm.additionalPhoneNumbers[0].PhoneNumber
                : "",
          },
          callback: function (err, response) {
            if (err) {
              console.log("Error in getCardToken => ", err);
              vm.disabledMultiSave = false;
              return;
            }
            if (response) {
              vm.disabledMultiSave = false;
              console.log("getCardToken", response);
              if (response.message) {
                console.log("getCardToken@@", response.message);
                vm.Save_ErrorLogs(response.message);
                vm.$store.dispatch("toastr", {
                  type: "warning",
                  header: "Warning!",
                  message: "Error in tokenizing the card",
                });
              } else {
                let request = vm.paymentCardInfo;
                request.ExpirationMonth = response.token.card.exp_month
                  ? moment()
                      .month(Math.abs(response.token.card.exp_month - 1))
                      .format("MM")
                  : response.token.card.exp_month;
                request.ExpirationYear = response.token.card.exp_year;
                request.CCLast4Digits = response.token.card.last4;
                request.CardType = response.token.card.brand;
                request.AddressDetails = response.token.card.address_line1;
                request.PostalCode = response.token.card.address_zip;
                request.CreditCard = null;
                request.CvvCode = null;
                vm.cardTokenFromStripe = response.customer.id;
                vm.stripecardId = response.customer.default_source;
                vm.savePaymentCardInfo();
                vm.getLogIdsByEventID(2, 10);
                vm.save_Notification(2, 10, vm.notificationAmount);
                // if (vm.DefaultSettingforSyncCard == true) {
                //   console.log("guest==================>", vm.DefaultSettingforSyncCard)
                //   // vm.savePaymentCardInfoforGuest();
                // }
              }
            }
          },
        });
      }
    },
    Save_ErrorLogs(errorMessage) {
      let vm = this;
      // console.log("errorMessage",errorMessage.raw.message);
      vm.$store.dispatch("dataRequestHandler", {
        key: "Save_ErrorLogs",
        params: {
          PartyId: vm.guestInfo.ReservationId,
          PartyTypeId: 5,
          ErrorFrom: "SavePaymentDetails",
          RawResponse: errorMessage,
        },
        callback: function (err, response) {
          if (err) {
            console.log("Error in Save_ErrorLogs => ", err);
            return;
          }
          if (response) {
            console.log(
              "Save_ErrorLogs=========================================>",
              response
            );
          }
        },
      });
    },
    // showPopUp(){
    //   let vm = this;
    //   vm.isModalVisible = true;
    // },
    // showingdetails(){
    //  let vm = this;
    //  vm.visibleCC = true;

    // },
    // showingdetails() {
    //   let vm = this
    //   vm.visibleCC = true;
    //   for (var x in vm.guestPaymentCards) {
    //     let ccnumber = vm.guestPaymentCards[x].CreditCard;
    //     console.log("ccnumber", ccnumber);
    //     vm.guestPaymentCards[x].CreditCard = (ccnumber.replace(/(\d{4}(?!\s))/g, "$1 "));
    //     console.log("vm.showcc===>", vm.guestPaymentCards[x].CreditCard);

    //   }
    // },
    SaveTaxExemptForReservation() {
      let vm = this;
      vm.$store.dispatch("dataRequestHandler", {
        key: "SaveTaxExemptForReservation",
        params: {
          ReservationId: vm.guestInfo.ReservationId,
          IsTaxExempt: vm.folioCharges.IsTaxExempt,
        },
        callback: function (err, response) {
          if (err) {
            console.log("Error in SaveTaxExemptForReservation => ", err);
            return;
          }
          if (response) {
            // console.log("response in SaveTaxExemptForReservation => ", response);
            vm.getFolioSummary(false, "folioChange");
          }
        },
      });
    },
    showBooked(e) {
      // e.stopPropagation();
      this.isBgColor1 = false;
      this.showBookedBy = true;
      this.showguestinfo = false;
      this.Color = "active";
    },
    close() {
      let vm = this;
      vm.showSourceEditTool = false;
      vm.getReservationDetailById();
    },
    showSourceEdit() {
      let vm = this;
      vm.showSourceEditTool = true;
    },
    Save_SourceDetails() {
      let vm = this;
      if (vm.guestInfo.SourceId == "-99") {
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning!",
          message: "Please Select Source",
        });
      } else if (
        (vm.guestInfo.ReservationNumber != null &&
          vm.guestInfo.ReservationNumber != "") ||
        (vm.guestInfo.CrsConfirmationNumber != null &&
          vm.guestInfo.CrsConfirmationNumber != "") ||
        (vm.guestInfo.SubSourceConfirmationNumber != null &&
          vm.guestInfo.SubSourceConfirmationNumber != "") ||
        vm.guestInfo.SourceId == 1 ||
        vm.guestInfo.SourceId == 9
      ) {
        if (vm.guestInfo.SourceId == 1 || vm.guestInfo.SourceId == 9) {
          vm.guestInfo.ReservationNumber = "";
        }
        vm.$store.dispatch("dataRequestHandler", {
          key: "Save_SourceDetails",
          params: {
            ReservationId: vm.guestInfo.ReservationId,
            SourceId: vm.guestInfo.SourceId,
            SubSourceId: vm.guestInfo.SubSourceId,
            SourceConfirmationNumber: vm.guestInfo.ReservationNumber,
            CrsConfirmationNumber: vm.guestInfo.CrsConfirmationNumber,
            CrsId: vm.guestInfo.CrsId,
            SubSourceConfirmationNumber:
              vm.guestInfo.SubSourceConfirmationNumber,
            Ext_ConfirmationNumber: vm.guestInfo.Ext_ConfirmationNumber,
            UnitId: vm.roomInfo.UnitId,
          },
          callback: function (err, response) {
            if (err) {
              console.log("Error in Save_SourceDetails => ", err);
              return;
            }
            if (response) {
              console.log("response in Save_SourceDetails", response);
              vm.$store.dispatch("toastr", {
                type: "success",
                header: "Success!",
                message: "Source Details Saved Successfully!",
              });
              vm.showSourceEditTool = false;
              if (vm.$route.params.ReservationId != "-1") {
                vm.getReservationDetailById();
              }
              // vm.getReservationDetailById();
            }
          },
        });
      } else {
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning!",
          message: "Please enter an id",
        });
      }
    },
    fncIsHousekeepingTaskList() {
      let vm = this;
      if (vm.userEntitlementList.fncHousekeeper.isAssigned === 1) {
        vm.showicon = false;
      } else {
        vm.showicon = true;
      }
    },
    UnassignAndStatus() {
      let vm = this;
      if (vm.userEntitlementList.fncHousekeeper.isAssigned === 1) {
        vm.unassignbutton = true;
      } else {
        vm.unassignbutton = false;
      }
    },
    getNoteSubject() {
      let vm = this;

      // if (
      //   (vm.notesDetailById.noteSubject == undefined || vm.notesDetailById.noteSubject == "" || vm.isSelectedFromDropdown == true) &&
      //   (vm.notesDetailById.taskTypeId != "" || vm.notesDetailById.taskTypeId != null)
      // ) {
      let value = vm.taskTypeDropdown.filter(
        (col) => col.taskTypeId == vm.notesDetailById.taskTypeId
      );
      console.log("value", value);
      vm.isSelectedFromDropdown = true;

      return (vm.notesDetailById.noteSubject = value[0].taskTypeDesc);
      // }
      // else if (vm.notesDetailById.noteSubject && vm.notesDetailById.noteSubject != ""
      // ) {
      //   console.log("vm.noteSubject", vm.notesDetailById.noteSubject);
      //   return (vm.notesDetailById.noteSubject = vm.notesDetailById.noteSubject);
      // }
    },
    enteredNotes() {
      let vm = this;
      vm.isSelectedFromDropdown = false;
      console.log("enteredNotes");
    },
    setFouce(Id) {
      let vm = this;
      vm.allowEdit = false;
      for (let note of vm.notes) {
        if (note.noteId == Id) {
          note.showEditIcon = 1;
        } else {
          note.showEditIcon = 0;
        }
      }
    },
    tagDisabling() {
      let vm = this;
      if (
        (vm.userEntitlementList.fncReservationUpdate.isAssigned === 1 &&
          vm.$route.params.ReservationId != -1) ||
        (vm.userEntitlementList.fncReservationNew.isAssigned === 1 &&
          vm.$route.params.ReservationId == -1)
      ) {
        vm.Tagdisable = true;
      } else {
        vm.Tagdisable = false;
      }
    },
    // showingPayments(){
    //  let vm = this;
    //   if(vm.userEntitlementList.fncReservationPayments.isAssigned==1){
    //     vm.eyeicon = true;
    //   }
    //   else {
    //     vm.eyeicon = false;
    //   }
    // },

    EditSource() {
      let vm = this;
      //  console.log("fncHousekeepingTaskUpdate+ fncReservationSave+fncReservationUpdate+ fncReservationList",fncHousekeepingTaskUpdate);
      if (vm.entitlements && vm.entitlements.fncEditSource.isAssigned === 1) {
        vm.SourceEditBtn = true;
      } else {
        vm.SourceEditBtn = false;
      }
    },
    // AddPayment() {
    //   let vm = this;

    //   if (vm.entitlements && vm.entitlements.fncFolioNew.isAssigned === 1) {
    //     vm.PaymentOption = true;
    //   }
    //   else {
    //     vm.PaymentOption = false;
    //   }

    // },

    CheckInAndOutbuttonAndStatus() {
      let vm = this;
      //  console.log("fncHousekeepingTaskUpdate+ fncReservationSave+fncReservationUpdate+ fncReservationList",fncHousekeepingTaskUpdate);
      if (
        vm.entitlements.fncReservationUpdate.isAssigned === 1 ||
        vm.entitlements.fncHousekeeper.isAssigned === 1 ||
        (vm.userEntitlementList.fncReservationNew.isAssigned === 1 &&
          vm.$route.params.ReservationId == -1)
      ) {
        vm.checkInOutAndStatusbutton = true;
      } else {
        vm.checkInOutAndStatusbutton = false;
      }
    },

    ShowTimePickerComponent(param) {
      let vm = this;
      if (param == "ShowCheckIn") {
        vm.ShowCheckIn = true;
      } else {
        vm.ShowCheckOut = true;
      }
    },
    closeTimePicker(param) {
      let vm = this;
      let EventId = null,
        subEventId = null,
        deleteEvent = null;
      if (param == "ShowCheckIn") {
        vm.ShowCheckIn = false;
        if (
          vm.roomInfo.Reservation_Status != 4 &&
          vm.roomInfo.Reservation_Status != 6 &&
          vm.roomInfo.Reservation_Status != 7 &&
          vm.roomInfo.Reservation_Status != 11 &&
          vm.roomInfo.Reservation_Status != 12 &&
          vm.roomInfo.Reservation_Status != 10
        ) {
          EventId = "4";
          subEventId = "15";
          deleteEvent = "4";
          vm.get_JobDetails(deleteEvent);
          vm.getLogIdsByEventID(EventId, subEventId);
          //  vm.save_Notification(4,14,vm.notificationAmount);
        }
      } else {
        vm.ShowCheckOut = false;
        if (vm.roomInfo.Reservation_Status == 6) {
          EventId = "5";
          subEventId = "18";
          deleteEvent = "5";
          vm.get_JobDetails(deleteEvent);
          vm.getLogIdsByEventID(EventId, subEventId);
          //  vm.save_Notification(5,17,vm.notificationAmount);
        }
      }
      if (vm.$route.params.ReservationId != -1) {
        vm.getReservationDetailById();
      }
    },
    resetCheckIn(param) {
      let vm = this;
      let ischeckin;
      if (param == "ischeckin") {
        ischeckin = 1;
      } else {
        ischeckin = 0;
      }
      vm.$store.dispatch("dataRequestHandler", {
        key: "resetCheckInCheckOutTime",
        params: {
          ReservationId: vm.guestInfo.ReservationId,
          ischeckin: ischeckin,
        },
        callback: function (err, response) {
          if (err) {
            console.log("Error in resetCheckInCheckOutTime => ", err);
            return;
          }
          if (response) {
            console.log("response in resetCheckInCheckOutTime", response);
            vm.getReservationDetailById();
            let EventId = null,
              subEventId = null,
              deleteEvent = null;
            if (param == "ischeckin") {
              if (
                vm.roomInfo.Reservation_Status != 4 &&
                vm.roomInfo.Reservation_Status != 6 &&
                vm.roomInfo.Reservation_Status != 7 &&
                vm.roomInfo.Reservation_Status != 11 &&
                vm.roomInfo.Reservation_Status != 12 &&
                vm.roomInfo.Reservation_Status != 10
              ) {
                EventId = "4";
                subEventId = "15";
                deleteEvent = "4";
                vm.get_JobDetails(deleteEvent);
                vm.getLogIdsByEventID(EventId, subEventId);
                //  vm.save_Notification(4,14,vm.notificationAmount);
              }
            } else {
              if (vm.roomInfo.Reservation_Status == 6) {
                EventId = "5";
                subEventId = "18";
                deleteEvent = "5";
                vm.get_JobDetails(deleteEvent);
                vm.getLogIdsByEventID(EventId, subEventId);
                //  vm.save_Notification(5,17,vm.notificationAmount);
              }
            }
          }
        },
      });
    },
    imageURLS(imgGuid) {
      let isBase64 = /^data:image\/([a-zA-Z]*);base64,([^\"]*)/.test(imgGuid);
      if (isBase64) {
        return imgGuid;
      }
      return this.apiUrl + "/downloadImage/" + imgGuid + "/430x300";
    },
    intimepicker: function () {
      let vm = this;
      (vm.checkinedit = false), (vm.checkinput = true);
    },
    outtimepicker: function () {
      let vm = this;
      (vm.checkoutedit = false), (vm.checkoutput = true);
    },

    updateValues(values) {
      let scope = this;
      console.log(values);
      scope.roomInfo.StartDate = values.startDate.toISOString().slice(0, 10);
      scope.roomInfo.EndDate = values.endDate.toISOString().slice(0, 10);
      let StartMonth = moment(scope.roomInfo.StartDate).format("MMM");
      scope.startAndEnddates.StartMonth = StartMonth;
      //console.log("StartMonth", StartMonth);
      let StartDate = moment(scope.roomInfo.StartDate).format("DD");
      scope.startAndEnddates.StartDate = StartDate;
      let StartDay = moment(scope.roomInfo.StartDate).format("ddd");
      scope.startAndEnddates.StartDay = StartDay;
      //console.log("StartMonth", StartDay);
      let StartYear = moment(scope.roomInfo.StartDate).format("YYYY");
      scope.startAndEnddates.StartYear = StartYear;
      let EndMonth = moment(scope.roomInfo.EndDate).format("MMM");
      scope.startAndEnddates.EndMonth = EndMonth;
      //console.log("StartMonth", EndMonth);
      let EndDate = moment(scope.roomInfo.EndDate).format("DD");
      scope.startAndEnddates.EndDate = EndDate;
      //console.log("StartMonth", EndDay);
      let EndDay = moment(scope.roomInfo.EndDate).format("ddd");
      scope.startAndEnddates.EndDay = EndDay;
      //console.log("EndDate", EndDate);
      let EndYear = moment(scope.roomInfo.EndDate).format("YYYY");
      scope.startAndEnddates.EndYear = EndYear;

      scope.roomInfo.Nights = moment(scope.roomInfo.EndDate).diff(
        moment(scope.roomInfo.StartDate),
        "days"
      );
    },
    // invoiceForFolio() {
    //   let folioParams = {};
    //   axios.post(this.$store.state.reportHttpUrl + "/folioInvoice", {})
    //     .then(response => {
    //       console.log("response", response);
    //     });

    // },
    // closeModal(modal){
    //   $('.modal').hide();
    // },
    assignOrUnassign(reservationMode, oversell, Allocate) {
      let vm = this;
      //vm.saveRoomInfo(vm.roomInfo.reservationMode);
      console.log(
        "reservationMode, oversell",
        reservationMode + "++++" + oversell
      );

      if (reservationMode || oversell) {
        var toasterMsg;
        if (oversell == 1) {
          toasterMsg = "Unallocated";
        } else if (oversell == 2) {
          toasterMsg = "allocated";
        } else if (oversell == 3) {
          toasterMsg = "Unassigned";
        }
        vm.$store.dispatch("dataRequestHandler", {
          key: "UpdateUnitToUnAssigned",
          params: {
            ReservationId: vm.guestInfo.ReservationId,
            Oversell: oversell,
            Allocate: Allocate
          },
          callback: function (err, response) {
            if (err) {
              vm.$store.dispatch("toastr", {
                type: "error",
                header: "Error!",
                message: `Error While ${toasterMsg} Unit Info!`,
              });

              console.log("Error in UpdateUnitToUnAssigned => ", err);
              return;
            }
            if (response) {
              if (
                response[0] &&
                response[0][0] &&
                response[0][0].ErrorMessage != ""
              ) {
                
                // assignOrUnassignModal
                if(vm.roomInfo.Oversell && response[0][0].ErrorMessage){
                  vm.assignOrUnassignPopup = true;
                  vm.assignOrUnassignModalParams = {
                    popupTitle: `Error`,
                    popupMessage: response[0][0].ErrorState == 1 ? 'This booking cannot be allocated with the existing search criteria.  Please modify your search with applicable values (e.g., new unit, dates, # of guests, etc.) and try again.' : 'This booking cannot be allocated due to missing originally booked rate plan or restriction.  Would you like to proceed and allocate the reservation?',//response[0][0].ErrorMessage,
                    isRUPopup: true,
                    yesButtontext: "Yes",
                    noButtonText: "No",
                    yesButtonCallback: vm.yesAssignOrUnassignPopup,
                    noButtonCallback: vm.closeAssignOrUnassignPopup,
                    actionButtons: true,
                    footer: response[0][0].ErrorState == 1 ? false : true,
                    paramsdata: {
                      reservationMode: reservationMode,
                      oversell: oversell,
                      Allocate: Allocate
                    },
                  };
                }
                else{
                  vm.$store.dispatch("toastr", {
                  type: "error",
                  header: "Error!",
                  message: response[0][0].ErrorMessage,
                });
                }
              } else if (
                response[0] &&
                response[0][0] &&
                response[0][0].ErrorMessage == "" &&
                vm.guestInfo.IsHostMode != 1
              ) {
                vm.$store.dispatch("toastr", {
                  type: "success",
                  header: "Success!",
                  message: `Unit has ${toasterMsg} successfully!`,
                });
              } else if (
                response[0] &&
                response[0][0] &&
                response[0][0].ErrorMessage == "" &&
                vm.guestInfo.IsHostMode == 1
              ) {
                vm.$store.dispatch("toastr", {
                  type: "success",
                  header: "Success!",
                  message: `Unit has ${toasterMsg} successfully!`,
                });
              }
              console.log("response in UpdateUnitToUnAssigned", response);
              // if(oversell){
              //   vm.GetAvailableRooms();
              // }
              // else{
              vm.getReservationDetailById();
              // }
            }
          },
        });
      } else {
        console.log("here");
        vm.searchByUnit = true;
        vm.splitReservations = false;
        vm.GetAvailableRooms();
      }
    },
    yesAssignOrUnassignPopup(event,params){
      let vm = this;
      vm.assignOrUnassignPopup = false;
      vm.assignOrUnassign(params.reservationMode, params.oversell, 1); 
    },
    closeAssignOrUnassignPopup() {
      let vm = this;
      vm.assignOrUnassignPopup = false;
    },
    getFolioInvoice(value) {
      let vm = this;
      // document.getElementById("invoiceToBePrinted").style.display = "block";
      // var element = document.getElementById("invoiceToBePrinted");
      // element.className += "in";
      // element.className += "show";
      vm.DetailedOrConsolidated = value;
      vm.$store.dispatch("dataRequestHandler", {
        key: "GetFolioLedgerTransDetails_Invoice",
        params: {
          FunctionId: null,
          ReservationId: vm.guestInfo.ReservationId,
        },
        callback: function (err, response) {
          if (err) {
            console.log("err in GetFolioLedgerTransDetails_Invoice", err);
            return;
          }
          if (response) {
            console.log(
              "result in GetFolioLedgerTransDetails_Invoice",
              response
            );
            vm.invoiceDetails = response;
            for (var i in vm.additionalEmails) {
              if (!vm.additionalEmails[i].Emailaddress) {
                vm.additionalEmails.splice(i, 1);
              }
            }

            // setTimeout(function () {
            if (vm.additionalEmails.length == 0) {
              // vm.additionalEmails =[]
              vm.additionalEmails.push({ ReservationId: "", Emailaddress: "" });
            }
            // }, 3000);
          }
        },
      });
    },
    pdfDownload(ReservationId) {
      let scope = this;
      //     var doc = new jsPDF();
      //     doc.fromHTML($('#invoiceToBePrinted').html(), 15, 15, {
      //     'width': 170
      // });
      // doc.save('sample-file.pdf');
      console.log("resId", ReservationId);

      //     requestParams.input('ledgerAccountId', mssql.NVarChar, params.ledgerAccountId);
      // requestParams.input('Amount', mssql.NVarChar, params.Amount);
      // requestParams.input('DateEffective', mssql.NVarChar, params.DateEffective);
      // requestParams.input('IsFolioEdit', mssql.Bit, params.IsFolioEdit);
      // requestParams.input('UserId', mssql.Int, params.systemParams.UserId);

      // ledgerAccountId: vm.selectedLedger && vm.selectedLedger.ledgerAccountID != null ? vm.selectedLedger.ledgerAccountID : null,
      //         Amount: vm.selectedLedger && vm.selectedLedger.defaultAmount != null ? vm.selectedLedger.defaultAmount : vm.selectedLedger && vm.selectedLedger.TaxAmount != null ? vm.selectedLedger.TaxAmount : null,
      //         DateEffective: vm.selectedLedger && vm.selectedLedger.dateEffective != null ? moment(vm.selectedLedger.dateEffective).format("YYYY-MM-DD") : null,
      //         IsFolioEdit: vm.selectedLedger && vm.selectedLedger.dateEffective != null ? 1 : 0,

      var form = document.createElement("form");
      var input = document.createElement("input");
      var input2 = document.createElement("input");
      var input3 = document.createElement("input");
      var input4 = document.createElement("input");
      var input5 = document.createElement("input");
      var input6 = document.createElement("input");
      var input7 = document.createElement("input");
      var input8 = document.createElement("input");
      var input9 = document.createElement("input");
      var input10 = document.createElement("input");
      var input11 = document.createElement("input");
      var input12 = document.createElement("input");

      input.value = ReservationId;
      input.name = "ReservationId";
      input.hidden = true;
      input11.value = scope.guestInfo.CompanyProfileId;
      input11.name = "companyProfileId";
      input11.hidden = true;
      input2.value = this.actualMyValue[0].ClientId;
      input2.name = "ClientId";
      input2.hidden = true;
      input3.value = this.apiUrl + "/downloadImage/";
      input3.name = "imgUrl";
      input3.hidden = true;
      input4.value =
        scope.selectedLedger && scope.selectedLedger.ledgerAccountID != null
          ? scope.selectedLedger.ledgerAccountID
          : null;
      input4.name = "ledgerAccountId";
      input4.hidden = true;
      input5.value =
        scope.selectedLedger && scope.selectedLedger.defaultAmount != null
          ? scope.selectedLedger.defaultAmount
          : scope.selectedLedger && scope.selectedLedger.TaxAmount != null
          ? scope.selectedLedger.TaxAmount
          : null;
      input5.name = "Amount";
      input5.hidden = true;
      input6.value =
        scope.selectedLedger && scope.selectedLedger.dateEffective != null
          ? moment(scope.selectedLedger.dateEffective).format("YYYY-MM-DD")
          : null;
      input6.name = "DateEffective";
      input6.hidden = true;
      input7.value =
        scope.selectedLedger && scope.selectedLedger.dateEffective != null
          ? 1
          : 0;
      input7.name = "IsFolioEdit";
      input7.hidden = true;
      input8.value = scope.DetailedOrConsolidated;
      input8.name = "DetailedOrConsolidated";
      input8.hidden = true;

      input9.value = scope.guestInfo.ShowTaxdetailsonDetailedInvoice;
      input9.name = "ShowTaxdetailsonDetailedInvoice";
      input9.hidden = true;

      input10.value = scope.guestInfo.ShowPolicyonDetailedInvoice;
      input10.name = "ShowPolicyonDetailedInvoice";
      input10.hidden = true;

      input12.value = "resProfile";
      input12.name = "invoiceType";
      input12.hidden = true;
      // DetailedOrConsolidated
      form.appendChild(input);
      form.appendChild(input2);
      form.appendChild(input3);
      form.appendChild(input4);
      form.appendChild(input5);
      form.appendChild(input6);
      form.appendChild(input7);
      form.appendChild(input8);
      form.appendChild(input9);
      form.appendChild(input10);
      form.appendChild(input11);
      form.appendChild(input12);

      form.method = "POST";
      form.action = this.$store.state.reportHttpUrl + "/FolioInvoice";
      document.body.appendChild(form);
      form.submit();
    },
    sharePdf() {
      let vm = this;
      // document.getElementById("invoiceToBePrinted").style.display = "none";
      // var element = document.getElementById("invoiceToBePrinted");
      // element.classList.remove("in");
      // element.classList.remove("show");
      // $('.modal-backdrop.fade.in').remove();
      // $('.modal-backdrop.fade.show').remove();

      if (vm.additionalEmails.length == 1) {
        // vm.sendPdfEmail(vm.additionalEmails[0].Emailaddress.split());
        vm.emailList = vm.additionalEmails[0].Emailaddress.split();
        vm.sendPdfEmail();
      }
      // else if(vm.additionalEmails.length > 1){
      //   // vm.showEmailDropdown = true;
      //   document.getElementById("invoiceDropDown").classList.toggle("show");

      // }

      // if(vm.additionalEmails && vm.additionalEmails.length > 1){
      //   vm.modalParams = {
      //         popupTitle: "Select emails to send Invoice",
      //         popupMessage: "",
      //         displayYesNoButtons: false,
      //         sendEmailButton:true,
      //         sendQuoteButton: false,
      //         sendEmailCallback: vm.sendPdfEmail,
      //         // sendQuoteCallback: vm.sendQuoteCallbackFunc,
      //         listValues: vm.additionalEmails
      // };
      // vm.isModalVisible = true;

      // }
      // else{
      //   vm.sendPdfEmail(vm.additionalEmails[0].Emailaddress.split());
      // }
    },
    sendPdfEmail() {
      let vm = this;
      console.log("email", vm.emailList[0]);
      if (vm.emailList[0] == "" || vm.emailList[0] == null) {
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning",
          message: "Please save guest email to send Invoice.",
        });
        return;
      }
      vm.isModalVisible = false;
      vm.$store.dispatch("dataRequestHandler", {
        key: "sendInvoiceMail",
        params: {
          invoiceDetails: vm.invoiceDetails,
          imgUrl: vm.apiUrl + "/downloadImage/",
          email: vm.emailList,
          folioItemSummary: vm.folioItemsDetails,
          DetailedOrConsolidated: vm.DetailedOrConsolidated,
          ShowTaxdetailsonDetailedInvoice:
            vm.guestInfo.ShowTaxdetailsonDetailedInvoice,
          ShowPolicyonDetailedInvoice: vm.guestInfo.ShowPolicyonDetailedInvoice,
          balanceTransferList: vm.balanceTransferDetails.filter(item => !item.isvoided),
          parentComp: "reservationProfile",
        },
        callback: function (err, response) {
          if (err) {
            console.log("err in sendInvoiceMail", err);
            vm.$store.dispatch("toastr", {
              type: "error",
              header: "Error",
              message: "Error While sending Invoice mail!",
            });
            return;
          }
          if (response) {
            console.log("response in sendPdf", response);
            vm.emailList = [];
            // if (response[0] && response[0][0] && response[0][0].ErrorMessage) {
            //   vm.$store.dispatch("toastr", {
            //     type: "error",
            //     header: "Error",
            //     message: "Error While Updating Folio!"
            //   });
            // } else {
            //   vm.$store.dispatch("toastr", {
            //     type: "success",
            //     header: "Success!",
            //     message: "Folio Updated Successfully."
            //   });
            // }
            if (response.errorMessage == "") {
              vm.$store.dispatch("toastr", {
                type: "success",
                header: "Success!",
                message: "Email Sent Succesfully!",
              });
            } else {
              vm.$store.dispatch("toastr", {
                type: "error",
                header: "Error",
                message: "Error While sending Invoice mail!",
              });
            }
          }
        },
      });
    },
    print(divID) {
      // let scope = this;

      // let divElementsToBePrinted = document.getElementById(divID).innerHTML;
      // let oldPage = document.body.innerHTML;
      // let originalPage = document.getElementById(".fullStretch");
      // document.body.innerHTML =
      //   "<html><head><title></title></head><body>" +
      //   divElementsToBePrinted +
      //   "</body>";
      // window.print();
      let elem = document.getElementById(divID);
      var domClone = elem.cloneNode(true);

      var $printSection = document.getElementById("printSection");

      if (!$printSection) {
        var $printSection = document.createElement("div");
        $printSection.id = "printSection";
        $printSection.style.width = "100%";
        // $printSection.style.color = "red"
        document.body.appendChild($printSection);
      }

      $printSection.innerHTML = "";
      $printSection.appendChild(domClone);
      window.print();
      // location.reload();
      // document.body.innerHTML = oldPage;
      // location.reload();
      // scope.$router.push("/newReservation/" + scope.$route.params.ReservationId + "/" + scope.$route.params.GuestProfileId + "/" + scope.$route.params.PartyAddressId + "/" + scope.$route.params.StatusId + "/" + scope.$route.params.PropertyId );

      // document.body.innerHTML = originalPage;
      // $('.divElementsToBePrinted').hide();
    },
    addAdditionalPhoneNumbers(accountType) {
      let vm = this;
      //console.log("add phoneNumber", phoneNumber);
      if (accountType == "company") {
        vm.additionalCompanyPhoneNumbers.push({
          ReservationId: "",
          PhoneNumber: "",
        });
        console.log("vm.additionalEmails", vm.additionalCompanyPhoneNumbers);
      } else {
        vm.additionalPhoneNumbers.push({ ReservationId: "", PhoneNumber: "" });
        console.log("vm.additionalEmails", vm.additionalPhoneNumbers);
      }
    },

    removeaddAdditionalPhoneNumbers(phoneNumber, accountType) {
      let vm = this;
      // console.log(email);
      if (accountType == "company") {
        let additionalCompanyPhoneNumbersIndex =
          vm.additionalCompanyPhoneNumbers.indexOf(phoneNumber);
        vm.additionalCompanyPhoneNumbers.splice(
          additionalCompanyPhoneNumbersIndex,
          1
        );
      } else {
        let additionalPhoneNumberIndex =
          vm.additionalPhoneNumbers.indexOf(phoneNumber);
        vm.additionalPhoneNumbers.splice(additionalPhoneNumberIndex, 1);
      }
    },
    addAdditionalEmail(accountType) {
      let vm = this;
      //console.log("add email", email);
      if (accountType == "company") {
        vm.additionalCompanyEmails.push({
          ReservationId: "",
          Emailaddress: "",
        });
      } else {
        vm.additionalEmails.push({ ReservationId: "", Emailaddress: "" });
      }
      console.log("vm.additionalEmails", vm.additionalEmails);
    },
    removeaddAdditionalEmail(email, accountType) {
      let vm = this;
      console.log(email);
      if (accountType == "company") {
        let additionalCompanyEmailsIndex =
          vm.additionalCompanyEmails.indexOf(email);
        vm.additionalCompanyEmails.splice(additionalCompanyEmailsIndex, 1);
      } else {
        let additionalEmailIndex = vm.additionalEmails.indexOf(email);
        vm.additionalEmails.splice(additionalEmailIndex, 1);
      }
    },
    showMoreFolioItems() {
      //console.log("showMoreFolioItems");
      let vm = this;
      (vm.showLess = false), (vm.showMore = true);
    },
    showLessFolioItems() {
      //console.log("showLessFolioItems");
      let vm = this;
      (vm.showLess = true), (vm.showMore = false);
    },
    getConfirmationNumbers() {
      let scope = this;
      scope.displayConfirmationDropDown = true;
    },
    // removeAmenities(Amenities) {
    //   let scope = this;
    //   scope.filteredAmenities.splice(this.filteredAmenities.indexOf(Amenities), 1);
    //   console.log("scope.filteredAmenities after removeAmenities", scope.filteredAmenities)

    // },
    removeAmenities(Amenities) {
      let scope = this;
      // scope.filteredAmenities.splice(this.filteredAmenities.indexOf(Amenities), 1);
      //console.log("scope.filteredAmenities after removeAmenities", scope.filteredAmenities)
      var index = scope.filteredAmenities.indexOf(Amenities);
      if (index > -1) {
        scope.filteredAmenities.splice(index, 1);
      }
      scope.AmenitiesList.push({
        ListId: Amenities.ListId,
        ListName: Amenities.ListName,
      });
    },
    // addAmenities(Amenities) {
    //   let scope = this;
    //   scope.filteredAmenities.push(Amenities);
    //   scope.showAmenitiesList = false;
    //   console.log("scope.filteredAmenities", scope.filteredAmenities)
    // },
    addAmenities(Amenities) {
      let scope = this;
      scope.filteredAmenities.push(Amenities);
      scope.showAmenitiesList = false;
      //console.log("scope.filteredAmenities", scope.filteredAmenities)
      var index = scope.AmenitiesList.indexOf(Amenities);
      console.log("index of Amenities=>", index);
      if (index > -1) {
        scope.AmenitiesList.splice(index, 1);
        //console.log("scope.AmenitiesList", scope.AmenitiesList);
      }
    },
    showItems(name) {
      if (name === "displayAddFolioItem") {
        //console.log("name in showItems", name);
        let scope = this;
        scope.ShowDropdown = true;
        //scope.selectedLedger = null;
        scope.focused = true;
        console.log(
          "scope.roomInfo.originalStartDatescope.roomInfo.originalStartDate",
          moment.utc(scope.roomInfo.originalStartDate).format("Do MMM YYYY")
        );
        // scope.$refs.ledger.focus();
        let selectedDate = scope.folioItemsDetails.filter((folioItem) => {
          return folioItem.Ischecked == true;
        });
        this.selectedLedger = {
          // ActualDateEffective: selectedDate && selectedDate[0] ? moment(selectedDate[0].ActualDateEffective).format("DD-MM-YYYY") : moment(scope.roomInfo.originalStartDate).format("YYYY-MM-DD"),
          // dateEffective: selectedDate && selectedDate[0] ? moment(selectedDate[0].ActualDateEffective).format("DD-MM-YYYY") : moment(scope.roomInfo.originalStartDate).format("YYYY-MM-DD"),
          // dateEffective: scope.selectedFolioItemToEdit && scope.selectedFolioItemToEdit.ActualDateEffective && scope.selectedFolioItemToEdit.ActualDateEffective != '' ? scope.selectedFolioItemToEdit.ActualDateEffective : scope.roomInfo.StartDate,
          dateEffective:
            selectedDate && selectedDate[0]
              ? moment(selectedDate[0].ActualDateEffective).format(
                  "DD MMM YYYY"
                )
              : moment
                  .utc(scope.roomInfo.originalStartDate)
                  .format("DD MMM YYYY"),
          ledgerAccountID: null,
          defaultAmount: null,
          paymentInfoId: null,
          folioItemId: null,
        };
        scope.cancelPayment();
      }
      if (name === "displayAddPayment") {
        //console.log("name in showItems", name);
        let scope = this;
        scope.ShowDiv = true;
      }
      this.showPreviewButton = true;
    },
    addPayment() {
      this.pendingPaymentDetails.push(
        JSON.parse(
          JSON.stringify({
            PaymentInfoId: -1,
            PaymentTypeId: null,
            Amount: this.folioCharges.Balance.replace(/\,/g, ""),
            dateEffective: moment().format("YYYY-MM-DD HH:mm:ss"),
          })
        )
      );
      this.showNextProcessButton = false;
      this.buttonName = "Save";
      if (this.guestPaymentCards.length === 1) {
        this.selectedPaymentCardDetails = this.guestPaymentCards[0];
        this.buttonName = "Process";
      } else {
        let defaultPaymentOption = this.guestPaymentCards.filter(function (
          paymentCard
        ) {
          return paymentCard.IsDefault;
        });

        if (defaultPaymentOption && defaultPaymentOption.length > 0) {
          this.selectedPaymentCardDetails = defaultPaymentOption[0];
          this.buttonName = "Process";
        } else {
          this.selectedPaymentCardDetails = this.guestPaymentCards[0];
          this.buttonName = "Process";
        }
      }

      this.showAddPaymentDetail = true;
      this.showPayments = true;
      this.showPaymentDetails = false;
      this.Cancel(); //Cancelling add folio items
      this.CancelUpdateFolioItem(); //Cancelling edit folio items
    },
    saveFolioItem(ledgerObj) {
      console.log("ledgerObjledgerObj", ledgerObj);
      this.selectedVoidItem = false;
      if (!ledgerObj.ledgerAccountID) {
        this.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning",
          message: "Please select ledger",
        });
        return;
      }

      if (ledgerObj.ledgerAccountID) {
        if (ledgerObj.ledgerAccountTypeID) {
          if (
            ledgerObj.ledgerAccountTypeID == 4 &&
            (!ledgerObj.TaxAmount || ledgerObj.TaxAmount == 0)
          ) {
            this.$store.dispatch("toastr", {
              type: "warning",
              header: "Warning",
              message: "Please enter amount",
            });
            return;
          }
        } else if (
          !ledgerObj.ledgerAccountTypeID &&
          (!ledgerObj.defaultAmount || ledgerObj.defaultAmount == 0)
        ) {
          this.$store.dispatch("toastr", {
            type: "warning",
            header: "Warning",
            message: "Please enter amount",
          });
          return;
        }
      }
      this.addFolioItem(
        {
          ledgerAccountID: ledgerObj.ledgerAccountID,
          defaultAmount:
            ledgerObj.ledgerAccountTypeID && ledgerObj.ledgerAccountTypeID == 4
              ? ledgerObj.TaxAmount
              : ledgerObj.defaultAmount,
          paymentInfoId: null,
          folioItemId: null,
          dateEffective: ledgerObj.ActualDateEffective
            ? ledgerObj.ActualDateEffective
            : moment(ledgerObj.dateEffective).format("YYYY-MM-DD"),
          fromPayment: false,
          TaxAmount: ledgerObj.TaxAmount,
        },
        "folioChange"
      );
      this.selectedLedger = null;
      let events = [
        { eventId: 2, subeventId: 9 },
        { eventId: 3, subeventId: 11 },
      ];
      for (let event of events) {
        this.getLogIdsByEventID(event.eventId, event.subeventId);
      }
      let NotificationEvents = [
        { notificationEventId: 2, NotiSubEventId: 9 },
        { notificationEventId: 3, NotiSubEventId: 11 },
      ];
      for (let event of NotificationEvents) {
        this.save_Notification(
          event.notificationEventId,
          event.NotiSubEventId,
          vm.notificationAmount
        );
      }
    },
    addFolioItem(object, foliochange) {
      console.log("addFolioItem addFolioItem", object);
      let vm = this;
      console.log("vm.chargeItem", vm.chargeItem);
      vm.$store.dispatch("dataRequestHandler", {
        key: "save_folioItem",
        params: {
          ReservationId: vm.guestInfo.ReservationId,
          LedgerAccountId: object.ledgerAccountID,
          // UnitId: null,
          // IsMaster: 0,
          // FolioId: null,
          Amount: object.defaultAmount,
          PaymentInfoId: object.paymentInfoId,
          ItemId: object.folioItemId,
          DateEffective: object.dateEffective,
          chargeObj: vm.chargeItem,
          paymentStatusId: vm.paymentProcessMethod,
          commissionAmmount: vm.commissionAmmount,
          FeeCollected: vm.FeeCollected,
          TaxAmount: object.TaxAmount ? object.TaxAmount : null,
          Ismultiple:
            vm.selectedLedger &&
            vm.selectedLedger.dateEffective != null &&
            vm.showPreviewButton == false
              ? 1
              : 0,
          foliochange: foliochange,
        },
        callback: function (err, response) {
          if (err) {
            console.log("err in save_folioItem", err);
            vm.$store.dispatch("toastr", {
              type: "error",
              header: "Error",
              message: "Error While Updating Folio!",
            });
            return;
          }
          if (response) {
            if (response[0] && response[0][0] && response[0][0].ErrorMessage) {
              vm.$store.dispatch("toastr", {
                type: "error",
                header: "Error",
                message: "Error While Updating Folio!",
              });
            } else {
              vm.$store.dispatch("toastr", {
                type: "success",
                header: "Success!",
                message: "Folio Updated Successfully.",
              });
            }
            vm.parentPaymentitemObj = {};
            vm.checkAmount = null;
            vm.paymentProcessMethod = null;
            vm.paymentStatusId = null;
            console.log("result in save_folioItem", response);
            vm.ShowDropdown = false;
            vm.selectedFolioItemToEdit = null;
            vm.getFolioSummary(object.fromPayment, foliochange);
            vm.getPaymentDetails();
            vm.folioUpdate = false;
            vm.ShowDropdown = false;
            vm.itemToEdit = null;
            vm.checkedItems = [];
            vm.selectedVoidItem = false;
          }
        },
      });
    },
    Cancel(cancelEditfolio) {
      this.ShowDropdown = false;
      this.selectedLedger = null;
      this.selectedItemCount = true;
      this.selectedVoidItem = false;
      this.folioDateChange = false;
      if (cancelEditfolio == "cancelEditfolio") {
        this.getFolioSummary(false);
      }
      this.folioItemsToVoid.splice(0);
      for (let folioItem of this.folioItemsDetails) {
        folioItem.Ischecked = false;
      }
      this.itemToEdit = null;
      this.checkedItems = [];
    },
    cancelRatePlanEdit() {
      this.myValue =
        this.actualMyValue && this.actualMyValue[0]
          ? this.actualMyValue[0].id
          : null;
      this.ratePlanId =
        this.actualMyValue && this.actualMyValue[0]
          ? this.actualMyValue[0].RatePlanId
          : null;
      this.Promocode =
        this.actualMyValue && this.actualMyValue[0]
          ? this.actualMyValue[0].PromoCodes
          : null;
      this.guestInfo.RateplanName =
        this.actualMyValue && this.actualMyValue[0]
          ? this.actualMyValue[0].RatePlan_DisplayName
          : null;
      this.guestInfo.Promocode =
        this.actualMyValue && this.actualMyValue[0]
          ? this.actualMyValue[0].PromoCodes
          : null;
      this.showRatePlanSave = false;
      this.ratePlanResMinStay =
        this.actualMyValue && this.actualMyValue[0]
          ? this.actualMyValue[0].MinStay
          : null;
      this.selectedFolioItemToEdit = false;
      this.ShowDropdown = false;
      this.getFolioSummary(false);
      this.isModalVisible = false;
      this.ShowDropdown = false;
      this.selectedLedger = null;
      for (let folioItem of this.folioItemsDetails) {
        folioItem.Ischecked = false;
      }
      this.GetFolioLedgerTransDetails_beforesave();
    },
    onChangeStatus(status) {
      //console.log("changeStatus", status.StatusId);
      let vm = this;
      // <!-- for RTB and alterations -->
      // if(vm.guestInfo.SourceId == 5 && status.StatusId == 4){
      //   vm.AcceptorDecline(0,null)
      //   return
      // }
      // <!-- for RTB and alterations -->
      vm.$store.dispatch("dataRequestHandler", {
        key: "UpdateReservationStatus",
        params: {
          // FunctionId: null,
          ReservationId: vm.guestInfo.ReservationId,
          // Ext_ReservationId: null,
          StatusId: status.StatusId,
          IsFromRU: 0,
          userdate: moment().format("YYYY-MM-DD HH:mm:ss"),
          voidfutureitems: 0,
        },
        callback: function (err, response) {
          if (err) {
            console.log("err in UpdateReservationStatus", err);
            return;
          }
          if (response) {
            console.log("result in UpdateReservationStatus", response);

            if (response[1] && response[1][0] && response[1][0]["StatusId"]) {
              vm.reservationStatusList = response[1];
            } else if (
              response[2] &&
              response[2][0] &&
              response[2][0]["StatusId"]
            ) {
              vm.reservationStatusList = response[2];
            }
            // vm.getReservationDetailById();
            vm.$store.dispatch("toastr", {
              type: "success",
              header: "Success!",
              message: response[0][0].SuccessMessage,
            });
            let EventID = [],
              SubEventId = null,
              deleteEvent = null;
            let NotificationEventID = [],
              NotiSubEventId;
            if (status.StatusId == 1) {
              //  NotificationEventID = [{ notificationEventId: 6, NotiSubEventId: "20" }]
              if (
                vm.previousRoomInfo.Reservation_Status == 4 ||
                vm.previousRoomInfo.Reservation_Status == 8 ||
                vm.previousRoomInfo.Reservation_Status == 10 ||
                vm.previousRoomInfo.Reservation_Status == 11 ||
                vm.previousRoomInfo.Reservation_Status == 12
              ) {
                EventID = [
                  { eventId: 4, subEventId: "15" },
                  { eventId: 6, subEventId: "20" },
                ];
                NotificationEventID = [
                  { notificationEventId: 6, NotiSubEventId: "20" },
                ];
              } else {
                EventID = [{ eventId: 6, subEventId: "20" }];
                NotificationEventID = [
                  { notificationEventId: 6, NotiSubEventId: "20" },
                ];
              }
            } else if (status.StatusId == 5) {
              EventID = [{ eventId: 6, subEventId: "21" }];
              NotificationEventID = [
                { notificationEventId: 6, NotiSubEventId: "21" },
              ];
            } else if (status.StatusId == 8) {
              EventID = [{ eventId: 6, subEventId: "22" }];
              NotificationEventID = [
                { notificationEventId: 6, NotiSubEventId: "22" },
              ];
            } else if (status.StatusId == 3) {
              EventID = [{ eventId: 6, subEventId: "23" }];
              NotificationEventID = [
                { notificationEventId: 6, NotiSubEventId: "23" },
              ];
            } else if (status.StatusId == 4) {
              EventID = [{ eventId: 6, subEventId: "24" }];
              NotificationEventID = [
                { notificationEventId: 6, NotiSubEventId: "24" },
              ];
            } else if (status.StatusId == 11) {
              EventID = [{ eventId: 6, subEventId: "25" }];
              NotificationEventID = [
                { notificationEventId: 6, NotiSubEventId: "25" },
              ];
            } else if (status.StatusId == 6) {
              NotificationEventID = [
                { notificationEventId: 4, NotiSubEventId: 14 },
              ];
            } else if (status.StatusId == 7) {
              NotificationEventID = [
                { notificationEventId: 5, NotiSubEventId: 17 },
              ];
            }

            if (
              (vm.previousRoomInfo.Reservation_Status == 6 ||
                vm.previousRoomInfo.Reservation_Status == 7 ||
                vm.previousRoomInfo.Reservation_Status == 8) &&
              status.StatusId == 1
            ) {
              deleteEvent = "4,5";
            }

            if (
              status.StatusId == 4 ||
              status.StatusId == 8 ||
              status.StatusId == 10 ||
              status.StatusId == 11 ||
              status.StatusId == 12
            ) {
              deleteEvent = "4,5";
            }

            // if (vm.previousRoomInfo.Reservation_Status == 10 && status.StatusId == 1) {
            //   EventID = "3,6"
            //   SubEventId = "6"
            // }
            // else if (vm.previousRoomInfo.Reservation_Status == 1 && status.StatusId == 5) {
            //   EventID = 7
            // }
            // else if (vm.previousRoomInfo.Reservation_Status == 1 && status.StatusId == 8) {
            //   EventID = "8"
            //   deleteEvent = "3"
            // }
            // else if (vm.previousRoomInfo.Reservation_Status == 1 && status.StatusId == 3) {
            //   EventID = 9
            // }
            // else if (status.StatusId == 4) {
            //   EventID = 10
            // }
            // else if (status.StatusId == 11) {
            //   EventID = 11
            // }
            // else if (vm.previousRoomInfo.Reservation_Status == 4 && status.StatusId == 1) {
            //   EventID = "3,12"
            //   SubEventId = "6"
            // }
            // else if (vm.previousRoomInfo.Reservation_Status == 11 && status.StatusId == 1) {
            //   EventID = "3,13"
            //   SubEventId = "6"
            // }

            // vm.getLogIdsByEventID(EventID, SubEventId)
            if (vm.$route.params.ReservationId != -1) {
              vm.getFolioSummary(false, null);
              if (
                (vm.previousRoomInfo.Reservation_Status == "4" ||
                  vm.previousRoomInfo.Reservation_Status == "10" ||
                  vm.previousRoomInfo.Reservation_Status == "11" ||
                  vm.previousRoomInfo.Reservation_Status == "12") &&
                vm.Reservation_Status.StatusId == "1"
              ) {
                // vm.roomInfo.reservationMode = 1;
                vm.saveRoomInfo(1, "fromStatusChange");
                setTimeout(function () {
                  vm.get_JobDetails(deleteEvent);
                  for (let event of NotificationEventID) {
                    vm.save_Notification(
                      event.notificationEventId,
                      event.NotiSubEventId,
                      vm.notificationAmount
                    );
                  }

                  for (let event of EventID) {
                    vm.getLogIdsByEventID(event.eventId, event.subEventId);
                  }
                }, 1000);
              } else {
                vm.getReservationDetailById();
                vm.get_JobDetails(deleteEvent);
                for (let event of NotificationEventID) {
                  vm.save_Notification(
                    event.notificationEventId,
                    event.NotiSubEventId,
                    vm.notificationAmount
                  );
                }

                for (let event of EventID) {
                  vm.getLogIdsByEventID(event.eventId, event.subEventId);
                }
              }
            }
            // vm.$nextTick(function () {

            // });
          }
        },
      });
    },
    changeStatus(status) {
      //console.log("changeStatus", action);
      let vm = this;
      // if (action === "fncGuestCheckIn") {
      //   vm.$route.params.StatusId = 6;
      // }
      // if (action === "fncGuestCheckOut") {
      //   vm.$route.params.StatusId = 7;
      // }
      let currentdate = moment().format("MMM DD YYYY");
      if (status == 7 && moment(currentdate).isBefore(vm.roomInfo.EndDate)) {
        vm.modalParams = {
          popupTitle: "void charges for future dates",
          popupMessage: "Would you like to update the remaining charges ?",
          displayYesNoButtons: true,
          yesButtontext: "Yes",
          noButtonText: "No",
          yesButtonCallback: vm.checkinOrCheckout,
          noButtonCallback: vm.noCheckout,
        };
        vm.isModalVisible = true;
      } else {
        vm.checkinOrCheckout(status, 0);
      }
    },
    noCheckout() {
      let vm = this;
      vm.isModalVisible = false;
      vm.checkinOrCheckout(7, 0);
    },
    checkinOrCheckout(status, voidfutureitems) {
      let vm = this;
      if (vm.isModalVisible) {
        status = 7;
        voidfutureitems = 1;
      }
      vm.isModalVisible = false;
      // if(!status){
      //   status = 7
      // }
      // if(!voidfutureitems){
      //   voidfutureitems = 1
      // }
      vm.$store.dispatch("dataRequestHandler", {
        key: "UpdateReservationStatus",
        params: {
          // FunctionId: action,
          ReservationId: vm.$route.params.ReservationId,
          // Ext_ReservationId: null,
          StatusId: status,
          IsFromRU: 0,
          userdate: moment().format("YYYY-MM-DD HH:mm:ss"),
          voidfutureitems: voidfutureitems,
        },
        callback: function (err, response) {
          if (err) {
            console.log("err in UpdateReservationStatus", err);
            return;
          }
          if (response) {
            console.log("result in UpdateReservationStatus", response);
            // vm.getReservationDetailById();
            vm.reservationStatusList = response[1];
            vm.$store.dispatch("toastr", {
              type: "success",
              header: "Success!",
              message: response[0][0].GuestReservationMessage,
            });
            vm.getReservationDetailById();
            let NotificationEventID = [],
              NotiSubEventId = null;

            let EventID = [],
              SubEventId = null;
            if (status == 6) {
              // EventID = "3,4";
              // SubEventId = "5,7,9"
              EventID = [
                { eventId: 4, subEventId: "14,16" },
                { eventId: 5, subEventId: 18 },
              ];
              NotificationEventID = [
                { notificationEventId: 4, NotiSubEventId: 14 },
              ];
            } else if (status == 7) {
              // EventID = 4;
              // SubEventId = "8,10"
              EventID = [{ eventId: 5, subEventId: "17,19" }];
              NotificationEventID = [
                { notificationEventId: 5, NotiSubEventId: 17 },
              ];
            } else {
              EventID = [];
              SubEventId = null;
              NotificationEventID = [];
              NotiSubEventId - null;
            }
            for (let event of EventID) {
              vm.getLogIdsByEventID(event.eventId, event.subEventId);
            }
            for (let notificationevent of NotificationEventID) {
              vm.save_Notification(
                notificationevent.notificationEventId,
                notificationevent.NotiSubEventId,
                vm.notificationAmount
              );
            }
          }
        },
      });
    },
    onChangeCity: function (CityId) {
      let vm = this;
      $(".searchResultsCities").hide();
      //console.log("in change method", CityId)
      vm.isCitySelected = true;
      vm.$store.dispatch("dataRequestHandler", {
        key: "GetCityStateCountryById",
        params: {
          ModuleAction: "GetCityStateCountryById",
          CityId: CityId,
        },
        callback: function (err, response) {
          if (err) {
            console.log("Error in change city => ", err);
            return;
          }
          if (response) {
            //console.log("response in GetCityStateCountryById", response);
            let selectedoptions = null;
            selectedoptions = response;
            vm.searchCityOldValue = selectedoptions.CityName;
            vm.searchCountryOldValue = selectedoptions.CountryName;
            vm.searchStateOldValue = selectedoptions.StateName;
            vm.selectedStateAndCountry = selectedoptions;
            vm.searchCity = selectedoptions.CityName;
            vm.searchCountry = selectedoptions.CountryName;
            vm.searchState = selectedoptions.StateName;
            vm.cityList = [];
            vm.isCitySelected = true;
            // vm.isCitySelected = false;
            // $(".searchResultsCities").hide();
          }
        },
      });
    },

    onChangeState: function (state) {
      let vm = this;
      $(".searchResultsCities").hide();
      // vm.selectedStateAndCountry.StateName = state.StateName;
      // vm.selectedStateAndCountry.StateId = state.StateId;
      // vm.searchStateOldValue = state.StateName
      // vm.searchState = state.StateName;
      // vm.stateList = [];
      vm.$store.dispatch("dataRequestHandler", {
        key: "GetCountryByStateId",
        params: {
          ModuleAction: "GetCountryByStateId",
          StateId: state.StateId,
        },
        callback: function (err, response) {
          if (err) {
            console.log("Error in change city => ", err);
            return;
          }
          if (response) {
            console.log("response in GetCountryByStateId", response);
            vm.selectedStateAndCountry.StateName = response[0][0].StateName;
            vm.selectedStateAndCountry.StateId = response[0][0].StateId;
            vm.selectedStateAndCountry.CountryName = response[0][0].CountryName;
            vm.selectedStateAndCountry.CountryId = response[0][0].CountryId;
            vm.searchStateOldValue = response[0][0].StateName;
            vm.searchCountryOldValue = response[0][0].CountryName;
            vm.searchCountry = response[0][0].CountryName;
            vm.searchState = response[0][0].StateName;
          }
        },
      });
    },

    onChangeCountry: function (country) {
      let vm = this;
      $(".searchResultsCities").hide();
      vm.selectedStateAndCountry.CountryName = country.CountryName;
      vm.selectedStateAndCountry.CountryId = country.CountryId;
      vm.searchCountryOldValue = country.CountryName;
      vm.searchCountry = country.CountryName;
      vm.countryList = [];
    },
    closeInfo: function () {},
    saveGuestProfile(accountDetailsObj) {
      let vm = this;
      if (
        (vm.Reservation_Status &&
          vm.Reservation_Status.StatusId != 4 &&
          vm.Reservation_Status.StatusId != 11) ||
        vm.$route.params.ReservationId == "-1"
      ) {
        vm.$store.dispatch("dataRequestHandler", {
          key: "SaveGuestProfile",
          params: {
            ModuleAction: "SaveGuestProfile",
            GuestProfileId: accountDetailsObj.guestProfileId,
            // PropertyId
            // ClientId
            GuestFirstName: accountDetailsObj.accountInfo.GuestFirstName,
            GuestLastName: accountDetailsObj.accountInfo.GuestLastName,
            PhoneNumber: accountDetailsObj.phone[0].PhoneNumber,
            EmailAddress: accountDetailsObj.emails[0].Emailaddress,
            CityId: null,
            StateId: null,
            CountryId: null,
            CountryName: accountDetailsObj.accountInfo.CountryName,
            StateName: accountDetailsObj.accountInfo.StateName,
            CityName: accountDetailsObj.accountInfo.CityName,
            Address1: accountDetailsObj.accountInfo.Address,
            Address2:
              accountDetailsObj.accountInfo.AddressDetails2 ||
              accountDetailsObj.accountInfo.Address2,
            PostalCode: accountDetailsObj.accountInfo.PostalCode,
            ReservationId: vm.guestInfo.ReservationId,
            addmoreEmails: accountDetailsObj.emails,
            addmorePhones: accountDetailsObj.phone,
            StatusId: accountDetailsObj.statusId,
            accountType: accountDetailsObj.accountTypeId,
            // unitId:vm.roomInfo.UnitId
          },
          callback: function (err, response) {
            if (err) {
              return;
            }
            if (response) {
              console.log("saveguestprofile2", response);
              if (response[1][0].AccountType == 3) {
                vm.guestInfo.GuestProfileId = response[1][0].GuestProfileId;
                vm.infoType = response[1][0].AccountType;
                vm.CreateGuestProfile = false;
              }
              if (response[1][0].AccountType == 7) {
                vm.$store.dispatch("toastr", {
                  type: "success",
                  header: "Success",
                  message: "Company Info Saved successfully!",
                });
                if (vm.guestProfileDetails && vm.guestProfileDetails.AccountType && vm.guestProfileDetails.GuestFirstName && vm.guestProfileDetails.GuestLastName) {
                    vm.saveGuestInfo("guestInfo");
                }
                vm.guestInfo.CompanyProfileId = response[1][0].GuestProfileId;
                vm.guestInfo.CompanyProfileName =
                  accountDetailsObj.accountInfo.GuestFirstName;
                vm.infoType = response[1][0].AccountType;
                vm.CreateCompanyProfile = false;
              }
              if (
                vm.guestInfo.ReservationId != -1 &&
                vm.guestInfo.ReservationId != null &&
                vm.guestInfo.ReservationId != undefined &&
                vm.$route.params.ReservationId != -1
              ) {
                vm.guestInfo.IsGuestProfilelinked =
                  response[1][0].IsGuestProfilelinked;
                // vm.guestInfo.IsCompanyProfilelinked = response[1][0].IsCompanyProfilelinked
              }
              vm.Get_GuestProfile_Detail(response[1][0].GuestProfileId);
            }
          },
        });
      }
    },
    saveGuestInfo: function (name) {
      let vm = this;
      vm.$validator.validateAll().then((result) => {
        if (result) {
          vm.displayGuestInfo = name;
          vm.showGuestInfoButton = false;
          let PartyAddressId;
          if (
            vm.$route.params.PartyAddressId === "null" ||
            vm.$route.params.PartyAddressId === null
          ) {
            PartyAddressId = -1;
          } else {
            PartyAddressId = vm.$route.params.PartyAddressId;
          }
          let resStatusId;
          // if (vm.$route.params.ReservationId == -1) {
          //   resStatusId = 10;
          // } else {
          resStatusId = vm.Reservation_Status.StatusId;
          // }
          if (vm.isCitySelected == false) {
            vm.selectedStateAndCountry.CityId = null;
          }
          if (
            (vm.$route.params.ReservationId == -1 &&
              vm.guestInfo.SourceId == null) ||
            (vm.$route.params.ReservationId == -1 &&
              vm.guestInfo.SourceId == "-99")
          ) {
            vm.guestInfo.SourceId = 1;
            vm.$set(vm.guestInfo, "SourceName", "Tempo");
            // vm.guestInfo.sourceName = "Tempo";
          }

          console.log(
            "vm.guestInfo--saveguest-",
            vm.guestProfileDetails,
            vm.$route.params.guestProfileId,
            vm.guestProfileDetails,
            vm.guestInfo
          );
          vm.$store.dispatch("dataRequestHandler", {
            key: "saveReservation_GuestInfo",
            params: {
              ModuleAction: "saveReservation_GuestInfo",
              GuestProfileId:  vm.$route.params.guestProfileId &&  vm.$route.params.accountType == 3 ? vm.$route.params.guestProfileId : vm.guestInfo.GuestProfileId,
                // vm.$route.params.guestProfileId &&
                // vm.guestProfileDetails &&
                // vm.guestProfileDetails.AccountType == 3 &&
                // vm.guestProfileDetails.GuestProfileId ==
                //   vm.$route.params.guestProfileId
                //   ? vm.$route.params.guestProfileId
                //   : vm.guestInfo.GuestProfileId,
              // ClientId,
              CompanyProfileId: vm.$route.params.guestProfileId &&  vm.$route.params.accountType == 7 ? vm.$route.params.guestProfileId : vm.guestInfo.CompanyProfileId,
                // vm.$route.params.guestProfileId &&
                // vm.guestProfileDetails &&
                // vm.guestProfileDetails.AccountType == 7 &&
                // vm.guestProfileDetails.GuestProfileId ==
                //   vm.$route.params.guestProfileId &&
                // vm.guestInfo.CompanyProfileId
                //   ? vm.$route.params.guestProfileId
                //   : vm.guestInfo.DefaultSettingforCompanyprofile &&
                //     vm.guestInfo.CompanyProfileId
                //   ? vm.guestInfo.CompanyProfileId
                //   : null,
              // vm.$route.params.guestProfileId && vm.guestProfileDetails && vm.guestProfileDetails.AccountType == 7 && vm.guestProfileDetails.GuestProfileId == vm.$route.params.guestProfileId ? vm.$route.params.guestProfileId : vm.guestInfo.CompanyProfileId,
              AddressTypeId: 1,
              GuestFirstName: vm.guestInfo.GuestFirstName,
              GuestLastName: vm.guestInfo.GuestLastName,
              PhoneNumber: vm.guestInfo.PhoneNumber,
              Email: vm.guestInfo.Email,
              Address1: vm.guestInfo.Address,
              Address2: vm.guestInfo.AddressDetails2,
              Address3: null,
              PostalCode: vm.guestInfo.PostalCode,
              CityId: null, // vm.selectedStateAndCountry.CityId,
              CountryId: null, // vm.selectedStateAndCountry.CountryId,
              StateId: null, // vm.selectedStateAndCountry.StateId,
              cityName: vm.guestInfo.CityName,
              stateName: vm.guestInfo.StateName,
              countryName: vm.guestInfo.CountryName,

              // StatusId: vm.$route.params.StatusId,
              StatusId: resStatusId,
              PartyAddressId: PartyAddressId,
              SourceId: vm.guestInfo.SourceId,
              SubSourceId: vm.guestInfo.SubSourceId,
              CrsId: 1,
              ReservationId: vm.guestInfo.ReservationId,
              unitId: vm.roomInfo.UnitId,
              Ext_ReservationId: vm.guestInfo.ReservationNumber,
              ClientPrice: 0,
              SelectedTags: vm.guestInfo.selectedTags,
              StayInfoId: -1,
              UpdatedDate: null,
              additionalEmails: vm.additionalEmails,
              additionalPhoneNumbers: vm.additionalPhoneNumbers,
            },
            callback: function (err, response) {
              if (err) {
                console.log(err);
                // if (response[2] && response[2][0] && response[2][0].hasOwnProperty(ReservationId)) {
                vm.$store.dispatch("toastr", {
                  type: "error",
                  header: "Error",
                  message: "Error while saving Guest Info!",
                });
                // }
                return;
              }
              if (response) {
                console.log("response in saveReservation_GuestInfo", response);
                if (
                  response[0] &&
                  response[0][0].hasOwnProperty("ErrorMessage") &&
                  response[0][0].ErrorMessage != ""
                ) {
                  console.log("here");
                  vm.$store.dispatch("toastr", {
                    type: "error",
                    header: "Error",
                    message: "Error while saving Guest Info!",
                  });
                } else if (
                  response[2][0].hasOwnProperty("ReservationId") &&
                  response[0][0].ErrorMessage == ""
                ) {
                  vm.$store.dispatch("toastr", {
                    type: "success",
                    header: "Success",
                    message: "Guest Info Saved successfully!",
                  });
                  // vm.getReservationDetailById();
                }
                vm.guestInfo.ReservationId = response[2][0].ReservationId;
                vm.guestInfo.GuestProfileId = response[1][0].GuestProfileId;
                vm.guestInfo.CompanyProfileId = response[1][0].CompanyProfileId;
                vm.Reservation_Status.StatusId = response[2][0].StatusId;
                vm.Reservation_Status.StatusName = response[2][0].StatusName;
                vm.enableStateCountry = false;
                vm.isFromGuestPannel = false;

                if (vm.guestInfo.DefaultSettingforGuestprofile) {
                  // call guestprofilesave
                  console.log("saveguestprofile1");
                  let accountDetailsObjArr = [
                    {
                      guestProfileId: vm.$route.params.guestProfileId && vm.$route.params.accountType == 3 ? vm.$route.params.guestProfileId : vm.guestInfo.GuestProfileId,
                        // vm.guestProfileDetails.AccountType == 3 &&
                        // vm.$route.params.guestProfileId &&
                        // vm.guestProfileDetails.GuestProfileId ==
                        //   vm.$route.params.guestProfileId
                        //   ? vm.$route.params.guestProfileId
                        //   : vm.guestInfo.GuestProfileId,
                      accountInfo: vm.guestInfo,
                      emails: vm.additionalEmails,
                      phone: vm.additionalPhoneNumbers,
                      statusId:
                        vm.$route.params.ReservationId == "-1"
                          ? 1
                          : vm.guestInfo.StatusId
                          ? vm.guestInfo.StatusId
                          : 1,
                      accountTypeId: 3,
                    },
                  ];
                  // if (vm.companyInfo && vm.companyInfo.GuestFirstName) {
                  //   accountDetailsObjArr.push({
                  //     guestProfileId: vm.$route.params.guestProfileId ? vm.$route.params.guestProfileId : vm.companyInfo.GuestProfileId,
                  //     accountInfo: vm.companyInfo,
                  //     emails: vm.additionalCompanyEmails,
                  //     phone: vm.additionalCompanyPhoneNumbers,
                  //     statusId: vm.$route.params.ReservationId == '-1' ? 1 : vm.companyInfo.StatusId ? vm.companyInfo.StatusId : 1,
                  //     accountTypeId: 7
                  //   })
                  // }
                  for (let accountDetailsObj of accountDetailsObjArr) {
                    vm.saveGuestProfile(accountDetailsObj);
                  }
                }
                // console.log('vm.roomInfo', vm.roomInfo);
                // // calling below function to Save room information simultaneously with saving guest information.
                // if (vm.roomInfo && vm.roomInfo.isActive) {
                //   vm.saveRoomInfo(1, 'assignRoomModule');
                // }

                // calling below function to Save room information simultaneously with saving guest information.
                var selectedUnitStartDate = vm.$store.state.selectedUnitData.SaleStartDate ? moment(vm.$store.state.selectedUnitData.SaleStartDate).format('YYYY-MM-DD') : null;
                var selectedUnitEndDate = vm.$store.state.selectedUnitData.SaleEndDate ? moment(vm.$store.state.selectedUnitData.SaleEndDate).format('YYYY-MM-DD') : null;
                if(vm.roomInfo && vm.roomInfo.isActive){
                  if (selectedUnitStartDate != null && selectedUnitEndDate != null &&
                    vm.roomInfo.formattedStartDate >= selectedUnitStartDate &&
                    vm.roomInfo.formattedEndDate <= selectedUnitEndDate
                  ) {
                      vm.saveRoomInfo(1, 'assignRoomModule');
                  }else if(selectedUnitStartDate != null && selectedUnitEndDate === null &&
                      vm.roomInfo.formattedStartDate >= selectedUnitStartDate
                    ) {
                      vm.saveRoomInfo(1, 'assignRoomModule');
                    }
                    else if(selectedUnitStartDate === null && selectedUnitEndDate === null
                    ) {
                      vm.saveRoomInfo(1, 'assignRoomModule');
                    }
                  else {
                      vm.$store.dispatch("toastr", {
                        type: "error",
                        header: "Error",
                        message: "Reservation is not allowed for dates that are blocked or unavailable.",
                      });
                  }
                }
              }
              //    if(vm.$route.params.ReservationId != "-1" || vm.$route.params.ReservationId == "-1" ){
              //     if((vm.guestInfo.CountryName != "" || vm.guestInfo.CountryName != null ) && (vm.guestInfo.StateName != "" || vm.guestInfo.StateName != null)  && vm.guestInfo.CountryName == "United States" ){
              //        vm.$set(vm.guestInfo, "CountryName", "");
              //        vm.$set(vm.guestInfo, "CityName", vm.guestInfo.CityName);
              //        vm.$set(vm.guestInfo, "StateName",vm.guestInfo.StateName);

              //     }
              //     else if((vm.guestInfo.CountryName != "" || vm.guestInfo.CountryName != null ) && (vm.guestInfo.StateName != "" || vm.guestInfo.StateName != null)  && vm.guestInfo.CountryName != "United States"){
              //        vm.$set(vm.guestInfo, "CountryName",vm.guestInfo.CountryName);
              //        vm.$set(vm.guestInfo, "CityName", "");
              //        vm.$set(vm.guestInfo, "StateName", "");

              //     }
              //       else{
              //        vm.$set(vm.guestInfo, "CountryName",vm.guestInfo.CountryName);
              //        vm.$set(vm.guestInfo, "CityName", vm.guestInfo.CityName);
              //        vm.$set(vm.guestInfo, "StateName", vm.guestInfo.StateName);
              // }

              // }
            },
          });
        }
      });
    },
    saveCompanyInfo: function (name) {
      let vm = this;
      console.log(
        "vm.companyInfo---",
        vm.companyInfo,
        vm.guestInfo,
        vm.$route.params.guestProfileId
      );
      vm.$validator.validateAll().then((result) => {
        if (result) {
          if (vm.companyInfo && vm.companyInfo.GuestFirstName) {
            let companyAccountDetailsObjArr = [
              {
                // account issue fix next line
                guestProfileId: vm.$route.params.guestProfileId && vm.$route.params.accountType == 7 ? vm.$route.params.guestProfileId : vm.companyInfo.CompanyProfileId ? vm.companyInfo.CompanyProfileId : vm.guestInfo.CompanyProfileId,
                  // vm.guestProfileDetails &&
                  // vm.guestProfileDetails.AccountType == 7 &&
                  // vm.$route.params.guestProfileId
                  //   ? vm.$route.params.guestProfileId
                  //   : !vm.guestInfo.CompanyProfileId ||
                  //     vm.companyInfo.GuestProfileId !=
                  //       vm.guestInfo.CompanyProfileId
                  //   ? vm.companyInfo.GuestProfileId
                  //   : vm.guestInfo.CompanyProfileId,
                // vm.guestInfo.CompanyProfileId,

                accountInfo: vm.companyInfo,
                emails: vm.additionalCompanyEmails,
                phone: vm.additionalCompanyPhoneNumbers,
                statusId:
                  vm.$route.params.ReservationId == "-1"
                    ? 1
                    : vm.companyInfo.StatusId
                    ? vm.companyInfo.StatusId
                    : 1,
                accountTypeId: 7,
              },
            ];
            console.log(
              "vm.$route.params.guestProfileId---",
              vm.guestInfo.CompanyProfileId,
              companyAccountDetailsObjArr[0].guestProfileId
            );
            vm.saveGuestProfile(companyAccountDetailsObjArr[0]);
          }
        }
      });
    },
    closeEmailDropdown() {
      let vm = this;
      vm.emailList = [];
      // vm.showEmailDropdown = false;
    },
    saveNotesDetails(noteId, noteStatusId, sendEmail, Module) {
      let vm = this;
      // console.log("saveNotesDetails noteid", noteId,vm.guestInfo,vm.$route.params);
      if (Module == "noteModule") {
        if (noteStatusId == 2) {
          vm.notesDetailById.noteStatusId = 0;
        }
      }
      console.log("noteId", noteId);
      if (
        vm.$route.params.ReservationId == -1 &&
        vm.guestInfo.ReservationId == -1
      ) {
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning",
          message: "Please Enter Guest Info!",
        });
        return;
      }
      // if (
      //   (!vm.guestInfo.CompanyProfileId ||
      //   vm.guestInfo.CompanyProfileId == -1) && vm.$route.params.guestProfileId
      // ) {
      //   vm.$store.dispatch("toastr", {
      //     type: "warning",
      //     header: "Warning",
      //     message: "Please Save Company Info!"
      //   });
      //   return;
      // }
      if (
        vm.notesDetailById.isActionReqd &&
        (vm.notesDetailById.dateOrTimeDue === null ||
          vm.notesDetailById.dateOrTimeDue === "" ||
          vm.notesDetailById.dateOrTimeDue === undefined)
      ) {
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning",
          message: "Please Enter Due Date!",
        });
        return;
      }
      if (
        vm.notesDetailById.noteTypeId == 2 &&
        vm.notesDetailById.isActionReqd
      ) {
        if (
          vm.notesDetailById.taskTypeId === null ||
          vm.notesDetailById.taskTypeId === "" ||
          vm.notesDetailById.taskTypeId === undefined
        ) {
          vm.$store.dispatch("toastr", {
            type: "warning",
            header: "Warning",
            message: "Please Enter Task Type!",
          });
          return;
        }
      }
      //console.log("notesDetailById", vm.notesDetailById);
      vm.displayNotesDetail = "NotesDetail";
      vm.showNotesDetailButton = false;
      let noteIdToSend;

      if (!noteId || noteId == -99) {
        noteIdToSend = -1;
      } else {
        noteIdToSend = noteId;
      }
      let DateOrTimeDue;
      if (
        vm.notesDetailById.dateOrTimeDue === null ||
        vm.notesDetailById.dateOrTimeDue === "" ||
        vm.notesDetailById.dateOrTimeDue === undefined
      ) {
        DateOrTimeDue = null;
      } else {
        DateOrTimeDue = moment(vm.notesDetailById.dateOrTimeDue).format(
          "YYYY-MM-DD"
        );
      }
      if (
        vm.notesDetailById.isActionReqd === null ||
        vm.notesDetailById.isActionReqd === undefined ||
        vm.notesDetailById.isActionReqd === ""
      ) {
        vm.notesDetailById.isActionReqd = 0;
      }
      if (vm.notesDetailById.isAutoGenerated != 1) {
        vm.notesDetailById.isAutoGenerated = 0;
      }
      vm.$store.dispatch("dataRequestHandler", {
        key: "SaveNotesDetails",
        params: {
          ModuleAction: "SaveNotesDetails",
          ReservationId: vm.guestInfo.ReservationId,
          NoteId: noteIdToSend,
          NoteTypeId: vm.notesDetailById.noteTypeId,
          noteStatusId: vm.notesDetailById.noteStatusId,
          taskTypeId: vm.notesDetailById.taskTypeId,
          isAutoGenerated: vm.notesDetailById.isAutoGenerated,
          NoteSubject: vm.notesDetailById.noteSubject,
          NoteDetails: vm.notesDetailById.noteDetails,
          IsActionReqd: vm.notesDetailById.isActionReqd,
          DateOrTimeDue: DateOrTimeDue,
          unitId: vm.roomInfo.UnitId,
          reCalculateFolio: vm.tempSaveAssignRoomParams
            ? vm.tempSaveAssignRoomParams.reCalculateFolio
            : vm.notesDetailById.isActionReqd
            ? true
            : false,
          sendEmail: sendEmail,
        },
        callback: function (err, response) {
          if (err) {
            console.log("error", err);
            vm.$store.dispatch("toastr", {
              type: "error",
              header: "Error",
              message: "Error While Saving Notes!",
            });
            return;
          }
          if (response) {
            console.log("response in saveNotesDetails", response);
            if (response[1] && response[1][0] && response[1][0].ErrorMessage) {
              vm.$store.dispatch("toastr", {
                type: "error",
                header: "Error",
                message: "Error While Saving Notes!",
              });
            } else if (
              noteId &&
              noteId != -99 &&
              !response[1][0].ErrorMessage
            ) {
              vm.$store.dispatch("toastr", {
                type: "success",
                header: "Success!",
                message: "Note Saved Successfully",
              });
            }
            if (
              response[0] &&
              response[0].length > 0 &&
              response[0][0].NoteId
            ) {
              console.log("noted id .............");
              vm.getNotesDetailsById(response[0][0].NoteId,null);
              //  vm.notesDetailById.noteId = response[0][0].NoteId
            }
            vm.getNotesDetails();
            let foliochange = "";
            if (
              vm.notesDetailById.taskTypeId &&
              (vm.notesDetailById.taskTypeId == 1 ||
                vm.notesDetailById.taskTypeId == 2)
            ) {
              foliochange = "folioChange";
            }
            vm.getFolioSummary(false, foliochange);
            vm.companyInfo = {};
          }
        },
      });
    },
    showAmenitiesListFnc() {
      this.showAmenitiesList = true;
    },

    // saveAccomodationInfo: function(name){

    // },
    saveFolioDetail: function (name) {
      this.displayFolioDetail = name;
      this.showFolioDetailButton = false;
    },
    getFolioSummary(fromPayment, foliochangedornot) {
      let vm = this;
      if (fromPayment) {
        vm.show = false;
        vm.showPayments = true;
      } else {
        vm.show = true;
        vm.showPayments = false;
      }
      // console.log("getFolioSummary resId", vm.guestInfo.ReservationId)
      vm.folioDateChange = false;
      console.log("vm.selectedLedger", vm.selectedLedger);
      vm.$store.dispatch("dataRequestHandler", {
        key: "Get_FolioSummary",
        params: {
          ModuleAction: "Get_FolioSummary",
          ReservationId: vm.guestInfo.ReservationId,
          ledgerAccountId:
            vm.selectedLedger && vm.selectedLedger.ledgerAccountID != null
              ? vm.selectedLedger.ledgerAccountID
              : null,
          Amount:
            vm.selectedLedger && vm.selectedLedger.defaultAmount != null
              ? vm.selectedLedger.defaultAmount
              : vm.selectedLedger && vm.selectedLedger.TaxAmount != null
              ? vm.selectedLedger.TaxAmount
              : null,
          DateEffective:
            vm.selectedLedger && vm.selectedLedger.dateEffective != null
              ? moment(vm.selectedLedger.dateEffective).format("YYYY-MM-DD")
              : null,
          IsFolioEdit:
            vm.selectedLedger && vm.selectedLedger.dateEffective != null
              ? 1
              : 0,
        },
        callback: function (err, response) {
          if (err) {
            console.log("Error in getFolioSummary => ", err);
            return;
          }
          if (response) {
            console.log("response in GetFolioSummary", response);
            vm.folioSummaryDetail = response[0];
            vm.ShowLessfolioItemsDetails = response[0].slice(0, 5);
            for (let fIndex = 0; fIndex < response[1].length; fIndex++) {
              response[1][fIndex]["ActualDateEffective"] =
                response[1][fIndex]["DateEffective"];
            }
            vm.folioItemsDetails = response[1];
            for (var i = 0; i < vm.folioItemsDetails.length; i++) {
              vm.folioItemsDetails[i].Ischecked = "";
            }
            for (let folioItem of vm.folioItemsDetails) {
              vm.previousFolioItemDetails.push(Object.assign({}, folioItem));
            }
            // vm.previousFolioItemDetails.splice(0, vm.previousFolioItemDetails.length, ...vm.folioItemsDetails)
            vm.folioCharges = response[2][0];
            vm.LedgerAcounts = response[3];

            if (foliochangedornot == "folioChange") {
              if (
                vm.previousRoomInfo.folioCharges &&
                vm.previousRoomInfo.folioCharges.TotalValue !=
                  vm.folioCharges.TotalValue
              ) {
                // vm.getLogIdsByEventID(2, 9)
              }
            }

            vm.previousRoomInfo.folioCharges = vm.folioCharges;
            vm.roomInfo.unitCharges = vm.folioSummaryDetail[0].Charges;
            let voidedItems = vm.folioItemsDetails.filter(function (fItem) {
              return fItem.IsVoided;
            });
            if (voidedItems && voidedItems.length > 0)
              vm.voidedItemsCount = voidedItems.length;
            if (
              vm.selectedLedger &&
              vm.selectedLedger.dateEffective != null &&
              response[4] &&
              response[4].length
            ) {
              vm.previewItems = [];
              vm.previewItems = response[4];
            }
          }
        },
      });
    },
    getFolioItemsDetail() {
      let vm = this;
      vm.show = true;
      vm.showPayments = false;
      vm.showBTInvoice = false;
      vm.showAddPaymentDetail = false;
      vm.disableMultiProcess = false;
      vm.parentPaymentitemObj.PendingchildPaymentitems = [];
      vm.pendingPaymentDetails.splice(vm.pendingPaymentDetails.length - 1, 1);
      vm.showNextProcessButton = true;
    },

    getPaymentsDetail() {
      let vm = this;
      vm.showPayments = true;
      vm.show = false;
      vm.showPaymentDetails = false;
      vm.showBTInvoice = false;
    },
    getBalananceTransferInvoiceDetails() {
      let vm = this;
      vm.showBTInvoice = true;
      vm.showPayments = false;
      vm.show = false;
    },
    GetSubSourceList(Crs, SourceId) {
      let vm = this;
      // vm.guestInfo.SourceName
      console.log("!isNaN(Crs)", Crs, SourceId);
      // if (SourceId) {
      if (vm.guestInfo.CrsId == "-99") {
        vm.guestInfo.CrsConfirmationNumber = "";
      }

      vm.$store.dispatch("dataRequestHandler", {
        key: "GetSubSourceList",
        params: {
          ModuleAction: "GetSubSourceList",
          SourceId: vm.guestInfo.SourceId,
          CrsId: vm.guestInfo.CrsId,
        },
        callback: function (err, response) {
          if (err) {
            console.log("Error in GetSubSourceList => ", err);
            return;
          }
          if (response) {
            console.log("response in GetSubSourceList", response);
            vm.sourceList.splice(0, vm.sourceList.length, ...response[2]);
            vm.subSourceList.splice(0, vm.subSourceList.length, ...response[1]);

            let SourceName = vm.sourceList.filter(
              (source) => source.sourceID == vm.guestInfo.SourceId
            );
            if (SourceName.length) {
              vm.guestInfo.SourceName = SourceName[0].sourceName;
              vm.guestInfo.SourceId = SourceName[0].sourceID;
              vm.guestInfo.SubSourceName = null;
              vm.guestInfo.SubSourceId = -99;
            } else {
              vm.guestInfo.SubSourceId = "-99";
              vm.guestInfo.SourceId = "-99";
            }
          }
        },
      });
      // }
    },
    getSubSourceName(SubSourceId) {
      let vm = this;
      let SubSourceName = vm.subSourceList.filter(
        (source) => source.SubSourceId == SubSourceId
      );
      console.log("SubSourceName", SubSourceName);
      if (SubSourceName.length) {
        vm.guestInfo.SubSourceName = SubSourceName[0].SubSourceName;
      }
    },
    displaySection(name, event, profileType) {
      // if (this.$store.state.userEntitlementList.fncHousekeepingTaskList.isAssigned === 1 || this.$store.state.userEntitlementList.fncHousekeepingTaskList.isAssigned === "1") {
      //   return
      // }
      this.showGuestProfileDetail = false;
      if(this.$route.params.ReservationId == "-1"){
        this.selectedNote = {};
      }
      if (
        this.$store.state.userEntitlementList &&
        this.$store.state.userEntitlementList.fncReservationList.isAssigned ===
          1 &&
        this.$store.state.userEntitlementList.fncHousekeeper.isAssigned === 1 &&
        (this.$store.state.userEntitlementList.fncReservationSave.isAssigned ===
          1 ||
          this.$store.state.userEntitlementList.fncReservationUpdate
            .isAssigned === 1)
      ) {
        this.displaySectionValue = name;
      } else if (
        this.$store.state.userEntitlementList.fncReservationList.isAssigned ===
          1 &&
        this.$store.state.userEntitlementList.fncHousekeeper.isAssigned === 1
      ) {
        this.displaySectionValue = "reservation4";
      } else {
        this.displaySectionValue = name;
      }
      if (name != "reservation4") {
        for (let note of this.notes) {
          note.showEditIcon = 0;
          note.highLightActive = 0;
        }
      }
      // this.displaySectionValue = name;
      console.log("this.displaySectionValue = name", this.displaySectionValue);

      if (name === "showBookedBy") {
        this.Color = "active";
        this.showMessages = true;
        this.showCompanyProfileData = false;
        this.showGuestProfileData = false;
        this.showEditDetails = false;
        event.stopPropagation();
      } else if (name === "companyProfile" && profileType == "company") {
        this.ShowCompanyData = "company";
        this.displaySectionValue = name;
        this.showguestinfo = true;
        this.showCompanyProfileData = false;
        this.showGuestProfileData = false;
        this.showEditDetails = true;
        this.showMessages = false;
        if (this.guestInfo.CompanyProfileId) {
          this.Get_GuestProfile_Detail(this.guestInfo.CompanyProfileId);
        }
        event.stopPropagation();
      } else if (name === "reservation1") {
        // alert("hai")
        this.ShowCompanyData = profileType;
        this.showdeclineRequestReservation = false;
        this.showCompanyProfileData = false;
        this.showGuestProfileData = false;
        this.showEditDetails = false;
        this.showMessages = false;
        this.isBgColor1 = true;
        this.isBgColor3 = false;
        this.isBgColor2 = false;
        this.isBgColor4 = false;
        this.isBgColor5 = false;
        this.isBgColor6 = false;
        this.isBgColor7 = false;
        (this.Color = null), (this.checkinedit = true);
        this.checkoutedit = true;
        this.showBookedBy = false;
        this.showguestinfo = true;
        this.checkinput = false;
        this.checkoutput = false;
        this.addressAndZipcodeShow = false;
        this.showPaymentDetails = false;
        this.showPaymentList = true;
        this.showAddPaymentDetail = false;
        this.parentPaymentitemObj.PendingchildPaymentitems = [];
        this.pendingPaymentDetails.splice(
          this.pendingPaymentDetails.length - 1,
          1
        );
        this.showNextProcessButton = true;

        if (profileType == "Guest") {
          // event.stopPropagation()
        }
        // console.log("disp---",this.guestInfo);
        if (this.guestInfo.AccountType && this.guestInfo.AccountType != 3) {
          this.guestInfo.PostalCode = "";
          this.guestInfo.Address = "";
          this.guestInfo.shortAddress = "";
        }
      } else if (name === "reservation2") {
        this.showdeclineRequestReservation = false;
        this.showCompanyProfileData = false;
        this.showGuestProfileData = false;
        this.showEditDetails = false;
        this.showMessages = false;
        this.isBgColor2 = true;
        this.isBgColor1 = false;
        this.isBgColor3 = false;
        this.isBgColor4 = false;
        this.isBgColor5 = false;
        this.isBgColor6 = false;
        this.isBgColor7 = false;
        this.addressAndZipcodeShow = false;
        this.showPaymentDetails = false;
        this.showPaymentList = true;
        this.showAddPaymentDetail = false;
        this.parentPaymentitemObj.PendingchildPaymentitems = [];
        this.pendingPaymentDetails.splice(
          this.pendingPaymentDetails.length - 1,
          1
        );
        this.showNextProcessButton = true;
      } else if (name === "reservation3") {
        this.showdeclineRequestReservation = false;
        this.showCompanyProfileData = false;
        this.showGuestProfileData = false;
        this.showEditDetails = false;
        this.showMessages = false;
        // this.isBgColor3 = true;
        this.isBgColor6 = true;
        this.isBgColor2 = false;
        this.isBgColor1 = false;
        this.isBgColor4 = false;
        this.isBgColor5 = false;
        this.isBgColor7 = false;

        this.checkinedit = true;
        this.checkoutedit = true;
        this.checkinput = false;
        this.checkoutput = false;
        this.addressAndZipcodeShow = false;
        this.showPaymentDetails = false;
        this.showPaymentList = true;
        this.showAddPaymentDetail = false;
        this.parentPaymentitemObj.PendingchildPaymentitems = [];
        this.pendingPaymentDetails.splice(
          this.pendingPaymentDetails.length - 1,
          1
        );
        this.showNextProcessButton = true;
      } else if (name === "reservation4") {
        this.showdeclineRequestReservation = false;
        this.showCompanyProfileData = false;
        this.showGuestProfileData = false;
        this.showEditDetails = false;
        this.showMessages = false;
        //console.log("in section 4")
        this.isBgColor3 = false;
        this.isBgColor2 = false;
        this.isBgColor1 = false;
        this.isBgColor4 = true;
        this.isBgColor5 = false;
        this.isBgColor6 = false;
        this.isBgColor7 = false;
        this.checkinedit = true;
        this.checkoutedit = true;
        this.checkinput = false;
        this.checkoutput = false;
        this.addressAndZipcodeShow = false;
        this.showPaymentDetails = false;
        this.showPaymentList = true;
        this.showAddPaymentDetail = false;
        this.parentPaymentitemObj.PendingchildPaymentitems = [];
        this.pendingPaymentDetails.splice(
          this.pendingPaymentDetails.length - 1,
          1
        );
        this.showNextProcessButton = true;
      } else if (name === "reservation5") {
        this.showdeclineRequestReservation = false;
        this.showCompanyProfileData = false;
        this.showGuestProfileData = false;
        this.showEditDetails = false;
        this.showMessages = false;
        this.isBgColor3 = true;
        this.isBgColor2 = false;
        this.isBgColor1 = false;
        this.isBgColor4 = false;
        this.isBgColor5 = false;
        this.isBgColor6 = false;
        this.isBgColor7 = false;
        this.addressAndZipcodeShow = false;
        this.showPaymentDetails = false;
        this.showPaymentList = true;
        this.getFolioItemsDetail();
        this.showAddPaymentDetail = false;
        this.disableMultiProcess = false;
        this.parentPaymentitemObj.PendingchildPaymentitems = [];
        this.pendingPaymentDetails.splice(
          this.pendingPaymentDetails.length - 1,
          1
        );
        this.showNextProcessButton = true;
      } else if (name === "CustomFields") {
        this.showdeclineRequestReservation = false;
        this.showCompanyProfileData = false;
        this.showGuestProfileData = false;
        this.showEditDetails = false;
        this.showMessages = false;
        this.isBgColor2 = false;
        this.isBgColor1 = false;
        this.isBgColor3 = false;
        this.isBgColor4 = false;
        this.isBgColor5 = false;
        this.isBgColor6 = false;
        this.isBgColor7 = true;
        this.displaySectionValue = name;
        this.addressAndZipcodeShow = false;
        this.showPaymentDetails = false;
        this.showPaymentList = true;
        this.showAddPaymentDetail = false;
        this.parentPaymentitemObj.PendingchildPaymentitems = [];
        this.pendingPaymentDetails.splice(
          this.pendingPaymentDetails.length - 1,
          1
        );
        this.showNextProcessButton = true;
      }

      this.showPaymentOptions = false;
    },
    getReservationDetailById() {
      let scope = this;
      scope.loading = true;
      // if(scope.prevRoute.name =="CalendarView" || scope.prevRoute.name =="ReservationList" || scope.prevRoute.name == "HouseKeepingStatus"){
      console.log("scope.prevRoute", scope.prevRoute);
      // }

      if (scope.$route.params.ReservationId !== "-1") {
        if (this.$route.query.name == "fromSummary") {
          scope.searchByUnit = true;
          scope.displayGuestInfo = "guestInfo";
          scope.showGuestInfoButton = false;
          scope.displayAccomodationInfo = "accomodationInfo";
          scope.showAccomodationInfoButton = false;
          scope.displayFolioDetail = "FolioDetail";
          scope.showFolioDetailButton = false;
          scope.displayNotesDetail = "NotesDetail";
          scope.showNotesDetailButton = false;
          scope.displaySectionValue = "reservation2";
          this.isBgColor2 = true;
          this.isBgColor1 = false;
          this.isBgColor3 = false;
          this.isBgColor4 = false;
          this.isBgColor5 = false;
          this.isBgColor6 = false;
          this.isBgColor7 = false;
          this.addressAndZipcodeShow = false;
          this.showPaymentDetails = false;
          this.showPaymentList = true;
          this.showAddPaymentDetail = false;
          this.parentPaymentitemObj.PendingchildPaymentitems = [];
          this.pendingPaymentDetails.splice(
            this.pendingPaymentDetails.length - 1,
            1
          );
          this.showNextProcessButton = true;
        } else {
          scope.displayGuestInfo = "guestInfo";
          scope.showGuestInfoButton = false;
          scope.displayAccomodationInfo = "accomodationInfo";
          scope.showAccomodationInfoButton = false;
          scope.displayFolioDetail = "FolioDetail";
          scope.showFolioDetailButton = false;
          scope.displayNotesDetail = "NotesDetail";
          scope.showNotesDetailButton = false;
          // scope.displaySectionValue = "reservation1";

          if (
            scope.$store.state.userEntitlementList.fncReservationList
              .isAssigned === 1 &&
            scope.$store.state.userEntitlementList.fncHousekeeper.isAssigned ===
              1 &&
            (scope.$store.state.userEntitlementList.fncReservationSave
              .isAssigned === 1 ||
              scope.$store.state.userEntitlementList.fncReservationUpdate
                .isAssigned === 1)
          ) {
            scope.displaySectionValue = "showBookedBy";
            this.isBgColor1 = false;
            this.isBgColor3 = false;
            this.isBgColor2 = false;

            this.isBgColor4 = false;
            this.isBgColor5 = false;
            this.isBgColor6 = false;
            this.isBgColor7 = false;
            // this.showBookedBy = true;
          } else if (
            scope.$store.state.userEntitlementList.fncReservationList
              .isAssigned === 1 &&
            scope.$store.state.userEntitlementList.fncHousekeeper.isAssigned ===
              1
          ) {
            scope.displaySectionValue = "reservation4";
            this.isBgColor4 = true;
            this.isBgColor3 = false;
            this.isBgColor2 = false;
            this.isBgColor1 = false;
            this.isBgColor5 = false;
            this.isBgColor6 = false;
            this.isBgColor7 = false;
          } else {
            scope.displaySectionValue = "showBookedBy";
            this.isBgColor1 = false;
            this.isBgColor3 = false;
            this.isBgColor2 = false;

            this.isBgColor4 = false;
            this.isBgColor5 = false;
            this.isBgColor6 = false;
            this.isBgColor7 = false;
            // this.showBookedBy = true;
          }
        }
      } else {
        scope.displayGuestInfo = "guestInfo";
        scope.showGuestInfoButton = false;
        scope.displayAccomodationInfo = null;
        scope.showAccomodationInfoButton = true;
        scope.displayFolioDetail = null;
        scope.displayNotesDetail = null;
        scope.showNotesDetailButton = true;
        // scope.roomInfo.dateObj = {};
        scope.showFolioDetailButton = true;
        // scope.companyInfo = {};
        scope.displaySectionValue = "reservation1";
        scope.ShowCompanyData = "Guest";
        scope.showguestinfo = true;
        // if ((scope.$store.state.userEntitlementList.fncReservationList.isAssigned === 1 || scope.$store.state.userEntitlementList.fncReservationSave.isAssigned === 1 || scope.$store.state.userEntitlementList.fncReservationUpdate.isAssigned === 1) && scope.$store.state.userEntitlementList.fncHousekeepingTaskList.isAssigned === 1) {
        //   scope.displaySectionValue = "reservation1";
        // }
        // else{
        //   scope.displaySectionValue = "reservation4";
        // }

        if (
          scope.$store.state.userEntitlementList.fncReservationList
            .isAssigned === 1 &&
          scope.$store.state.userEntitlementList.fncHousekeeper.isAssigned ===
            1 &&
          (scope.$store.state.userEntitlementList.fncReservationSave
            .isAssigned === 1 ||
            scope.$store.state.userEntitlementList.fncReservationUpdate
              .isAssigned === 1)
        ) {
          scope.displaySectionValue = "reservation1";
          this.isBgColor1 = true;
          this.isBgColor3 = false;
          this.isBgColor2 = false;
          this.isBgColor4 = false;
          this.isBgColor5 = false;
          this.isBgColor6 = false;
          this.isBgColor7 = false;
        } else if (
          scope.$store.state.userEntitlementList.fncReservationList
            .isAssigned === 1 &&
          scope.$store.state.userEntitlementList.fncHousekeeper.isAssigned === 1
        ) {
          scope.displaySectionValue = "reservation4";
          this.isBgColor4 = true;
          this.isBgColor3 = false;
          this.isBgColor2 = false;
          this.isBgColor1 = false;
          this.isBgColor5 = false;
          this.isBgColor6 = false;
          this.isBgColor7 = false;
        } else {
          scope.displaySectionValue = "reservation1";
          this.isBgColor1 = true;
          this.isBgColor3 = false;
          this.isBgColor2 = false;

          this.isBgColor4 = false;
          this.isBgColor5 = false;
          this.isBgColor6 = false;
          this.isBgColor7 = false;
        }
      }

      //hide pannels other than guestinfo.

      // scope.isBgColor1 = true;
      // scope.isBgColor2 = false;
      // scope.isBgColor3 = false;
      // scope.isBgColor4 = false;
      // scope.isBgColor5 = false;
      // scope.isBgColor6 = false;
      // scope.isBgColor7 = false;
      scope.splitReservations = scope.searchByUnit ? false : true
      scope.showPaymentDetails = false;
      scope.showPaymentOptions = false;
      scope.showAddPaymentDetail = false;
      scope.selectedLedger = {
        dateEffective: null,
        ledgerAccountID: null,
        defaultAmount: null,
        paymentInfoId: null,
        folioItemId: null,
        TaxAmount: null,
      };
      scope.selectedVoidItem = false;
      scope.itemToEdit = null;
      scope.paymentCharges = {};
      scope.paymentDetails = {};
      scope.pendingPaymentDetails.splice(0, scope.pendingPaymentDetails.length);
      scope.selectedPaymentCardDetails = null;
      scope.notesDetailById = {};
      scope.notesDetailById.noteId = -1;
      scope.guestPaymentCards.splice(0, scope.guestPaymentCards.length);
      scope.displayVoidItems = false;
      scope.checkInTime = "00:00 AM";
      scope.checkOutTime = "00:00 AM";
      scope.ShowCheckOut = false;
      scope.ShowCheckIn = false;
      scope.noOfNights = null;
      scope.roomInfo.Nights = null;
      scope.roomInfo.StartDate = null;
      scope.roomInfo.EndDate = null;
      scope.ShowDropdown = false;
      scope.roomInfo.isCheckIn = null;
      scope.roomInfo.isCheckOut = null;
      scope.roomInfo.IsActionEnable = null;
      scope.roomInfo.originalEndDate = null;
      scope.roomInfo.originalStartDate = null;
      scope.filteredAmenities.splice(0, scope.filteredAmenities.length);
      scope.filteredProperties.splice(0, scope.filteredProperties.length);
      scope.filteredUnitClasses.splice(0, scope.filteredUnitClasses.length);
      scope.filteredUnitTypes.splice(0, scope.filteredUnitTypes.length);
      scope.filteredRatePlans.splice(0, scope.filteredRatePlans.length);
      scope.selectedRatePlan = null;
      // scope.filteredPromocode.splice(0, scope.filteredPromocode.length);
      scope.filterSearchPromoCodeText = null;
      scope.Reservation_Status.StatusId = 10;
      scope.Reservation_Status.StatusName = "Inquiry";
      scope.previousRoomInfo = {};
      this.$store.dispatch("dataRequestHandler", {
        key: "GetReservationDetailById",
        params: {
          ModuleAction: "GetReservationDetailById",
          ReservationId: scope.$route.params.ReservationId,
        },
        callback: function (err, response) {
          if (response) {
            console.log("response in GetReservationDetailById", response);
            scope.propertyId = response.roomInfo.PropertyId;
            scope.getCustomFields();
            scope.getCustomFieldInstances();
            if (!scope.$route.params.guestProfileId) {
              scope.loading = false;
            }

            scope.showGuestProfileDetail = false;
            scope.guestInfo = response.guestInfo;
            // scope.SyncToGuestProfile = scope.guestInfo.IsGuestProfilelinked
            scope.DetailedOrConsolidated = scope.guestInfo.DefaultInvoiceType;
            if (scope.$route.params.guestProfileId) {
              scope.Get_GuestProfile_Detail(
                scope.$route.params.guestProfileId,
                "redirectfromaccount"
              );
              // const oldObject = response[0][0];
              // let noReservationId = Object.assign({}, oldObject, { ReservationId: vm.guestInfo.ReservationId, SourceId: vm.guestInfo.SourceId, SourceName: vm.guestInfo.SourceName, SubSourceName: vm.guestInfo.SubSourceName, SubsourceId: vm.guestInfo.SubsourceId, TempoConfirmationNumber: vm.guestInfo.TempoConfirmationNumber, ClientCode: vm.guestInfo.ClientCode, ClientEmail: vm.guestInfo.ClientEmail, ClientEmailPassword: vm.guestInfo.ClientEmailPassword, ConfirmationNumber: vm.guestInfo.ConfirmationNumber, CrsConfirmationNumber: vm.guestInfo.CrsConfirmationNumber, CrsId: vm.guestInfo.CrsId, CrsName: vm.guestInfo.CrsName, Ext_ConfirmationNumber: vm.guestInfo.Ext_ConfirmationNumber, IsHostMode: vm.guestInfo.IsHostMode, LastminuteBooking: vm.guestInfo.LastminuteBooking, Promocode: vm.guestInfo.Promocode, PropertyAddress: vm.guestInfo.PropertyAddress, PropertyOwnerName: vm.guestInfo.PropertyOwnerName, RatePlanId: vm.guestInfo.RatePlanId, RateplanName: vm.guestInfo.RateplanName, ReservationNumber: vm.guestInfo.ReservationNumber, SubSourceConfirmationNumber: vm.guestInfo.SubSourceConfirmationNumber, emailservice: vm.guestInfo.emailservice, sendemail: vm.guestInfo.sendemail, DefaultSettingforGuestprofile: vm.guestInfo.DefaultSettingforGuestprofile });
              // // noFoo is { foo: undefined, baz: 42 }
              // // this call is also equivalent to this
              // noReservationId = { ...oldObject, ReservationId: vm.guestInfo.ReservationId, SourceId: vm.guestInfo.SourceId, SourceName: vm.guestInfo.SourceName, SubSourceName: vm.guestInfo.SubSourceName, SubsourceId: vm.guestInfo.SubsourceId, TempoConfirmationNumber: vm.guestInfo.TempoConfirmationNumber, ClientCode: vm.guestInfo.ClientCode, ClientEmail: vm.guestInfo.ClientEmail, ClientEmailPassword: vm.guestInfo.ClientEmailPassword, ConfirmationNumber: vm.guestInfo.ConfirmationNumber, CrsConfirmationNumber: vm.guestInfo.CrsConfirmationNumber, CrsId: vm.guestInfo.CrsId, CrsName: vm.guestInfo.CrsName, Ext_ConfirmationNumber: vm.guestInfo.Ext_ConfirmationNumber, IsHostMode: vm.guestInfo.IsHostMode, LastminuteBooking: vm.guestInfo.LastminuteBooking, Promocode: vm.guestInfo.Promocode, PropertyAddress: vm.guestInfo.PropertyAddress, PropertyOwnerName: vm.guestInfo.PropertyOwnerName, RatePlanId: vm.guestInfo.RatePlanId, RateplanName: vm.guestInfo.RateplanName, ReservationNumber: vm.guestInfo.ReservationNumber, SubSourceConfirmationNumber: vm.guestInfo.SubSourceConfirmationNumber, emailservice: vm.guestInfo.emailservice, sendemail: vm.guestInfo.sendemail, DefaultSettingforGuestprofile: vm.guestInfo.DefaultSettingforGuestprofile };
              // console.log("noReservationId", noReservationId)

              // vm.guestInfo = noReservationId;
              // vm.guestInfo.IsGuestProfilelinked = true;
              // vm.CreateGuestProfile = false;
              // // if(){

              // // }
              // // vm.guestInfo.DefaultSettingforGuestprofile = true;
              // vm.additionalEmails = [];
              // vm.additionalPhoneNumbers = [];

              // vm.additionalEmails.push({
              //   ReservationId: "",
              //   Emailaddress:  response[4] && response[4][0] && response[4][0].Emailaddress ? response[4][0].Emailaddress : ''
              // });

              // vm.additionalPhoneNumbers.push({
              //   ReservationId: "",
              //   PhoneNumber: response[5] && response[5][0] && response[5][0].PhoneNumber ? response[5][0].PhoneNumber : ''
              // });
              // vm.displaySectionValue = 'reservation1';
              // vm.showguestinfo = true;
              // // vm.showGuestInfoButton = false;
              // // vm.displayGuestInfo = 'guestInfo'
            } else if (
              scope.guestInfo.GuestProfileId &&
              scope.guestInfo.GuestProfileId != -1 &&
              scope.guestInfo.GuestProfileId != "" &&
              scope.guestInfo.GuestProfileId != null
            ) {
              scope.Get_GuestProfile_Detail();
            }
            (scope.guestPriorStays = []),
              console.log("scope.guestInfoscope.guestInfo==>", scope.guestInfo);

            scope.actualMyValue = scope.RatePlanList.filter(
              (obj) =>
                obj.RatePlan_DisplayName == scope.guestInfo.RateplanName &&
                obj.PromoCodes == scope.guestInfo.Promocode
            );
            scope.myValue =
              scope.actualMyValue && scope.actualMyValue[0]
                ? scope.actualMyValue[0].id
                : null;

            if (!scope.myValue && scope.guestInfo.RatePlanId) {
              let text = scope.guestInfo.Promocode
                ? `${scope.guestInfo.RateplanName}(${scope.guestInfo.Promocode})`
                : scope.guestInfo.RateplanName;
              let rateId = scope.RatePlanList.length + 1;
              let ratePlanObj = {
                ClientId: scope.RatePlanList[0].ClientId,
                DerivedOffsetAmount: null,
                IsDefault: false,
                IsDerived: false,
                IsPercent: false,
                ParentRatePlanId: null,
                PromoCodes: scope.guestInfo.Promocode,
                RatePlanDescription: scope.guestInfo.RateplanName,
                RatePlanId: scope.guestInfo.RatePlanId,
                RatePlan_DisplayName: scope.guestInfo.RateplanName,
                RatePlan_Name: scope.guestInfo.RateplanName,
                StatusId: 1,
                StatusName: "Active",
                UpdateBy: 1,
                UpdatedDate: "2020-01-29T07:17:33.230Z",
                id: rateId,
                text: text,
              };
              scope.actualMyValue = [];
              scope.RatePlanList.push(ratePlanObj);
              scope.actualMyValue.push(ratePlanObj);
              scope.myValue = rateId;
            }

            // if
            scope.guestInfo.SourceId = response.guestInfo.SourceId;
            scope.$set(
              scope.selectedStateAndCountry,
              "CountryId",
              response.guestInfo.CountryId
            );

            scope.$set(
              scope.selectedStateAndCountry,
              "CityId",
              response.guestInfo.CityId
            );

            scope.$set(
              scope.selectedStateAndCountry,
              "StateId",
              response.guestInfo.StateId
            );
            scope.$set(scope.guestInfo, "Address", response.guestInfo.Address);
            if (scope.$route.params.ReservationId == "-1") {
              scope.guestInfo.ReservationId = -1;
              scope.guestInfo.GuestProfileId = -1;
              scope.searchCity = "";
              scope.searchState = "";
              scope.searchCountry = "";
              scope.roomInfo.formattedStartDate = "";
              scope.roomInfo.formattedEndDate = "";
            }
            scope.reservationStatusList = response.reservationStatusObj;
            scope.AmenitiesList = response.amenitiesList;
            scope.additionalEmails = response.additionalEmails;
            scope.additionalPhoneNumbers = response.additionalPhoneNumbers;
            scope.additionalCompanyEmails = [
              { ReservationId: "", Emailaddress: "" },
            ];
            scope.additionalCompanyPhoneNumbers = [
              { ReservationId: "", PhoneNumber: "" },
            ];
            scope.reservationStatusList = response.reservationStatusObj;
            scope.sourceList = response.sourceList;
            scope.subSourceList = response.subSourceList;
            scope.crsList = response.crsList;
            scope.GetSubSourceList(null, null);
            // console.log("response.InventryValue===>",response.InventryValue[0].ActualInventory)
            scope.ActualInventoryValue =
              response.InventryValue[0].ActualInventory;

            if (scope.ActualInventoryValue == 2) {
              scope.honourFolio = true;
            } else {
              scope.honourFolio = false;
            }

            if (
              scope.guestInfo.SourceId == null ||
              scope.guestInfo.SourceId == ""
            ) {
              scope.guestInfo.SourceId = 1;
              scope.guestInfo.SourceName = "Tempo";
            }
            if (scope.guestInfo.CrsId == null || scope.guestInfo.CrsId == "") {
              scope.guestInfo.CrsId = "-99";
            }
            if (
              scope.guestInfo.SubSourceId == null ||
              scope.guestInfo.SubSourceId == ""
            ) {
              scope.guestInfo.SubSourceId = "-99";
            }

            if (
              response.guestInfo.Email &&
              (response.guestInfo.Email !== null ||
                response.guestInfo.Email !== "" ||
                response.guestInfo.Email !== undefined)
            ) {
              let verifyEmailDomain =
                /^[a-zA-Z0-9_.+-]+@(guest.booking|guest.airbnb)\.com$/;
              if (response.guestInfo.Email.match(verifyEmailDomain)) {
                scope.isVerfiedEmailDomain = true;
              } else {
                scope.isVerfiedEmailDomain = false;
              }
            }
            if (response.additionalEmails.length == 0) {
              if (
                scope.isVerfiedEmailDomain == false &&
                response.guestInfo.Email
              )
                scope.additionalEmails.push({
                  ReservationId: "",
                  Emailaddress: response.guestInfo.Email,
                });
              else
                scope.additionalEmails.push({
                  ReservationId: "",
                  Emailaddress: "",
                });
            }
            // additionalPhoneNumbers
            if (response.additionalPhoneNumbers.length == 0) {
              if (response.guestInfo.PhoneNumber) {
                scope.additionalPhoneNumbers.push({
                  ReservationId: "",
                  PhoneNumber: response.guestInfo.PhoneNumber,
                });
              } else
                scope.additionalPhoneNumbers.push({
                  ReservationId: "",
                  PhoneNumber: "",
                });
            }
            if (
              scope.$route.params.ReservationId !== "-1" &&
              response.roomInfo != null &&
              response.roomInfo != {}
            ) {
              scope.roomInfo = response.roomInfo;
              scope.roomInfo.formattedStartDate = moment
                .utc(response.roomInfo.originalStartDate)
                .format("Do MMM YYYY");
              scope.roomInfo.formattedEndDate = moment
                .utc(response.roomInfo.originalEndDate)
                .format("Do MMM YYYY");
              // scope.selectedRoom = response.roomInfo;
              scope.Reservation_Status.StatusId =
                response.roomInfo.Reservation_Status;
              scope.Reservation_Status.StatusName =
                response.roomInfo.StatusName;
              scope.previousRoomInfo = JSON.parse(
                JSON.stringify(response.roomInfo)
              );
              if (
                response.roomInfo.checkInTime &&
                response.roomInfo.checkInTime != null
              ) {
                scope.checkInTime = response.roomInfo.checkInTime;
              }
              if (
                response.roomInfo.checkOutTime &&
                response.roomInfo.checkOutTime != null
              ) {
                scope.checkOutTime = response.roomInfo.checkOutTime;
              }
              // if (
              //  ( response.roomInfo.checkInTime &&
              //   response.roomInfo.checkInTime != null)
              // ) {
              //   var checkinHour = moment(
              //     response.roomInfo.checkInTime,
              //     "hh:mm a"
              //   ).format("hh");
              //   var checkinmin = moment(
              //     response.roomInfo.checkInTime,
              //     "hh:mm a"
              //   ).format("mm");
              //   var checkinmeridian = moment(
              //     response.roomInfo.checkInTime,
              //     "hh:mm a"
              //   ).format("a");
              //   scope.checkinTime.hh = checkinHour;
              //   scope.checkinTime.mm = checkinmin;
              //   scope.checkinTime.a = checkinmeridian;

              //   console.log("checkinHour", checkinHour);
              //   console.log("checkinmin", response.roomInfo.checkInTime);
              // }

              // if (
              //   response.roomInfo.checkOutTime &&
              //   response.roomInfo.checkOutTime != null
              // ) {
              //   var checkoutHour = moment(
              //     response.roomInfo.checkOutTime,
              //     "hh:mm a"
              //   ).format("hh");
              //   var checkoutmin = moment(
              //     response.roomInfo.checkOutTime,
              //     "hh:mm a"
              //   ).format("mm");
              //   var checkoutmeridian = moment(
              //     response.roomInfo.checkOutTime,
              //     "hh:mm a"
              //   ).format("a");
              //   console.log("checkoutHour", checkoutHour);
              //   console.log("checkoutmin", checkoutmin);
              //   console.log(
              //     "response.roomInfo.checkInTime",
              //     response.roomInfo.checkOutTime
              //   );
              //   scope.checkoutTime.hh = checkoutHour;
              //   scope.checkoutTime.mm = checkoutmin;
              //   scope.checkoutTime.a = checkoutmeridian;
              // }

              let diff = moment(response.roomInfo.StartDate).diff(
                scope.today,
                "months"
              );
              // if (Math.abs(diff) >= 6) {
              //   scope.isDateBeforeOrAfterSixMonths = true;
              // }
            }

            // if(scope.$route.params.ReservationId == "-1"){
            //     scope.checkoutTime.hh = "00";
            //     scope.checkoutTime.mm = "00";
            //     scope.checkoutTime.a = "am";
            //     scope.checkinTime.hh = "00";
            //     scope.checkinTime.mm = "00";
            //     scope.checkinTime.a =  "am";
            //   scope.Reservation_Status.StatusId = "";
            //   scope.Reservation_Status.StatusName = "";
            // }

            // if(scope.$route.params.ReservationId != "-1" || scope.$route.params.ReservationId == "-1" ){
            //     if(response.guestInfo.CountryName != "" && response.guestInfo.StateName != null && response.guestInfo.CountryName == "United States" ){

            //        scope.$set(scope.guestInfo, "CountryName", "");
            //        scope.$set(scope.guestInfo, "CityName", response.guestInfo.CityName);
            //        scope.$set(scope.guestInfo, "StateName", response.guestInfo.StateName);

            //     }
            //     else if(response.guestInfo.CountryName != "" && response.guestInfo.StateName != null && response.guestInfo.CountryName != "United States"){

            //        scope.$set(scope.guestInfo, "CountryName",response.guestInfo.CountryName);
            //        scope.$set(scope.guestInfo, "CityName", "");
            //        scope.$set(scope.guestInfo, "StateName", "");

            //     }

            // }
            if (scope.$route.params.ReservationId != "-1") {
              scope.searchCity = response.guestInfo.CityName;
              scope.searchCountry = response.guestInfo.CountryName;
              scope.searchState = response.guestInfo.StateName;
              if (scope.guestInfo.IsGuestProfilelinked == false) {
                scope.CreateGuestProfile = true;
              }
              if (!scope.guestInfo.CompanyProfileId) {
                scope.CreateCompanyProfile = true;
              }
            }
            if (scope.$route.params.ReservationId == "-1") {
              scope.roomInfo.Persons = 2;
              scope.roomInfo.NumberOfAdults = 2;
              scope.roomInfo.NumberOfChildren = 0;
              scope.radioCheck = "AdultsAndChildren";

              // scope.Reservation_Status = {};
              scope.roomInfo.reservationMode = 0;
              // scope.availableRoomsList = [];
              scope.showRooms = false;
              scope.display = false;
              scope.showactualinventory = true;
              scope.isCitySelected = false;
              scope.enableStateCountry = false;
              // scope.radioCheckForAdultsAndChildren =true;
            }

            if (scope.$route.params.ReservationId !== "-1") {
              // scope.roomInfo.numberOfPersonsInfo = response.numberOfPersonsInfo;
              // scope.Reservation_Status.StatusId =
              //   response.numberOfPersonsInfo.Reservation_Status;
              // scope.Reservation_Status.StatusName =
              //   response.numberOfPersonsInfo.StatusName;
              // scope.previousRoomInfo.numberOfPersonsInfo = JSON.parse(
              //   JSON.stringify(response.numberOfPersonsInfo)
              // );
              scope.isCitySelected = false;
              scope.enableStateCountry = false;
              //console.log("scope.Reservation_Status", scope.Reservation_Status);
            }
            if (scope.roomInfo.Persons !== null) {
              scope.radioCheckForAdultsAndChildren = false;
              scope.radioCheckForPersons = true;
              scope.radioCheck = "Persons";
            }
            if (scope.roomInfo.Persons === null) {
              scope.radioCheckForAdultsAndChildren = true;
              scope.radioCheckForPersons = false;
              scope.radioCheck = "AdultsAndChildren";
            }
            // scope.getFolioItemsDetail();
            scope.getFolioSummary(false, null);
            scope.getNotesDetails();

            scope.getBalanceTransferFolioList();

            scope.getPaymentDetails();
            scope.getPaymentCardDetails();
            if (scope.$route.query.name == "fromSummary") {
              scope.GetAvailableRooms();
            }
          }
          if (err) {
            console.log("error in getReservationDetailById", err);
            return;
          }
        },
      });
      scope.fncIsHousekeepingTaskList();
      scope.UnassignAndStatus();
      scope.tagDisabling();
      scope.EditSource();
      scope.CheckInAndOutbuttonAndStatus();
    },
    viewReservationDetailById(currReservationId) {
        let vm = this;
        console.log("windows.location.href", vm.$route.name)
        if (vm.$route.name == "MessageInbox") {
          if (vm.parentCallback) vm.parentCallback();
        }
        vm.$router.push("/newReservation/" + currReservationId.ReservationId);
      },
    addNewNotes(name) {
      let vm = this;
      vm.isBgColor3 = false;
      vm.isBgColor2 = false;
      vm.isBgColor1 = false;
      vm.isBgColor4 = true;
      vm.notesDetailById = { noteId: -1 };
      for (let note of vm.notes) {
        note.highLightActive = 0;
      }
      vm.allowEdit = false;
      vm.selectedNote = {};
    },

    getNotesDetailsById(Id,note) {
      let vm = this;
      vm.selectedNote = note
      vm.getDocuSignDetailNotes(note);
      for (let note of vm.notes) {
        if (note.noteId == Id) {
          note.highLightActive = 1;
        } else {
          note.highLightActive = 0;
        }
      }
      // vm.displaySectionValue = "reservation4";
      vm.$store.dispatch("dataRequestHandler", {
        key: "Get_NotesDetails",
        params: {
          ModuleAction: "Get_NotesDetails",
          ReservationId: vm.guestInfo.ReservationId,
          NoteId: Id,
        },
        callback: function (err, response) {
          if (err) {
            return;
          }
          if (response && response[0][0]) {
            console.log("response in Get_NotesDetails by id", response[0][0]);
            vm.notesDetailById = response[0][0];
            if (vm.notesDetailById.noteStatusId == 2) {
              vm.notesDetailById.isActionReqd = false;
              vm.notesDetailById.dateOrTimeDue = null;
              vm.notesDetailById.taskTypeId = null;
              vm.allowEdit = true;
            } else {
              vm.allowEdit = false;
            }
            vm.notesTypeDropdown = response[1];
            //console.log("vm.notesTypeDropdown", vm.notesTypeDropdown)
          }
        },
      });

      //console.log("ID", Id);
    },
    getNotesDetails() {
      let vm = this;
      vm.$store.dispatch("dataRequestHandler", {
        key: "Get_NotesDetails",
        params: {
          ModuleAction: "Get_NotesDetails",
          ReservationId: vm.guestInfo.ReservationId,
          NoteId: null,
        },
        callback: function (err, response) {
          if (err) {
            return;
          }
          if (response) {
            if (response[0]) {
              console.log("response in Get_NotesDetails", response);
              vm.notes.splice(0);
              if (vm.$route.params.ReservationId != -1) {
                vm.notes = response[0];
                if (vm.notesDetailById && vm.notesDetailById.noteId) {
                  for (let note of vm.notes) {
                    if (note && note.noteId == vm.notesDetailById.noteId) {
                      vm.$set(note, "highLightActive", 1);
                      vm.$set(note, "showEditIcon", 0);
                    } else {
                      vm.$set(note, "highLightActive", 0);
                      vm.$set(note, "showEditIcon", 0);
                    }
                  }
                } else {
                  for (let note of vm.notes) {
                    vm.$set(note, "highLightActive", 0);
                    vm.$set(note, "showEditIcon", 0);
                  }
                }
              }
            }

            vm.notesTypeDropdown = response[1];
            vm.taskTypeDropdown = response[2];
          }
        },
      });
    },
    formatDate_docuSign(date) {
      return moment(date).format('MMM DD YYYY');
    },
    getDocuSignDetailNotes(note) {
      let vm = this;
      vm.$store.dispatch("dataRequestHandler", {
        key: "GetDocuSignDetailNotes",
        params: {
          ModuleAction: "GetDocuSignDetailNotes",
          docusignDocId: note.docusignDocId ? note.docusignDocId : null,
          noteTypeId: note.noteTypeId ? note.noteTypeId : null,
          reservationId: vm.guestInfo.ReservationId ? vm.guestInfo.ReservationId : vm.$route.params.ReservationId,
        },
        callback: function (err, response) {
          if (err) {
            console.log("err in GetDocuSignDetailNotes", err);
            return;
          }
          if (response) {
            console.log("response in GetDocuSignDetailNotes", response);
            vm.docuSignDetailNotes = response;
          }
        },
      });
    },
    downloadDocuSign(note) {
      let vm =  this
      const downloadUrl = note.noteDetails;
      fetch(downloadUrl)
        .then(response => response.blob())
        .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const parts = note.noteDetails.split("/");
            link.download = parts[parts.length - 1]; // You can set the filename dynamically if needed
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        })
        .catch(error => {
            console.error('Error downloading document:', error);
        });
    },
    updateDueDate(key, dateObj) {
      let vm = this;
      vm.notesDetailById.dateOrTimeDue = dateObj
        ? dateObj.format("DD MMM YYYY")
        : null;
    },
    getPaymentCardDetails() {
      let vm = this;
      vm.$store.dispatch("dataRequestHandler", {
        key: "Get_PaymentCardDetails",
        params: {
          ModuleAction: "Get_PaymentCardDetails",
          ReservationId: vm.$route.params.ReservationId,
          PartyTypeId: 5,
        },
        callback: function (err, response) {
          if (err) {
            return;
          }
          if (response) {
            console.log("response in Get_PaymentCardDetails", response);
            vm.cardDetails = response[0];
            vm.guestPaymentCards.splice(
              0,
              vm.guestPaymentCards.length,
              ...response[0]
            );

            for (var x in vm.guestPaymentCards) {
              if (vm.guestPaymentCards[x].ParentStatusId == 1) {
                vm.guestPaymentCards[x].csscolor = "black";
                vm.guestPaymentCards[x].disableSave = false;
              }
              if (vm.guestPaymentCards[x].ParentStatusId == 0) {
                vm.guestPaymentCards[x].csscolor = "grey";
                vm.guestPaymentCards[x].disableSave = true;
              }
            }

            if (vm.guestPaymentCards.length === 1) {
              vm.selectedPaymentCardDetails = vm.guestPaymentCards[0];
              vm.buttonName = "Process";
            } else {
              let defaultPaymentOption = vm.guestPaymentCards.filter(function (
                paymentCard
              ) {
                return paymentCard.IsDefault;
              });

              if (defaultPaymentOption && defaultPaymentOption.length > 0) {
                vm.selectedPaymentCardDetails = defaultPaymentOption[0];
                vm.buttonName = "Process";
              } else {
                vm.selectedPaymentCardDetails = vm.guestPaymentCards[0];
                vm.buttonName = "Process";
              }
            }
            // vm.showingdetails();
            //   for (var x in vm.guestPaymentCards) {
            //   let ccnumber = vm.guestPaymentCards[x].CreditCard;
            //   vm.guestPaymentCards[x].CreditCard = (ccnumber.replace(/(\d{4}(?!\s))/g, "$1 "));

            // }
          }
        },
      });
    },
    GetUserEntitlementsAndDefaultProperty() {
      let vm = this;
      vm.$store.dispatch("dataRequestHandler", {
        key: "GetUserEntitlementsAndDefaultProperty",
        params: {
          ModuleAction: "GetUserEntitlementsAndDefaultProperty",
        },
        callback: function (err, response) {
          if (err) {
            return;
          }
          if (response) {
            console.log(
              "response in GetUserEntitlementsAndDefaultProperty",
              response
            );
            vm.UserProperties = response.properties;
            vm.entitlements = response.userEntitlementList;
            vm.fncIsHousekeepingTaskList();
            vm.UnassignAndStatus();
            vm.tagDisabling();
            vm.EditSource();
            vm.getReservationDetailById();
            // vm.showingPayments();
            // vm.AddPayment();
            // vm.showingPayments();

            // vm.DefaultProperty = response.defaultPropertyId;
          }
        },
      });
    },
    GetAvailableRooms: function () {
      $(".editContainer").scrollTop(0);
      let vm = this;
      let checkedAmenities = [];
      if (vm.filteredAmenities.length > 0) {
        for (
          let filteredAmenitiesIndex = 0;
          filteredAmenitiesIndex < vm.filteredAmenities.length;
          filteredAmenitiesIndex++
        ) {
          checkedAmenities.push(
            vm.filteredAmenities[filteredAmenitiesIndex]["ListId"]
          );
        }
      }
      // let Persons;
      let StartDate;
      let EndDate;
      // if (vm.radioCheck === "Persons") {
      //   Persons = vm.roomInfo.numberOfPersonsInfo.Persons;
      // }
      // else if (vm.radioCheck === "AdultsAndChildren") {
      //   Persons = parseInt(vm.roomInfo.numberOfPersonsInfo.NumberOfAdults) + parseInt(vm.roomInfo.numberOfPersonsInfo.NumberOfChildren)
      // }
      let NumberOfAdults;
      let NumberOfChildren;
      let Persons;
      if (vm.radioCheck === "Persons") {
        Persons = vm.roomInfo.Persons;
        NumberOfAdults = null;
        NumberOfChildren = null;
      } else if (vm.radioCheck === "AdultsAndChildren") {
        Persons = null;
        NumberOfAdults = vm.roomInfo.NumberOfAdults;
        NumberOfChildren = vm.roomInfo.NumberOfChildren;
      }
      //console.log("vm.checkedAmenities", checkedAmenities);
      //console.log("vm.roomInfo.selectedRoom.UnitId", vm.roomInfo.selectedRoom.UnitId)
      //console.log("NumberOfAdults, NumberOfChildren,Persons", NumberOfAdults, NumberOfChildren, Persons)
      if (
        vm.roomInfo.EndDate === "" ||
        vm.roomInfo.EndDate === undefined ||
        vm.roomInfo.EndDate === null ||
        vm.roomInfo.StartDate === "" ||
        vm.roomInfo.StartDate === undefined ||
        vm.roomInfo.StartDate === null
      ) {
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning!",
          message: "Please Select check-in and check-out dates",
        });
      } else if (
        moment(vm.roomInfo.EndDate).isBefore(vm.roomInfo.StartDate) ||
        moment(vm.roomInfo.EndDate).isSame(vm.roomInfo.StartDate)
      ) {
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning!",
          message: "Please check the dates and try again",
        });
      } else if (
        vm.selectedRatePlan &&
        vm.selectedRatePlan.PromocodeRequired &&
        !vm.filterSearchPromoCodeText
      ) {
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning!",
          message: "Please select promocode",
        });
      } else {
        // if (vm.$route.params.ReservationId == -1 || vm.$route.params.ReservationId == null) {
        //   StartDate = null;
        //   EndDate = null;
        // }
        // else {
        //   StartDate = moment(vm.roomInfo.dateObj.StartDate).format("YYYY-MM-DD");
        //   EndDate = moment(vm.roomInfo.dateObj.EndDate).format("YYYY-MM-DD");
        // }
        let resultProperties = vm.filteredProperties.map(
          (obj) => obj.PropertyId
        );
        let resultUnitClasses = vm.filteredUnitClasses.map(
          (obj) => obj.UnitClassId
        );
        let unitTypes = vm.filteredUnitTypes.map((obj) => obj.UnitTypeId);
        // let promoCodes = vm.filteredPromocode.map(obj => obj.Promocode);
        let ratePlans = vm.filteredRatePlans.map((obj) => obj.RatePlanId);
        console.log("shshowactualinventory", vm.showactualinventory);
        if (
          vm.showactualinventory == null ||
          vm.showactualinventory == false ||
          vm.showactualinventory == undefined ||
          vm.showactualinventory == 0
        ) {
          vm.showactualinventory = 0;
        }
        if (vm.showactualinventory == true || vm.showactualinventory == 1) {
          vm.showactualinventory = 1;
        }
        vm.$store.dispatch("dataRequestHandler", {
          key: "GetAvailableRooms",
          params: {
            ModuleAction: "GetAvailableRooms",
            Adults: NumberOfAdults,
            Persons: Persons,
            NoOfChildren: NumberOfChildren,
            PropertyID: resultProperties.toString(),
            UnitClassId: resultUnitClasses.toString(),
            // UnitId: vm.roomInfo.selectedRoom.UnitId,
            StartDate: moment(vm.roomInfo.StartDate).format("YYYY-MM-DD"),
            EndDate: moment(vm.roomInfo.EndDate).format("YYYY-MM-DD"),
            FilteredAmenities: checkedAmenities,
            // PropertyId: vm.roomInfo.selectedRoom.PropertyId,
            reservationId: vm.guestInfo.ReservationId,
            unitTypeIds: unitTypes ? unitTypes.toString() : null,
            searchByUnit: vm.searchByUnit,
            ratePlans:
              vm.selectedRatePlan && vm.selectedRatePlan.RatePlanId
                ? vm.selectedRatePlan.RatePlanId
                : null, //ratePlans ? ratePlans.toString() : null,
            promoCodes: vm.filterSearchPromoCodeText
              ? vm.filterSearchPromoCodeText.Promocode
              : null,
            splitReservations: !vm.searchByUnit ? vm.splitReservations : false,
            // showactualinventory: vm.showactualinventory
          },
          callback: function (err, response) {
            console.log("GetAvailableRooms", response);
            if (err) {
              return;
            }
            if (response) {
              if (
                response.resultSet &&
                response.resultSet[0] &&
                response.resultSet[0].hasOwnProperty("ErrorMessage") &&
                (response.resultSet[0].ErrorMessage !== null ||
                  response.resultSet[0].ErrorMessage !== "" ||
                  response.resultSet[0].ErrorMessage !== undefined)
              ) {
                vm.$store.dispatch("toastr", {
                  type: "error",
                  header: "Error!",
                  message: response.resultSet[0].ErrorMessage,
                });
              } else {
                console.log("response in GetAvailableRooms", response);
                vm.availableRoomsList = [];
                vm.display = true;
                if (
                  response &&
                  response.roomDetailsListObjs &&
                  response.roomDetailsListObjs.length > 0
                ) {
                  vm.showRooms = true;
                  vm.availableRoomsList = response.roomDetailsListObjs;
                  let unitData = vm.sharedSelectedUnitData
                  let selUnitId = unitData.IsAssigned != 0 ? unitData.UnitId : unitData.UnitTypeId
                  if(unitData && selUnitId){
                    let  RatePlan = vm.RatePlanList.filter(rateplan => rateplan.id == vm.myValue)
                    
                    let roomInfoData = vm.availableRoomsList.filter(room=>room.UnitId == selUnitId)
                    // let  RatePlanObj = roomInfoData[0].ratePlanList.filter(rateplan => rateplan.RatePlanId == RatePlan[0].RatePlanId)
                    let RatePlanObj = [];
                    if (roomInfoData && roomInfoData.length > 0 && roomInfoData[0].ratePlanList) {
                        RatePlanObj = roomInfoData[0].ratePlanList.filter(rateplan => rateplan && rateplan.RatePlanId == RatePlan[0]?.RatePlanId);
                    }
                    console.log("RatePlanObj" , RatePlanObj)
                    vm.selectRoom(roomInfoData[0], RatePlanObj[0]);
                  }
                }
              }
            }
          },
        });
      }
    },
    showAvailabilityInfo(clearSearch) {
      let vm = this;
      vm.showRooms = false;

      if (clearSearch == "cancelSearch") {
        vm.selectedRoomFlag = false;
        if (
          vm.$route.params.ReservationId == -1 &&
          vm.guestInfo.ReservationId &&
          vm.guestInfo.ReservationId != -1
        ) {
          // alert("hai")
        } else {
          vm.getReservationDetailById();
        }
      }
    },
    selectRoom: function (room, ratePlan) {
      let vm = this;
      console.log("room selected", room);
      vm.$set(vm.roomInfo, "PropertyNickName", room.PropertyNickName);
      vm.$set(vm.roomInfo, "PropertyName", room.PropertyName);
      vm.$set(vm.roomInfo, "UnitName", room.UnitName);
      vm.$set(vm.roomInfo, "UnitNickName", room.UnitNickName ? room.UnitNickName : room.NickName);
      vm.$set(vm.roomInfo, "UnitTypeId", room.UnitTypeId);
      vm.$set(vm.roomInfo, "UnitTypeName", room.UnitTypeName);
      vm.$set(vm.roomInfo, "UnitClassName", room.UnitClassName);
      vm.$set(vm.roomInfo, "PropertyId", room.PropertyId);
      vm.$set(vm.roomInfo, "UnitId", room.UnitId);
      vm.$set(vm.roomInfo, "UnitClassId", room.UnitClassId);
      vm.$set(vm.roomInfo, "ColorCode", room.ColorCode);
      vm.$set(vm.roomInfo, "ImageUrl", room.ImageURL);
      vm.$set(vm.roomInfo, "isActive", true);
      vm.$set(vm.roomInfo, "checkInTime", room.CheckInTime);
      vm.$set(vm.roomInfo, "checkInTime", room.CheckInTime);
      vm.$set(vm.roomInfo, "Timezone", room.TimeZone);
      vm.$set(vm.guestInfo, "LastminuteBooking", room.Lastminutebooking);
      vm.selectedRoomFlag = true;

      if(ratePlan){
        vm.guestInfo.RateplanName = ratePlan && ratePlan.RatePlanId ? ratePlan.RatePlanName : room.RatePlanName;
        vm.ratePlanId = ratePlan && ratePlan.RatePlanId ? ratePlan.RatePlanId : room.RateplanId;
      }else{
        var selectedRatePlanName = this.sharedSelectedUnitData?.selectedRatePlan?.[0]?.RatePlan_Name || null;
        var selectedRatePlanId = this.sharedSelectedUnitData?.selectedRatePlan?.[0]?.RatePlanId || null;
  
        vm.guestInfo.RateplanName = ratePlan && ratePlan.RatePlanId ? ratePlan.RatePlanName : selectedRatePlanName ? selectedRatePlanName : room.RatePlanName;
        vm.ratePlanId = ratePlan && ratePlan.RatePlanId ? ratePlan.RatePlanId : selectedRatePlanId ? selectedRatePlanId : room.RateplanId;
      }
      vm.Promocode =
        ratePlan && ratePlan.PromoCodes
          ? ratePlan.PromoCodes.join()
          : room.Promocode;
      vm.guestInfo.Promocode = vm.Promocode;
      if (!vm.searchByUnit) {
        vm.$set(vm.roomInfo, "UnitTypeName", room.UnitName);
      } else {
        vm.$set(vm.roomInfo, "UnitTypeName", room.UnitTypeName);
      }
      vm.GetFolioLedgerTransDetails_beforesave();
      if (this.roomInfo.StartDate && this.roomInfo.EndDate) {
        //console.log("in calculateNights");
        let StartDate = moment(this.roomInfo.StartDate);
        let EndDate = moment(this.roomInfo.EndDate);
        let Nights = EndDate.diff(StartDate, "days");
        this.roomInfo.Nights = Nights;
      }
      // vm.roomInfo.checkInTime = "00:00 AM";
      // vm.roomInfo.checkOutTime = "00:00 AM";
      // vm.roomInfo.checkInTime = room.CheckInTime;
      // vm.roomInfo.checkOutTime = room.CheckOutTime;
      // if(vm.checkinput != true ){
      //   var checkinHour = moment(room.CheckInTime, "hh:mm a").format('hh');
      // var checkinmin = moment(room.CheckInTime, "hh:mm a").format('mm');
      // var checkinmeridian = moment(room.CheckInTime, "hh:mm a").format('a');

      // vm.checkinTime.hh = checkinHour;
      // vm.checkinTime.mm = checkinmin;
      // vm.checkinTime.a = checkinmeridian;
      // console.log("checkinHour===>", checkinHour)
      // console.log("checkinmin===>", checkinmin)
      // console.log("checkinmeridian==>", checkinmeridian)
      // console.log("room.CheckInTime==>", room.CheckInTime)

      // }
      // if(vm.checkoutput != true){
      //   var checkoutHour = moment(room.CheckOutTime, "hh:mm a").format('hh');
      // var checkoutmin = moment(room.CheckOutTime, "hh:mm a").format('mm');
      // var checkoutmeridian = moment(room.CheckOutTime, "hh:mm a").format('a');

      // vm.checkoutTime.hh = checkoutHour;
      // vm.checkoutTime.mm = checkoutmin;
      // vm.checkoutTime.a = checkoutmeridian;

      // console.log("checkoutHour==>", checkoutHour)
      // console.log("checkoutmin==>", checkoutmin)
      // console.log("checkoutmeridian==>", checkoutmeridian)
      // console.log("room.CheckOutTime==>", room.CheckOutTime)

      // }

      this.displayAccomodationInfo = "accomodationInfo";
      this.showAccomodationInfoButton = false;
    },
    GetFolioLedgerTransDetails_beforesave() {
      let vm = this;
      let NumberOfAdults;
      let NumberOfChildren;
      let Persons;
      if (vm.radioCheck === "Persons") {
        Persons = vm.roomInfo.Persons;
        NumberOfAdults = null;
        NumberOfChildren = null;
      } else if (vm.radioCheck === "AdultsAndChildren") {
        Persons = null;
        NumberOfAdults = vm.roomInfo.NumberOfAdults;
        NumberOfChildren = vm.roomInfo.NumberOfChildren;
      }
      vm.$store.dispatch("dataRequestHandler", {
        key: "GetFolioLedgerTransDetails",
        params: {
          ModuleAction: "GetFolioLedgerTransDetails",
          FolioId: null,
          ReservationId: null,
          UnitId: vm.roomInfo.UnitId,
          // UserId,
          // ClientId,
          PropertyId: vm.roomInfo.PropertyId,
          // StartDate:vm.roomInfo.originalStartDate,
          // EndDate:vm.roomInfo.originalEndDate,
          StartDate: moment(vm.roomInfo.StartDate).format("YYYY-MM-DD"),
          EndDate: moment(vm.roomInfo.EndDate).format("YYYY-MM-DD"),
          NumOfAdults: NumberOfAdults,
          NumOfChildren: NumberOfChildren,
          Persons: Persons,
          RatePlanId: vm.ratePlanId,
        },
        callback: function (err, response) {
          if (err) {
            return;
          }
          if (response) {
            console.log("response in GetFolioLedgerTransDetails", response);
            if (response[1]) {
              // vm.folioSummaryDetail = response[1];
              vm.displayFolioDetail = "FolioDetail";
              vm.showFolioDetailButton = false;
              vm.folioSummaryDetail = response[0];
              vm.ShowLessfolioItemsDetails = response[0].slice(0, 5);
              vm.folioItemsDetails = response[1];
              vm.folioCharges = response[2][0];
              // vm.LedgerAcounts = response[3];
              vm.ActualInventoryValue = response[4][0].ActualInventory;
              // console.log("vm.ActualInventory========>",response[4][0].ActualInventoryValue)

              if (vm.ActualInventoryValue == 2) {
                vm.honourFolio = true;
              } else {
                vm.honourFolio = false;
              }
            }
          }
        },
      });
    },
    folioRecalculateYesCallback() {
      this.continueSaveRoom(true);
      this.isModalVisible = false;
    },
    folioRecalculateNoCallback() {
      this.continueSaveRoom(false);
      this.isModalVisible = false;
    },
    saveRoomInfo(ReservationMode, fromModule) {
      let vm = this;
      //console.log("in saveRoomInfo");
      let NumberOfAdults;
      let NumberOfChildren;
      let Persons;
      if (vm.radioCheck === "Persons") {
        Persons = vm.roomInfo.Persons;
        NumberOfAdults = null;
        NumberOfChildren = null;
      } else if (vm.radioCheck === "AdultsAndChildren") {
        Persons = null;
        NumberOfAdults = vm.roomInfo.NumberOfAdults;
        NumberOfChildren = vm.roomInfo.NumberOfChildren;
      }
      let reservationMode = ReservationMode;
      if (
        vm.roomInfo.reservationMode == undefined ||
        vm.roomInfo.reservationMode == null ||
        vm.roomInfo.reservationMode == ""
      ) {
        reservationMode = 0;
      }
      console.log("reservationMode", reservationMode);
      let resStatusId;
      // if (vm.Reservation_Status.StatusId === 10) {
      //   resStatusId = 1;
      // } else {
      resStatusId = vm.Reservation_Status.StatusId;
      // }
      // if (
      //   vm.checkinput == true &&
      //   (vm.checkinTime.hh != "00" || vm.checkinTime.mm != "00")
      // ) {
      //   CheckInTime =
      //     vm.checkinTime.hh + ":" + vm.checkinTime.mm + "" + vm.checkinTime.a;
      // } else {
      //   CheckInTime = null;
      // }
      // if (
      //   vm.checkoutput == true &&
      //   (vm.checkoutTime.hh != "00" || vm.checkoutTime.mm != "00")
      // ) {
      //   CheckOutTime =
      //     vm.checkoutTime.hh +
      //     ":" +
      //     vm.checkoutTime.mm +
      //     "" +
      //     vm.checkoutTime.a;
      // } else {
      //   CheckOutTime = null;
      // }
      vm.tempSaveAssignRoomParams = {
        ModuleAction: "SaveReservation_AssignRooms",
        PropertyId: vm.roomInfo.PropertyId,
        StatusId: resStatusId,
        NumberOfAdults: NumberOfAdults,
        NumberOfChildren: NumberOfChildren,
        ReservationId: vm.guestInfo.ReservationId,
        UnitId: vm.roomInfo.UnitId,
        StartDate: moment(vm.roomInfo.StartDate).format("YYYY-MM-DD"),
        EndDate: moment(vm.roomInfo.EndDate).format("YYYY-MM-DD"),
        Ext_ReservationId: null,
        Persons: Persons,
        SourceId: vm.guestInfo.SourceId,
        StayInfoId: -1,
        // checkInTime: vm.checkInTime,
        // checkOutTime: vm.checkInTime,
        ReservationMode: reservationMode,
        PreviousRoomInfo: vm.previousRoomInfo,
        RatePlanId: vm.ratePlanId,
        // RatePlanId: vm.ratePlanId ? vm.ratePlanId : vm.guestInfo.RatePlanId,
        Promocode: vm.Promocode ? vm.Promocode : vm.guestInfo.Promocode,
        splitReservations: !vm.searchByUnit ? vm.splitReservations : false,
      };
      let splitNum1 = vm.folioSummaryDetail[0].Charges.replace(",", "");
      let splitNum2 = vm.roomInfo.unitCharges.replace(",", "");
      let num1 = parseInt(splitNum1);
      let num2 = parseInt(splitNum2);
      if (
        (vm.$route.params.ReservationId != -1 &&
          fromModule != "fromStatusChange" &&
          (vm.previousRoomInfo.UnitId !== vm.roomInfo.UnitId ||
            vm.previousRoomInfo.StartDate != vm.roomInfo.StartDate ||
            vm.previousRoomInfo.EndDate != vm.roomInfo.EndDate ||
            vm.previousRoomInfo.Persons != Persons ||
            vm.previousRoomInfo.NumberOfChildren !=
              (NumberOfChildren ? NumberOfChildren : 0) ||
            vm.previousRoomInfo.NumberOfAdults !=
              (NumberOfAdults ? NumberOfAdults : 0) ||
            vm.guestInfo.RatePlanId != vm.ratePlanId)) ||
        (vm.guestInfo.RatePlanId == vm.ratePlanId && num1 != num2)
      ) {
        //Show popup for user confirmation
        vm.modalParams = {
          popupTitle: "Folio has to be re-calculated",
          popupMessage: "Do you want to re-calculate Folio ?",
          displayYesNoButtons: true,
          yesButtontext: "Yes",
          noButtonText: "No",
          yesButtonCallback: vm.folioRecalculateYesCallback,
          noButtonCallback: vm.folioRecalculateNoCallback,
        };

        vm.isModalVisible = true;
        return;
      }
      // else if (vm.$route.params.ReservationId == -1) {
      //   vm.continueSaveRoom(-1);
      // }
      else if (fromModule == "fromStatusChange") {
        let recalculateFolioval = false;
        if (
          vm.previousRoomInfo.Reservation_Status == "4" ||
          vm.previousRoomInfo.Reservation_Status == "11"
        ) {
          recalculateFolioval = true;
        }
        vm.continueSaveRoom(recalculateFolioval);
      } else {
        vm.continueSaveRoom(true);
      }

      //console.log("StartDate : vm.roomInfo.dateObj.StartDate", vm.roomInfo.dateObj.StartDate, vm.roomInfo.dateObj.EndDate)
    },
    continueSaveRoom(reCalculate) {
      let vm = this;
      vm.tempSaveAssignRoomParams.reCalculateFolio = reCalculate;
      vm.$store.dispatch("dataRequestHandler", {
        key: "SaveReservation_AssignRooms",
        params: vm.tempSaveAssignRoomParams,
        callback: function (err, response) {
          if (err) {
            console.log("err in saveRoomInfo", err);
            vm.$store.dispatch("toastr", {
              type: "error",
              header: "Error!",
              message: "Error While Saving Room Info!",
            });
            return;
          }
          if (response) {
            // (vm.checkinedit = true),
            //   (vm.checkinput = false),
            //   (vm.checkoutedit = true),
            //   (vm.checkoutput = false);

            console.log("response in SaveReservation_AssignRooms", response);
            if (response[0] && response[0][0] && response[0][0].ErrorMessage) {
              vm.$store.dispatch("toastr", {
                type: "error",
                header: "Error!",
                message: "Error While Saving Room Info!",
              });
            }
            if (
              response[6] &&
              response[6][0] &&
              response[6][0].hasOwnProperty("reservationID") &&
              !response[0][0].ErrorMessage
            ) {
              vm.guestData = response[6][0];
              if (
                ((vm.$route.params.ReservationId != -1 ||
                  vm.$route.params.ReservationId != null) &&
                  vm.roomInfo.propertyId == vm.previousRoomInfo.propertyId &&
                  vm.roomInfo.UnitClassId == vm.previousRoomInfo.UnitClassId &&
                  vm.roomInfo.StartDate == vm.previousRoomInfo.StartDate &&
                  vm.roomInfo.EndDate == vm.previousRoomInfo.EndDate &&
                  ((vm.radioCheck == "AdultsAndChildren" &&
                    vm.roomInfo.NumberOfAdults ==
                      vm.previousRoomInfo.NumberOfAdults &&
                    vm.roomInfo.NumberOfChildren ==
                      vm.previousRoomInfo.NumberOfChildren) ||
                    (vm.radioCheck == "Persons" &&
                      vm.roomInfo.Persons == vm.previousRoomInfo.Persons))) ||
                !reCalculate
              ) {
                vm.$store.dispatch("toastr", {
                  type: "success",
                  header: "Success!",
                  message:
                    "Reservation is Saved Successfully. No Changes are made to existing folio",
                });
                // console.log("vm.folioItemsDetails", vm.folioItemsDetails)
              } else {
                vm.$store.dispatch("toastr", {
                  type: "success",
                  header: "Success!",
                  message:
                    "Reservation is Saved Successfully. Folio is updated accordingly.",
                });
              }
              vm.getCustomFields();
              vm.getCustomFieldInstances();

              let EventID = [],
                SubEventId,
                sub_event = null,
                deleteEvent = null;
              let NotificationEventID = [],
                NotiSubEventId = null;
              if (vm.$route.params.ReservationId == "-1") {
                // let localDateTime = moment().format('YYYY-MM-DD HH:mm:ss');
                let bookedTimeInProperty = moment
                  .tz(vm.roomInfo.Timezone)
                  .format("YYYY-MM-DD HH:mm:ss");
                // let diff = moment(now,"DD/MM/YYYY HH:mm:ss").diff(moment(bookedTimeInProperty,"DD/MM/YYYY HH:mm:ss"));
                // let d = duration.asHours();
                let startdate = moment(
                  vm.roomInfo.formattedStartDate,
                  "Do MMM YYYY"
                ).format("YYYY-MM-DD");
                let checkintime = moment(vm.roomInfo.checkInTime, [
                  "h:mm A",
                ]).format("HH:mm:ss");
                let combinetime = startdate + " " + checkintime;
                // var momentObj = moment(startdate + checkintime, 'YYYY-MM-DDLT');
                // console.log("momentObjmomentObjmomentObj === ", combinetime)
                // var dateTime = momentObj.format('YYYY-MM-DD HH:mm:ss');
                // console.log("dateTimedateTimedateTime === ", dateTime)

                let duration = moment(combinetime, "YYYY-MM-DD HH:mm:ss").diff(
                  moment(bookedTimeInProperty, "YYYY-MM-DD HH:mm:ss")
                );
                let seconds = moment.duration(duration);
                let hoursDiff = seconds.asHours();
                console.log("hourshourshours === ", hoursDiff);
                if (vm.Reservation_Status.StatusId == 10) {
                  SubEventId = 3;
                } else if (vm.Reservation_Status.StatusId == 12) {
                  SubEventId = 26;
                } else if (
                  vm.guestInfo.LastminuteBooking &&
                  vm.guestInfo.LastminuteBooking > 0 &&
                  hoursDiff <= vm.guestInfo.LastminuteBooking
                ) {
                  // alert("lastminbooking");
                  SubEventId = 2;
                  NotiSubEventId = 2;
                } else {
                  SubEventId = 1;
                  NotiSubEventId = 1;
                }
                if (
                  vm.Reservation_Status.StatusId != 10 &&
                  vm.Reservation_Status.StatusId != 12 &&
                  vm.Reservation_Status.StatusId != 8
                ) {
                  EventID = [
                    { eventId: 1, subEventId: SubEventId },
                    { eventId: 4, subEventId: 15 },
                  ];
                } else {
                  EventID = [{ eventId: 1, subEventId: SubEventId }];
                }
                for (let event of EventID) {
                  vm.getLogIdsByEventID(event.eventId, event.subEventId);
                }
                if (vm.Reservation_Status.StatusId == 10) {
                  NotiSubEventId = 3;
                }
                if (vm.Reservation_Status.StatusId == 12) {
                  NotiSubEventId = 26;
                }
                NotificationEventID = [
                  { notificationEventId: 1, NotiSubEventId: NotiSubEventId },
                ];
                for (let event of NotificationEventID) {
                  if (event.NotiSubEventId != "") {
                    vm.save_Notification(
                      event.notificationEventId,
                      event.NotiSubEventId,
                      vm.notificationAmount
                    );
                  }
                }
              } else {
                let subEventArr = [];
                let NotisubeventArr = [];
                if (
                  vm.previousRoomInfo.StartDate != vm.roomInfo.StartDate ||
                  vm.previousRoomInfo.EndDate != vm.roomInfo.EndDate
                ) {
                  subEventArr.push(4);
                  NotisubeventArr.push(4);
                }
                if (
                  vm.previousRoomInfo.GuestCount !=
                  (vm.radioCheck == "Persons"
                    ? vm.roomInfo.Persons
                    : JSON.parse(vm.roomInfo.NumberOfAdults) +
                      JSON.parse(vm.roomInfo.NumberOfChildren))
                ) {
                  // SubEventId = 5
                  subEventArr.push(5);
                  NotisubeventArr.push(5);
                }
                if (vm.previousRoomInfo.UnitTypeId != vm.roomInfo.UnitTypeId) {
                  // SubEventId = 6
                  subEventArr.push(6);
                  NotisubeventArr.push(6);
                }
                if (
                  vm.previousRoomInfo.UnitClassId != vm.roomInfo.UnitClassId
                ) {
                  // SubEventId = 7
                  subEventArr.push(7);
                  NotisubeventArr.push(7);
                }
                if (vm.previousRoomInfo.UnitId != vm.roomInfo.UnitId) {
                  // SubEventId = 8
                  subEventArr.push(8);
                  deleteEvent = "4";
                  NotisubeventArr.push(8);
                }
                if (
                  reCalculate &&
                  vm.previousRoomInfo.folioCharges.TotalValue !=
                    vm.folioCharges.TotalValue
                ) {
                  // SubEventId = 9
                  subEventArr.push(9);
                  NotisubeventArr.push(9);
                }

                if (vm.roomInfo.Reservation_Status == 6) {
                  if (
                    vm.previousRoomInfo.EndDate != vm.roomInfo.EndDate ||
                    vm.previousRoomInfo.UnitId != vm.roomInfo.UnitId
                  ) {
                    EventID = [
                      { eventId: 2, subEventId: subEventArr.join() },
                      { eventId: 5, subEventId: 18 },
                    ];
                    deleteEvent = "5";
                    NotificationEventID = [
                      {
                        notificationEventId: 2,
                        NotiSubEventId: NotisubeventArr.join(),
                      },
                    ];
                  } else {
                    EventID = [{ eventId: 2, subEventId: subEventArr.join() }];
                    NotificationEventID = [
                      {
                        notificationEventId: 2,
                        NotiSubEventId: NotisubeventArr.join(),
                      },
                    ];
                  }
                } else if (
                  (vm.previousRoomInfo.StartDate != vm.roomInfo.StartDate ||
                    vm.previousRoomInfo.UnitId != vm.roomInfo.UnitId) &&
                  vm.Reservation_Status.StatusId != 10 &&
                  vm.Reservation_Status.StatusId != 12
                ) {
                  // if ((vm.previousRoomInfo.StartDate != vm.roomInfo.StartDate && vm.previousRoomInfo.EndDate != vm.roomInfo.EndDate) || vm.previousRoomInfo.StartDate != vm.roomInfo.StartDate) {
                  EventID = [
                    { eventId: 2, subEventId: subEventArr.join() },
                    { eventId: 4, subEventId: 15 },
                  ];
                  deleteEvent = "4";
                  NotificationEventID = [
                    {
                      notificationEventId: 2,
                      NotiSubEventId: NotisubeventArr.join(),
                    },
                  ];
                  // }
                } else {
                  EventID = [{ eventId: 2, subEventId: subEventArr.join() }];
                  NotificationEventID = [
                    {
                      notificationEventId: 2,
                      NotiSubEventId: NotisubeventArr.join(),
                    },
                  ];
                }
                for (let event of NotificationEventID) {
                  if (event.NotiSubEventId != "") {
                    vm.save_Notification(
                      event.notificationEventId,
                      event.NotiSubEventId,
                      vm.notificationAmount
                    );
                  }
                }
                vm.get_JobDetails(deleteEvent);
                for (let event of EventID) {
                  vm.getLogIdsByEventID(event.eventId, event.subEventId);
                }

                // if ((vm.previousRoomInfo.UnitId != vm.roomInfo.UnitId ||
                //   vm.previousRoomInfo.StartDate != vm.roomInfo.StartDate ||
                //   vm.previousRoomInfo.EndDate != vm.roomInfo.EndDate || vm.previousRoomInfo.GuestCount != (vm.radioCheck == "Persons" ? vm.roomInfo.Persons : vm.roomInfo.NumberOfAdults + vm.roomInfo.NumberOfChildren)) && ((Math.abs(vm.previousRoomInfo.Nights - vm.roomInfo.Nights) > 1 || reCalculate) && vm.previousRoomInfo.folioCharges.TotalValue != vm.folioCharges.TotalValue)) {
                //   SubEventId = "1,2"
                // }
                // else if (
                //   vm.previousRoomInfo.UnitId != vm.roomInfo.UnitId ||
                //   vm.previousRoomInfo.StartDate != vm.roomInfo.StartDate ||
                //   vm.previousRoomInfo.EndDate != vm.roomInfo.EndDate || vm.previousRoomInfo.GuestCount != (vm.radioCheck == "Persons" ? vm.roomInfo.Persons : vm.roomInfo.NumberOfAdults + vm.roomInfo.NumberOfChildren)
                // ) {
                //   SubEventId = "1"
                // } else if (reCalculate && vm.previousRoomInfo.folioCharges.TotalValue != vm.folioCharges.TotalValue) {
                //   SubEventId = "2"
                // } else {
                //   EventID = null;
                //   SubEventId = null;
                //   sub_event = null;
                // }
                // if (sub_event) {
                //   SubEventId = SubEventId + ',' + sub_event
                // }

                // vm.getLogIdsByEventID(EventID, SubEventId)
              }
              vm.getFolioSummary(false, null);
              vm.getNotesDetails();
              vm.displayFolioDetail = "FolioDetail";
              vm.showFolioDetailButton = false;
              vm.$set(
                vm.roomInfo,
                "PropertyNickName",
                response[6][0].PropertyNickName
              );
              vm.$set(vm.roomInfo, "PropertyName", response[6][0].PropertyName);
              vm.$set(vm.roomInfo, "UnitName", response[6][0].UnitName);
              vm.$set(vm.roomInfo, "UnitNickName", response[6][0].UnitNickName);
              vm.$set(vm.roomInfo, "UnitClassId", response[6][0].UnitClassId);
              vm.$set(vm.roomInfo, "UnitId", response[6][0].UnitId);
              vm.$set(
                vm.roomInfo,
                "UnitClassName",
                response[6][0].UnitClassName
              );
            }
            if (response[3] && response[3][0]) {
              vm.$set(
                vm.Reservation_Status,
                "StatusId",
                response[3][0].StatusId
              );
              vm.$set(
                vm.Reservation_Status,
                "StatusName",
                response[3][0].StatusName
              );
            }
            if (response[4]) {
              vm.reservationStatusList = response[4];
            }
            if (response[5] && response[5][0]) {
              vm.$set(
                vm.roomInfo,
                "reservationMode",
                response[5][0].ReservationMode
              );
            }
            vm.selectedRoomFlag = false;
            vm.showRooms = false;
            // for creating the Turnover housekeeping task
            vm.notesDetailById.noteTypeId = 2;
            vm.notesDetailById.noteSubject = "Turnover cleaning";
            vm.notesDetailById.noteDetails = "Turnover cleaning";
            vm.notesDetailById.isActionReqd = 1;
            // vm.notesDetailById.noteStatusId = 0;
            vm.notesDetailById.taskTypeId = 1;
            vm.notesDetailById.isAutoGenerated = 1;
            vm.notesDetailById.dateOrTimeDue = moment(
              vm.roomInfo.EndDate
            ).format("YYYY-MM-DD");
            // vm.saveNotesDetails(-99, 0, 1);
            if (vm.$route.params.ReservationId == "-1") {
              vm.notesDetailById.noteStatusId = 0;
              // console.log("redirect--",vm.guestInfo);
              vm.saveNotesDetails(-99, 0, 1, "saveRoomModule");
              if (
                vm.guestInfo &&
                vm.guestInfo.GuestProfileId == -1 &&
                vm.guestInfo.CompanyProfileId == -1 &&
                vm.guestInfo.ReservationId == -1
              ) {
                vm.$router.push(
                  `/newReservation/${vm.guestInfo.ReservationId}`
                );
              } else if (
                vm.guestInfo &&
                vm.guestInfo.GuestProfileId != -1 &&
                vm.guestInfo.CompanyProfileId != -1 &&
                vm.guestInfo.ReservationId == -1
              ) {
                vm.$router.push(
                  "/newReservation/" + -1 + "/" + vm.guestInfo.GuestProfileId
                );
              } else if (
                vm.guestInfo &&
                vm.guestInfo.CompanyProfileId != -1 &&
                vm.guestInfo.GuestProfileId != -1 &&
                vm.guestInfo.ReservationId == -1
              ) {
                vm.$router.push(
                  "/newReservation/" + -1 + "/" + vm.guestInfo.CompanyProfileId
                );
              }

              if (
                vm.guestInfo &&
                (vm.guestInfo.GuestProfileId != -1 ||
                  vm.guestInfo.CompanyProfileId != -1) &&
                vm.guestInfo.ReservationId != -1
              ) {
                vm.$router.push(
                  `/newReservation/${vm.guestInfo.ReservationId}`
                );
              }

              // vm.$router.push("/newReservation/" + vm.guestInfo.ReservationId);
            } else {
              let notedId = -99;
              let statusId = 0;
              for (let note of vm.notes) {
                if (note.isAutogenerated == 1 || note.isAutogenerated == true) {
                  notedId = note.noteId;
                  statusId = note.noteStatusId;
                }
              }
              vm.notesDetailById.noteStatusId = statusId;
              vm.saveNotesDetails(notedId, statusId, 1, "saveRoomModule");
              vm.getReservationDetailById();
            }
            vm.tempSaveAssignRoomParams = null;
          }
        },
      });
    },
    getLogIdsByEventID(eventId, SubEventId) {
      let vm = this;
      vm.$store.dispatch("dataRequestHandler", {
        key: "Get_LogDetails_ByEventId",
        params: {
          ReservationId: vm.guestInfo.ReservationId,
          EventId: eventId,
          SubEventId: SubEventId,
        },
        callback: function (err, response) {
          if (err) {
            return;
          }
          if (response) {
            console.log("response in getLogIdsByEventID", response);
          }
        },
      });
    },
    get_JobDetails(eventId) {
      let vm = this;
      vm.$store.dispatch("dataRequestHandler", {
        key: "get_JobDetails",
        params: {
          ReservationId: vm.guestInfo.ReservationId,
          EventId: eventId,
        },
        callback: function (err, response) {
          if (err) {
            return;
          }
          if (response) {
            console.log("response in get_JobDetails", response);
          }
        },
      });
    },
    get_NotificationCount() {
      let vm = this;
      vm.$store.dispatch("dataRequestHandler", {
        key: "GetNotificationCountByUser",
        params: {},
        callback: function (err, response) {
          if (err) {
            return;
          }
          if (response) {
            vm.$store.commit(
              "setNotificationCount",
              response.NotificationCount
            );
            console.log("response in get_NotificationCount", response);
          }
        },
      });
    },
    save_Notification(notificationEventId, notifSubEventId, amount) {
      let vm = this;
      var notificationToaster = null;
      var headerToaster = null;
      vm.$store.dispatch("dataRequestHandler", {
        key: "SaveNotification",
        params: {
          ReservationId: vm.guestInfo.ReservationId,
          EventId: notificationEventId,
          SubEventId: notifSubEventId,
          PropertyId: vm.roomInfo.PropertyId,
          Amount: amount,
        },
        callback: function (err, response) {
          if (err) {
            vm.$store.dispatch("toastr", {
              type: "error",
              header: "Error!",
              message: `Error While saving notification !`,
            });
            return;
          }
          if (
            response[0] &&
            response[0][0] &&
            response[0][0].ErrorMessage != ""
          ) {
            vm.$store.dispatch("toastr", {
              type: "error",
              header: "Error!",
              message: response[0][0].ErrorMessage,
            });
          }
          if (response) {
            if (
              response &&
              response.recordset[0] &&
              response.recordset[0].EventDescription
            ) {
              notificationToaster = response.recordset[0].Messagecontent;
              headerToaster = response.recordset[0].EventDescription;
            }

            if (notificationToaster != null) {
              vm.$store.dispatch("toastr", {
                type: "success",
                header: ` ${headerToaster} `,
                message: ` ${notificationToaster} `,
              });
            }

            console.log("response in save_Notification", response);
            //vm.get_NotificationCount();
            vm.notificationEventId = null;
            vm.$store.state.bus.$emit("getNoficicationConversation", {
              ConversationId: vm.guestInfo.ConversationId,
              ReservationId: vm.guestInfo.ReservationId,
            });
          }
        },
      });
    },
    createReservation() {
      let vm = this;
      let PartyAddressId;
      //console.log("vm.dateObj.StartDate", vm.roomInfo.dateObj)
      if (
        vm.$route.params.PartyAddressId === "null" ||
        vm.$route.params.PartyAddressId === null
      ) {
        PartyAddressId = -1;
      } else {
        PartyAddressId = vm.$route.params.PartyAddressId;
      }
      if (
        (vm.guestInfo.GuestFirstName === " " ||
          vm.guestInfo.GuestFirstName === undefined ||
          vm.guestInfo.GuestLastName === " " ||
          vm.guestInfo.GuestLastName === undefined ||
          vm.guestInfo.Email === " " ||
          vm.guestInfo.Email === undefined ||
          vm.guestInfo.PhoneNumber === " " ||
          vm.guestInfo.PhoneNumber === undefined ||
          vm.selectedStateAndCountry.StateName === " " ||
          vm.selectedStateAndCountry.StateName === undefined ||
          vm.selectedStateAndCountry.CountryName === " " ||
          vm.selectedStateAndCountry.CountryName === undefined) &&
        (vm.roomInfo.StartDate === " " ||
          vm.roomInfo.StartDate === undefined ||
          vm.roomInfo.EndDate === " " ||
          vm.roomInfo.EndDate === undefined ||
          vm.roomInfo.DefaultProperty === null ||
          vm.roomInfo.DefaultProperty === undefined ||
          vm.roomInfo.UnitClassName === " " ||
          vm.roomInfo.UnitClassName === undefined ||
          vm.filteredAmenities === null ||
          vm.filteredAmenities.length === 0 ||
          vm.roomInfo.NumberOfAdults === " " ||
          vm.roomInfo.NumberOfAdults === undefined ||
          vm.roomInfo.NumberOfChildren === " " ||
          vm.roomInfo.NumberOfChildren === undefined)
      ) {
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning",
          message:
            "Check-in date, Check-out date, No.of Adults, No.of Children ,Unit and Amenities are mandatary",
        });
      } else {
        vm.$store.dispatch("dataRequestHandler", {
          key: "SaveReservationDetail",
          params: {
            ModuleAction: "SaveReservationDetail",
            GuestProfileId: vm.$route.params.guestProfileId && vm.$route.params.accountType == 3 ? vm.$route.params.guestProfileId : vm.guestInfo.GuestProfileId,
            CompanyProfileId: vm.$route.params.guestProfileId && vm.$route.params.accountType == 7 ? vm.$route.params.guestProfileId : vm.guestInfo.CompanyProfileId,
            GuestFirstName: vm.guestInfo.GuestFirstName,
            GuestLastName: vm.guestInfo.GuestLastName,
            PropertyId: vm.roomInfo.DefaultProperty,
            AddressTypeId: 1,
            ContactName: vm.guestInfo.FirstName,
            PhoneCountryCode: null,
            PhoneAreaCode: null,
            PhoneNumber: vm.guestInfo.PhoneNumber,
            PhoneExtension: null,
            FaxCountryCode: null,
            FaxAreaCode: null,
            FaxNumber: null,
            FaxExtension: null,
            Email: vm.guestInfo.Email,
            Address1: vm.selectedStateAndCountry.Address,
            Address2: null,
            Address3: null,
            City: vm.selectedStateAndCountry.CityName,
            CityId: vm.selectedStateAndCountry.CityId,
            TerritoryId: null,
            PostalCode: null,
            CountryId: vm.selectedStateAndCountry.CountryId,
            StateId: vm.selectedStateAndCountry.StateId,
            NumberOfAdults: vm.roomInfo.NumberOfAdults,
            NumberOfChildren: vm.roomInfo.NumberOfChildren,
            StatusId: vm.$route.params.StatusId,
            PartyAddressId: PartyAddressId,
            ReservationId: vm.$route.params.ReservationId,
            UnitId: vm.roomInfo.UnitId,
            StartDate: vm.roomInfo.StartDate,
            EndDate: vm.roomInfo.EndDate,
            StatusIdOfUE: 1,
            UixId: null,
            SourceId: 1,
            Ext_ReservationId: null,
            ClientPrice: 0,
            FunctionId: "fncReservationSave",
            SelectedTags: vm.guestInfo.selectedTags,
          },
          callback: function (err, response) {
            if (response) {
              vm.$router.push("/ReservationList");
            } else {
              console.log(err);
            }
          },
        });
      }
    },
    fetchData: function () {
      let vm = this;
      console.log("hereeeeeeeeee", this.$route.params.propertyId);
      // vm.currSearchObj = {};
      vm.triggerevent = false;
      vm.showguestinfo = false;
      if (vm.$route.params.ReservationId == -1) {
        console.log("here");
        vm.CreateGuestProfile = true;
        vm.CreateCompanyProfile = true;
      } else {
        vm.CreateGuestProfile = false;
        vm.CreateCompanyProfile = false;
      }
      this.getReservationDetailById();
    },
    updatePaymentDate(key, dateObj) {
      let scope = this;
      scope.pendingPaymentDetails[0]["dateEffective"] = dateObj
        ? dateObj.format("DD MMM YYYY")
        : null;
    },
    updateStartDate(key, dateObj) {
      let scope = this;
      scope.roomInfo.StartDate = dateObj ? dateObj.format("DD MMM YYYY") : null;
      scope.roomInfo.formattedStartDate = dateObj
        ? dateObj.format("Do MMM YYYY")
        : null;
      // scope.roomInfo.formattedEndDate = response.roomInfo.EndDate;
      scope.startAndEnddates.StartMonth = moment(
        scope.roomInfo.StartDate
      ).format("MMM");
      scope.startAndEnddates.StartDate = moment(
        scope.roomInfo.StartDate
      ).format("DD");
      scope.startAndEnddates.StartDay = moment(scope.roomInfo.StartDate).format(
        "ddd"
      );
      scope.startAndEnddates.StartYear = moment(
        scope.roomInfo.StartDate
      ).format("YYYY");
      if (scope.roomInfo.StartDate && scope.roomInfo.EndDate) {
        let StartDate = moment(scope.roomInfo.StartDate);
        let EndDate = moment(scope.roomInfo.EndDate);
        let Nights = EndDate.diff(StartDate, "days");
        scope.noOfNights = Nights;
        scope.roomInfo.Nights = Nights;
      }
    },

    updateEndDate(key, dateObj) {
      let scope = this;
      scope.roomInfo.EndDate = dateObj ? dateObj.format("DD MMM YYYY") : null;
      //console.log("updateEndDate")
      scope.roomInfo.formattedEndDate = dateObj
        ? dateObj.format("Do MMM YYYY")
        : null;
      scope.startAndEnddates.EndMonth = moment(scope.roomInfo.EndDate).format(
        "MMM"
      );
      scope.startAndEnddates.EndDate = moment(scope.roomInfo.EndDate).format(
        "DD"
      );
      scope.startAndEnddates.EndDay = moment(scope.roomInfo.EndDate).format(
        "ddd"
      );
      scope.startAndEnddates.EndYear = moment(scope.roomInfo.EndDate).format(
        "YYYY"
      );
      if (scope.roomInfo.StartDate && scope.roomInfo.EndDate) {
        let StartDate = moment(scope.roomInfo.StartDate);
        let EndDate = moment(scope.roomInfo.EndDate);
        let Nights = EndDate.diff(StartDate, "days");
        scope.noOfNights = Nights;
        scope.roomInfo.Nights = Nights;
      }
    },

    getPaymentDetails() {
      let vm = this;
      vm.$store.dispatch("dataRequestHandler", {
        key: "Get_PaymentDetails",
        params: {
          ModuleAction: "Get_PaymentDetails",
          ReservationId: vm.$route.params.ReservationId,
        },
        callback: function (err, response) {
          if (err) {
            return;
          }
          if (response) {
            console.log("getPaymentDetails===>", response);
            vm.paymentDetails = response.paymentObj;
            vm.paymentCharges = response.recordsets[1][0];
            vm.paymentLedgerAcounts.splice(
              0,
              vm.paymentLedgerAcounts.length,
              ...response.recordsets[2]
            );
            vm.stripePlatformAccount = response.recordsets[3][0];
            vm.stripeConnectedAccount = response.recordsets[4][0];
            vm.commissionAmmount = response.recordsets[5][0];
            vm.paymentProcessList = response.recordsets[6];
            vm.isAccountConflict = response.recordsets[7][0].IsAccountChanged;
            vm.PaymentMode = response.recordsets[8][0].PaymentMode;
            vm.pendingPaymentDetails.splice(0, vm.pendingPaymentDetails.length);
            vm.paymentCardInfo.DefaultSettingforSyncCardDetails =
              response.recordsets[8][0].DefaultSettingforSyncCardDetails;
            vm.showNextProcessButton = true;
          }
        },
      });
    },
    changeNoteStatus(noteId, noteStatusId, note) {
      let vm = this;
      if (noteStatusId == 0) {
        vm.allowEdit = false;
      }
      for (let note of vm.notes) {
        if (note.noteId == noteId) {
          note.highLightActive = 1;
        } else {
          note.highLightActive = 0;
        }
      }
      console.log("note", noteId, noteStatusId);
      vm.$store.dispatch("dataRequestHandler", {
        key: "update_Notes_status",
        params: {
          ModuleAction: "update_Notes_status",
          noteId: noteId,
          noteStatusId: noteStatusId,
        },
        callback: function (err, response) {
          if (err) {
            console.log("Error in changeNoteStatus => ", err);
            return;
          }
          if (response) {
            console.log("response in changeNoteStatus", response);
            if (noteStatusId != 3) {
              vm.$store.dispatch("toastr", {
                type: "success",
                header: "Success!",
                message: "Notes status changed successfully",
              });
            } else if (noteStatusId == 3) {
              // vm.getNotesDetails();
              vm.$store.dispatch("toastr", {
                type: "success",
                header: "Success!",
                message: "Notes deleted successfully",
              });
            }
            vm.getNotesDetails();
            let foliochange = "";
            if (
              note.taskTypeId &&
              (note.taskTypeId == 1 || note.taskTypeId == 2)
            ) {
              foliochange = "folioChange";
            }
            vm.getFolioSummary(false, foliochange);
          }
        },
      });
    },
    getPropertiesBySearchText(searchText) {
      let vm = this;
      vm.$store.dispatch("dataRequestHandler", {
        key: "GetPropertiesBySearchText",
        params: {
          searchText: searchText,
        },
        callback: function (err, response) {
          if (err) {
            return;
          }
          if (response) {
            vm.propertyList.splice(
              0,
              vm.propertyList.length,
              ...response.propertyList
            );
          }
          // vm.getReservationDetailById();
        },
      });
    },
    GetUnitClasssListBySearchText(searchText) {
      let vm = this;
      let resultObj = vm.filteredProperties.map((obj) => obj.PropertyId);
      let unitTypes = vm.filteredUnitTypes.map((obj) => obj.UnitTypeId);
      vm.$store.dispatch("dataRequestHandler", {
        key: "GetUnitClasssListBySearchText",
        params: {
          searchText: searchText,
          PropertyId: resultObj.toString(),
          unitTypeIds: unitTypes.toString(),
        },
        callback: function (err, response) {
          if (err) {
            return;
          }
          if (response) {
            console.log("response in GetUnitClasssListBySearchText", response);
            vm.unitClassList.splice(
              0,
              vm.unitClassList.length,
              ...response.unitClassList
            );
          }
        },
      });
    },
    removePropertyFromFilter(propertyObj) {
      let vm = this;
      var index = vm.filteredProperties.indexOf(propertyObj);
      if (index > -1) {
        vm.filteredProperties.splice(index, 1);
      }
      vm.propertyList.push(propertyObj);
      // vm.getUnitTypeList();
    },
    removeUnitTypeFromFilter(unitType) {
      let vm = this;
      var index = vm.filteredUnitTypes.indexOf(unitType);
      if (index > -1) {
        vm.filteredUnitTypes.splice(index, 1);
      }
      vm.unitTypeList.push(unitType);
    },
    removeRatePlanFromFilter(ratePlan) {
      let vm = this;
      var index = vm.filteredRatePlans.indexOf(ratePlan);
      if (index > -1) {
        vm.filteredRatePlans.splice(index, 1);
      }
      vm.ratePlanList.push(ratePlan);
    },
    removePromoCodeFromFilter(promoCode) {
      let vm = this;
      var index = vm.filteredPromocode.indexOf(promoCode);
      if (index > -1) {
        vm.filteredPromocode.splice(index, 1);
      }
      vm.promoCodeList.push(promoCode);
    },
    removeUnitClassFromFilter(UnitClassObj) {
      let vm = this;
      var index = vm.filteredUnitClasses.indexOf(UnitClassObj);
      if (index > -1) {
        vm.filteredUnitClasses.splice(index, 1);
      }
      vm.unitClassList.push(UnitClassObj);
    },
    addToFilter(Obj) {
      let vm = this;
      if (vm.selectedFilterColumn == "property") {
        vm.filteredProperties.push(Obj);
        vm.filterSearchPropertyText = null;
        var index = vm.propertyList.indexOf(Obj);
        if (index > -1) {
          vm.propertyList.splice(index, 1);
        }
        vm.GetUnitClasssListBySearchText();
        // vm.getUnitTypeList();
      }
      if (vm.selectedFilterColumn == "UnitClass") {
        vm.filteredUnitClasses.push(Obj);
        vm.filterSearchPropertyText = null;
        var index = vm.unitClassList.indexOf(Obj);
        console.log("index of Amenities=>", index, Obj);
        if (index > -1) {
          vm.unitClassList.splice(index, 1);
          console.log("index", index);
          console.log("vm.unitClassList", vm.unitClassList);
        }
      }
      if (vm.selectedFilterColumn == "unitType") {
        vm.filteredUnitTypes.push(Obj);
        vm.filterSearchUnitTypeText = null;
        var index = vm.unitTypeList.indexOf(Obj);
        console.log("index of Amenities=>", index, Obj);
        if (index > -1) {
          vm.unitTypeList.splice(index, 1);
        }
      }
      if (vm.selectedFilterColumn == "promoCode") {
        vm.filteredPromocode.push(Obj);
        vm.filterSearchPromoCodeText = null;
        var index = vm.promoCodeList.indexOf(Obj);
        console.log("index of Amenities=>", index, Obj);
        if (index > -1) {
          vm.promoCodeList.splice(index, 1);
        }
      }
      if (vm.selectedFilterColumn == "ratePlan") {
        vm.filteredRatePlans.push(Obj);
        vm.filterSearchRatePlanText = null;
        var index = vm.ratePlanList.indexOf(Obj);
        console.log("index of Amenities=>", index, Obj);
        if (index > -1) {
          vm.ratePlanList.splice(index, 1);
        }
      }
      vm.selectedFilterColumn = null;
    },

    showFilterByType(filterCol) {
      let vm = this;
      setTimeout(function () {
        vm.selectedFilterColumn = filterCol;
        if (filterCol == "property") {
          if (vm.filteredProperties.length == 0) {
            vm.getPropertiesBySearchText();
          }

          $("#propertyDropDown").show();
        }
        if (filterCol == "UnitClass") {
          if (vm.filteredUnitClasses.length == 0) {
            vm.GetUnitClasssListBySearchText();
          }
          // vm.GetUnitClasssListBySearchText();
          $("#UnitClassDropDown").show();
        }
        if (filterCol == "unitType") {
          // if (vm.filteredUnitTypes.length == 0) {
          vm.getUnitTypeList();
          // }
          // vm.GetUnitClasssListBySearchText();
          $("#unitTypeDropDown").show();
        }
        if (filterCol == "promoCode") {
          // if (vm.filteredUnitTypes.length == 0) {
          vm.getPromoCodeList();
          // }
          // vm.GetUnitClasssListBySearchText();
          $("#promoCodeDropDown").show();
        }
        if (filterCol == "ratePlan") {
          // if (vm.filteredUnitTypes.length == 0) {
          vm.getRatePlanList();
          // }
          // vm.GetUnitClasssListBySearchText();
          $("#ratePlanDropDown").show();
        }
        if (filterCol == "amenities") {
          $("#amenitiesDropDown").show();
        }
      }, 10);
    },
    getUnitTypeList(searchText) {
      let vm = this;
      let resultObj = vm.filteredProperties.map((obj) => obj.PropertyId);
      vm.$store.dispatch("dataRequestHandler", {
        key: "Get_UnitTypeList",
        params: {
          sortBy: null,
          sortOrder: null,
          propertyId: resultObj ? resultObj : null,
          statusId: 1,
          searchText: searchText,
          FromSetup: false,
        },
        callback: function (err, response) {
          if (err) {
            return;
          }
          if (response) {
            console.log("Get_UnitTypeList==>", response);
            if (response[1] && response[1].length > 0) {
              vm.unitTypeList.splice(0, vm.unitTypeList.length, ...response[1]);
            }
            for (var unitType of vm.filteredUnitTypes) {
              let index = vm.unitTypeList.findIndex(
                (x) => x.UnitTypeId == unitType.UnitTypeId
              );
              if (index > -1) {
                vm.unitTypeList.splice(index, 1);
              }
            }
          }
        },
      });
    },
    getPromoCodeList(searchText) {
      let vm = this;
      vm.filterSearchPromoCodeText = null;
      vm.$store.dispatch("dataRequestHandler", {
        key: "Get_PromoCodes",
        params: {
          sortBy: null,
          sortOrder: null,
          statusId: 1,
          searchText: searchText,
          ratePlanId: vm.selectedRatePlan
            ? vm.selectedRatePlan.RatePlanId
            : null,
        },
        callback: function (err, response) {
          if (err) {
            return;
          }
          if (response) {
            console.log("Get_PromoCodes==>", response);
            // if (response[1] && response[1].length > 0) {
            vm.promoCodeList.splice(0, vm.promoCodeList.length, ...response[1]);
            // }
            // for (var promoCode of vm.filteredPromocode) {
            //   let index = vm.promoCodeList.findIndex(x => x.Promocode == promoCode.Promocode);
            //   if (index > -1) {
            //     vm.promoCodeList.splice(index, 1);
            //   }
            // }
            // vm.getRatePlanList()
          }
        },
      });
    },
    // getRatePlanList(searchText) {
    //   let vm = this;

    //   console.log("searchText ===", searchText);
    //   vm.$store.dispatch("dataRequestHandler", {
    //     key: "Get_RatePlanList",
    //     params: {
    //       sortBy: null,
    //       sortOrder: null,
    //       StatusId: 1,
    //       searchText: searchText ? searchText : null,
    //     },
    //     callback: function (err, response) {
    //       if (err) {
    //         return;
    //       }
    //       if (response) {
    //         console.log("Get_RatePlanList==>", response);
    //         // if (response[1] && response[1].length > 0) {
    //         vm.ratePlanList.splice(0, vm.ratePlanList.length, ...response[1]);
    //         vm.getPromoCodeList();
    //         // }
    //         // for (var ratePlan of vm.filteredRatePlans) {
    //         //   let index = vm.ratePlanList.findIndex(x => x.RatePlanId == ratePlan.RatePlanId);
    //         //   if (index > -1) {
    //         //     vm.ratePlanList.splice(index, 1);
    //         //   }
    //         // }
    //       }
    //     },
    //   });
    // },
    getRatePlanList(searchText) {
      let vm = this;

      console.log("searchText ===", searchText);
      vm.$store.dispatch("dataRequestHandler", {
        key: "getFolioRateplanList",
        params: {
          clientId: null,
        },
        callback: function (err, response) {
          if (err) {
            return;
          }
          if (response) {
            console.log("getFolioRateplanList==>", response[0]);
            vm.ratePlanList.splice(0, vm.ratePlanList.length, ...response[0]);
            vm.getPromoCodeList();
          }
        },
      });
    },
    // getRatePlanDetailList(SearchText, Tagtext) {
    //   let vm = this;
    //   vm.$store.dispatch("dataRequestHandler", {
    //     key: "GetRateplanList_bysearch",
    //     params: {
    //       StatusId: 1,
    //       SearchText: SearchText,
    //       Tagtext: Tagtext,
    //     },
    //     callback: function (err, response) {
    //       if (err) {
    //         console.log("Get_RatePlanList==>", err);
    //         return;
    //       }
    //       if (response) {
    //         console.log("Get_RatePlanList==>", response);
    //         vm.RatePlanList = response[1];
    //                     console.log("RatePlanList----",vm.RatePlanList);

    //       }
    //     },
    //   });
    // },
    getRatePlanDetailList(SearchText, Tagtext) {
      let vm = this;
      vm.$store.dispatch("dataRequestHandler", {
        key: "getFolioRateplanList",
        params: {
          clientId: null,
        },
        callback: function (err, response) {
          if (err) {
            console.log("getFolioRateplanList==>", err);
            return;
          }
          if (response) {
            console.log("getFolioRateplanList==>", response[0]);
            vm.RatePlanList = response[0];
          }
        },
      });
    },

    showRatePlansListForUnit(room, index) {
      let vm = this;
      room.ShowRates = !room.ShowRates;
    },
    // showFilterByType(filterCol) {
    //   let vm = this;
    //   // if (this.selectedFilterColumn == filterCol)
    //   //  this.selectedFilterColumn = null;
    //   // else
    //   //   vm.getPropertiesBySearchText();
    //   // vm.GetUnitClasssListBySearchText();
    //   // vm.getUnitListBySearchText();

    //   setTimeout(function () {
    //     vm.selectedFilterColumn = filterCol;
    //     if (filterCol == "amenities") {
    //       $("#amenitiesDropDown").show();
    //     }
    //   }, 10);
    // },

    formatDate(date) {
      console.log("date====>", date);
      // return moment(date, "YYYY-MM-DD").format("DD MMM");
      let vm = this;
      // let diff = moment(date).diff(vm.today, "months");
      // let dateToReturn;
      // console.log("diff", Math.abs(diff));
      // if (Math.abs(diff) >= 6) {
      //   console.log("here");
      // return moment(date, "YYYY-MM-DD").format("DD MMM YYYY");
      return moment.utc(date).format("DD MMM YYYY");
      // var m = moment.tz(date, vm.roomInfo.Timezone);
      // return m.format("DD MMM YYYY h:mm A");

      // }
      // else {
      //   return moment(date, "YYYY-MM-DD").format("DD MMM");
      // }
    },
    formatDateTime(date) {
      let vm = this;
      return moment(date).format("DD MMM YYYY h:mm A");
    },
    getLastTwoDigits(date) {
      let vm = this;
      return date.toString().substr(-2);
    },
    getTodayDate() {
      return moment().format("DD MMM YYYY");
    },
    addPaymentDetails(fromFolio) {
      let vm = this;
      vm.paymentCardInfo = {
        CreditCard: null,
        NameOnCard: null,
        ExpirationMonth: "-1",
        ExpirationYear: "-1",
        PaymentTypeId: null,
        PaymentInfoId: -1,
        CCLast4Digits: null,
        CardType: null,
        CvvCode: null,
        IsDefault: false,
        AddressDetails: null,
        PostalCode: null,
        DefaultSettingforSyncCardDetails:
          vm.paymentCardInfo.DefaultSettingforSyncCardDetails,
      };
      if (fromFolio) {
        vm.fromFolio = true;
      }
      if (
        vm.$store.state.userEntitlementList.fncFolioNew.isAssigned === -1 ||
        vm.$store.state.userEntitlementList.fncFolioNew.isAssigned === "-1"
      ) {
        vm = this;
        vm.showPaymentbutton = false;
      }

      if (vm.cardDetails.length == 0) {
        vm.paymentCardInfo.IsDefault = true;
      } else {
        vm.paymentCardInfo.IsDefault = false;
      }
      setTimeout(function () {
        vm.showPaymentDetails = true;
        vm.showPaymentList = false;
        vm.showPaymentOptions = true;
      }, 5);
    },
    savePaymentCardInfo() {
      let vm = this;

      // let currentYear = moment().format("YYYY");
      // let currentMonth = moment().format("MM");

      // if (!vm.paymentCardInfo.PaymentTypeId) {
      //   vm.$store.dispatch("toastr", {
      //     type: "warning",
      //     header: "Warning!",
      //     message: "Please Select Payment Method"
      //   });
      // } else if (
      //   !vm.paymentCardInfo.CreditCard ||
      //   vm.paymentCardInfo.CreditCard.length < 10
      // ) {
      //   vm.$store.dispatch("toastr", {
      //     type: "warning",
      //     header: "Warning!",
      //     message: "Please enter card number"
      //   });
      // } else if (isNaN(vm.paymentCardInfo.CreditCard)) {
      //   vm.$store.dispatch("toastr", {
      //     type: "warning",
      //     header: "Warning!",
      //     message: "Please enter valid card number"
      //   });
      // } else if (vm.paymentCardInfo.ExpirationMonth == -1) {
      //   vm.$store.dispatch("toastr", {
      //     type: "warning",
      //     header: "Warning!",
      //     message: "Please select expiry month"
      //   });
      // } else if (vm.paymentCardInfo.ExpirationYear == -1) {
      //   vm.$store.dispatch("toastr", {
      //     type: "warning",
      //     header: "Warning!",
      //     message: "Please select expiry year"
      //   });
      // } else if (
      //   Number(vm.paymentCardInfo.ExpirationMonth) < currentMonth &&
      //   Number(vm.paymentCardInfo.ExpirationYear) <= currentYear
      // ) {
      //   vm.$store.dispatch("toastr", {
      //     type: "warning",
      //     header: "Warning!",
      //     message: "Please select valid expiry month/year"
      //   });
      // } else {
      // else if (!vm.paymentCardInfo.CvvCode || vm.paymentCardInfo.CvvCode.length < 3 || vm.paymentCardInfo.CvvCode.length > 3) {
      //   vm.$store.dispatch("toastr", {
      //     type: "warning",
      //     header: "Warning!",
      //     message: "Please enter valid CVV"
      //   });
      // }
      // vm.guestPaymentCards.push(vm.paymentCardInfo);
      vm.showPaymentDetails = false;

      let request = vm.paymentCardInfo;
      request.partyId = vm.guestInfo.ReservationId;
      request.partyTypeId = 5;
      for (let ledger of vm.paymentLedgerAcounts) {
        if (vm.paymentCardType === ledger.PaymentMethod) {
          request.PaymentTypeId = ledger.ledgerAccountID;
        }
      }
      vm.$store.dispatch("dataRequestHandler", {
        key: "SavePaymentDetails",
        params: {
          paymentDetails: vm.paymentCardInfo,
          Token: vm.cardTokenFromStripe,
          cardId: vm.stripecardId,
          stripePlatformAccount: vm.stripePlatformAccount,
          stripeConnectedAccount: vm.stripeConnectedAccount,
          // Savetoallfuturereservations: false,
        },
        callback: function (err, response) {
          if (err) {
            console.log("Error in saving payment details => ", err);
            vm.$store.dispatch("toastr", {
              type: "error",
              header: "Error",
              message: "Error While Saving Card Details!",
            });
            return;
          }
          if (response) {
            if (response[0] && response[0][0] && response[0][0].ErrorMessage) {
              vm.$store.dispatch("toastr", {
                type: "error",
                header: "Error",
                message: "Error While Saving Card Details!",
              });
            } else {
              vm.$store.dispatch("toastr", {
                type: "success",
                header: "Success!",
                message: "Card Details Saved Successfully.",
              });
              if (
                vm.Reservation_Status.StatusId == 10 ||
                vm.Reservation_Status.StatusId == 12
              ) {
                vm.getReservationDetailById();
              }
            }
            console.log("response getPaymentCardDetails", response);
            vm.getPaymentCardDetails();
            // vm.showingdetails();
            //   for (var x in vm.guestPaymentCards) {
            //   let ccnumber = vm.guestPaymentCards[x].CreditCard;
            //   vm.guestPaymentCards[x].CreditCard = (ccnumber.replace(/(\d{4}(?!\s))/g, "$1 "));

            // }
          }
          vm.showPaymentList = true;
          if (vm.fromFolio) {
            vm.showPaymentDetails = false;
            vm.showPaymentOptions = false;
            vm.fromFolio = false;
          }
        },
      });
      // }
    },
    savePaymentCardInfoforGuest() {
      let vm = this;

      // let currentYear = moment().format("YYYY");
      // let currentMonth = moment().format("MM");

      // if (!vm.paymentCardInfo.PaymentTypeId) {
      //   vm.$store.dispatch("toastr", {
      //     type: "warning",
      //     header: "Warning!",
      //     message: "Please Select Payment Method"
      //   });
      // } else if (
      //   !vm.paymentCardInfo.CreditCard ||
      //   vm.paymentCardInfo.CreditCard.length < 10
      // ) {
      //   vm.$store.dispatch("toastr", {
      //     type: "warning",
      //     header: "Warning!",
      //     message: "Please enter card number"
      //   });
      // } else if (isNaN(vm.paymentCardInfo.CreditCard)) {
      //   vm.$store.dispatch("toastr", {
      //     type: "warning",
      //     header: "Warning!",
      //     message: "Please enter valid card number"
      //   });
      // } else if (vm.paymentCardInfo.ExpirationMonth == -1) {
      //   vm.$store.dispatch("toastr", {
      //     type: "warning",
      //     header: "Warning!",
      //     message: "Please select expiry month"
      //   });
      // } else if (vm.paymentCardInfo.ExpirationYear == -1) {
      //   vm.$store.dispatch("toastr", {
      //     type: "warning",
      //     header: "Warning!",
      //     message: "Please select expiry year"
      //   });
      // } else if (
      //   Number(vm.paymentCardInfo.ExpirationMonth) < currentMonth &&
      //   Number(vm.paymentCardInfo.ExpirationYear) <= currentYear
      // ) {
      //   vm.$store.dispatch("toastr", {
      //     type: "warning",
      //     header: "Warning!",
      //     message: "Please select valid expiry month/year"
      //   });
      // } else {
      // else if (!vm.paymentCardInfo.CvvCode || vm.paymentCardInfo.CvvCode.length < 3 || vm.paymentCardInfo.CvvCode.length > 3) {
      //   vm.$store.dispatch("toastr", {
      //     type: "warning",
      //     header: "Warning!",
      //     message: "Please enter valid CVV"
      //   });
      // }
      // vm.guestPaymentCards.push(vm.paymentCardInfo);
      vm.showPaymentDetails = false;

      let request = vm.paymentCardInfo;
      request.partyId = vm.guestInfo.GuestProfileId;
      request.partyTypeId = 3;
      for (let ledger of vm.paymentLedgerAcounts) {
        if (vm.paymentCardType === ledger.PaymentMethod) {
          request.PaymentTypeId = ledger.ledgerAccountID;
        }
      }
      vm.$store.dispatch("dataRequestHandler", {
        key: "SavePaymentDetails",
        params: {
          paymentDetails: vm.paymentCardInfo,
          Token: vm.cardTokenFromStripe,
          cardId: vm.stripecardId,
          stripePlatformAccount: vm.stripePlatformAccount,
          stripeConnectedAccount: vm.stripeConnectedAccount,
          // Savetoallfuturereservations: true,
        },
        callback: function (err, response) {
          if (err) {
            console.log("Error in saving payment details => ", err);
            vm.$store.dispatch("toastr", {
              type: "error",
              header: "Error",
              message: "Error While Saving Card Details!",
            });
            return;
          }
          if (response) {
            if (response[0] && response[0][0] && response[0][0].ErrorMessage) {
              vm.$store.dispatch("toastr", {
                type: "error",
                header: "Error",
                message: "Error While Saving Card Details!",
              });
            } else {
              vm.$store.dispatch("toastr", {
                type: "success",
                header: "Success!",
                message: "Card Details Saved Successfully for guest.",
              });
            }
            console.log("response getPaymentCardDetails", response);
            vm.getPaymentCardDetails();
            // vm.showingdetails();
            //   for (var x in vm.guestPaymentCards) {
            //   let ccnumber = vm.guestPaymentCards[x].CreditCard;
            //   vm.guestPaymentCards[x].CreditCard = (ccnumber.replace(/(\d{4}(?!\s))/g, "$1 "));

            // }
          }
          vm.showPaymentList = true;
          if (vm.fromFolio) {
            vm.showPaymentDetails = false;
            vm.showPaymentOptions = false;
            vm.fromFolio = false;
          }
        },
      });
      // }
    },
    formatPriorStayDate(date) {
      console.log("date====>", date);
      // return moment(date, "YYYY-MM-DD").format("DD MMM");
      let vm = this;
      return moment(date).format("MMM DD");
    },
    formatUTCPriorStayDate(date) {
      console.log("date====>", date);
      // return moment(date, "YYYY-MM-DD").format("DD MMM");
      let vm = this;
      return moment.utc(date).format("MMM DD");
    },
    getDay(date) {
      let vm = this;
      return moment(date).format("ddd");
    },

    cancelPaymentCardInfo() {
      let vm = this;
      vm.showPaymentDetails = false;
      vm.showPaymentList = true;
      vm.disabledMultiSave = false;
      vm.addressAndZipcodeShow = false;
      if (vm.fromFolio) {
        vm.showPaymentOptions = false;
        vm.fromFolio = false;
      }
    },
    viewCurrentCardDetails(cardInfo) {
      let vm = this;
      vm.showPaymentDetails = true;
      vm.paymentCardType = null;
      vm.paymentCardInfo = JSON.parse(JSON.stringify(cardInfo));
    },
    showChildPaymentItems(payment) {
      let vm = this;
      console.log("showChildPaymentItems", payment);
      payment.showChildPaymentDetails = true;
    },
    hideChildPaymentItems(payment) {
      let vm = this;
      payment.showChildPaymentDetails = false;
      if (
        (vm.parentPaymentitemObj.PendingchildPaymentitems &&
          vm.parentPaymentitemObj.PendingchildPaymentitems.length > 0) ||
        (vm.pendingPaymentDetails && vm.pendingPaymentDetails.length > 0)
      ) {
        vm.showNextProcessButton = false;
      } else {
        vm.showNextProcessButton = true;
      }
      // vm.parentPaymentitemObj.PendingchildPaymentitems = [];
    },
    addPendingchildPaymentitems(payment, nextProcess, mode, childPayment) {
      let vm = this;
      vm.buttonName = "Process";
      if (nextProcess == "NextPaymentStatus") {
        payment.parentPaymentDetails.NextProcess = true;
        if (childPayment) {
          childPayment.NextProcess = true;
        }
      }
      if (nextProcess == "NextPaymentStatus2") {
        payment.parentPaymentDetails.NextProcess = false;
        if (childPayment) {
          childPayment.NextProcess = false;
        }
      }
      payment.showChildPaymentDetails = true;
      vm.showNextProcessButton = false;
      vm.$set(payment, "PendingchildPaymentitems", []);
      if (mode == "parent") {
        payment.PendingchildPaymentitems.push(
          Object.assign({}, payment.parentPaymentDetails)
        );
        payment.parentPaymentDetails = payment.parentPaymentDetails;
        vm.checkAmount = payment.parentPaymentDetails.Amount;
      } else if (mode == "child") {
        payment.PendingchildPaymentitems.push(Object.assign({}, childPayment));
        payment.parentPaymentDetails.NextPaymentStatusId =
          childPayment.NextPaymentStatusId;
        payment.parentPaymentDetails.NextPaymentStatusId2 =
          childPayment.NextPaymentStatusId2;
        vm.checkAmount = childPayment.Amount;
      }

      vm.parentPaymentitemObj = payment;
      vm.showAddPaymentDetail = true;
      vm.showPayments = true;
      vm.showPaymentDetails = false;
      vm.Cancel(); //Cancelling add folio items
      vm.CancelUpdateFolioItem();
      // if(Amount <= payment.Amount){

      // }else{
      //   vm.$store.dispatch("toastr", {
      //     type: "warning",
      //     header: "warning!",
      //     message: "Amount sholud be equal or less than the charged or authorized amount"
      //   });
      // }
    },
    GetCardType(number) {
      let vm = this;
      vm.paymentCardType = null;
      // visa
      var re = new RegExp("^4");
      if (number.match(re) != null) {
        vm.paymentCardType = "Visa";
        vm.paymentCardInfo.CardType = "Visa";
        // vm.paymentCardInfo.PaymentTypeId = 8;
        return "Visa";
      }
      // Mastercard
      // Updated for Mastercard 2017 BINs expansion
      // if (/^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(number))
      //     {vm.paymentCardType = "MasterCard"
      //     return {cardType:"Mastercard",paymentTypeId:9};
      //     }
      re = new RegExp(
        "^(5[1-5]\\d{0,2}|22[2-9]\\d{0,1}|2[3-7]\\d{0,2})\\d{0,12}"
      );
      if (number.match(re) != null) {
        vm.paymentCardType = "MasterCard";
        vm.paymentCardInfo.CardType = "MasterCard";
        // vm.paymentCardInfo.PaymentTypeId = 9;
        return "Mastercard";
      }
      // AMEX
      re = new RegExp("^3[47]\\d{0,13}"); //new RegExp("^3[47]");
      if (number.match(re) != null) {
        vm.paymentCardType = "American Express";
        vm.paymentCardInfo.CardType = "American Express";
        // vm.paymentCardInfo.PaymentTypeId = 7;
        return "AMEX";
      }

      // Discover ^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)
      re = new RegExp("(?:6011|65\\d{0,2}|64[4-9]\\d?)\\d{0,12}");
      if (number.match(re) != null) {
        vm.paymentCardType = "Discover";
        vm.paymentCardInfo.CardType = "Discover";
        // vm.paymentCardInfo.PaymentTypeId = 10;
        return "Discover";
      } else {
        vm.paymentCardType = "Other";
        vm.paymentCardInfo.CardType = "Other";
        return "Other";
      }

      // // Diners
      // re = new RegExp("^36");
      // if (number.match(re) != null)
      //   {vm.paymentCardType = "Diners"
      //   return {cardType:"Diners",paymentTypeId:7};}

      // // Diners - Carte Blanche
      // re = new RegExp("^30[0-5]");
      // if (number.match(re) != null)
      //   {vm.paymentCardType = "Diners"
      //   return {cardType:"Diners - Carte Blanche",paymentTypeId:7};}

      // // JCB
      // re = new RegExp("^35(2[89]|[3-8][0-9])");
      // if (number.match(re) != null)
      //   {vm.paymentCardType = "JCB"
      //   return {cardType:"JCB",paymentTypeId:7};}

      // // Visa Electron
      // re = new RegExp("^(4026|417500|4508|4844|491(3|7))");
      // if (number.match(re) != null)
      //   {vm.paymentCardType = "Visa Electron"
      //   return {cardType:"Visa Electron",paymentTypeId:7};}

      return "";
    },
    showTransactionData(data) {
      let vm = this;
      // paymentDetails = Object.keys(paymentDetails).map(function(key, index) {
      //   return paymentDetails[key];
      // });
      // if (mode == "parent") {
      // for (let payment of childPayment) {
      //   payment.showGatewayResponseData = false;
      // }
      // for (let paymentDetailObj of paymentDetails) {
      //   if (
      //     JSON.stringify(paymentDetailObj.parentPaymentDetails) ===
      //     JSON.stringify(parentPayment)
      //   ) {
      //     parentPayment.showGatewayResponseData = !parentPayment.showGatewayResponseData;
      vm.modalParams = {
        popupTitle: "Transaction Details",
        popupMessage: JSON.stringify(JSON.parse(data), null, "\t"),
        yesButtontext: null,
        noButtonText: null,
        yesButtonCallback: null,
        noButtonCallback: null,
        code: true,
        className: "payment-info-modal",
      };
      vm.isModalVisible = true;
      //   } else {
      //     for (let childPayment of paymentDetailObj.childPaymentDetails) {
      //       childPayment.showGatewayResponseData = false;
      //     }
      //     paymentDetailObj.parentPaymentDetails.showGatewayResponseData = false;
      //   }
      // }
      // }s
      // if (mode == "child") {
      //   vm.modalParams = {
      //     popupTitle: "Transaction Details",
      //     popupMessage: JSON.stringify(JSON.parse(childPayment[index].gatewayResponseData), null, "\t"),
      //     yesButtontext: null,
      //     noButtonText: null,
      //     yesButtonCallback: null,
      //     noButtonCallback: null,
      //     code: true,
      //     className: "payment-info-modal"
      //   };
      //   vm.isModalVisible = true;
      //   console.log("paymentDetails", paymentDetails);
      // for (let paymentDetailObj of paymentDetails) {
      //   paymentDetailObj.parentPaymentDetails.showGatewayResponseData = false;
      //   for (let childPaymentObj of paymentDetailObj.childPaymentDetails) {
      //     if (
      //       JSON.stringify(childPayment[index]) ===
      //       JSON.stringify(childPaymentObj)
      //     ) {
      //       childPaymentObj.showGatewayResponseData = !childPaymentObj.showGatewayResponseData;
      //     } else {
      //       childPaymentObj.showGatewayResponseData = false;
      //     }
      //   }
      // }
      // for(let payment of childPayment){
      //   if(JSON.stringify(childPayment[index]) === JSON.stringify(payment)){
      //     childPayment[index].showGatewayResponseData = !childPayment[index].showGatewayResponseData;
      //   }else{
      //     payment.showGatewayResponseData = false;
      //   }
      // }
      // }
    },
    captureChargeOrRefund() {
      let vm = this;
      let reTries = 1;
      vm.isModalVisible = false;
      // if (
      //   vm.commissionAmmount.IsPercent == true &&
      //   vm.commissionAmmount.CommissionValue
      // ) {
      //   vm.FeeCollected =
      //     (vm.commissionAmmount.CommissionValue / 100) *
      //     vm.parentPaymentitemObj.PendingchildPaymentitems[0].BalanceAmount;
      // } else if (vm.commissionAmmount.CommissionValue) {
      //   vm.FeeCollected = vm.commissionAmmount.CommissionValue;
      // } else {
      //   vm.FeeCollected = 0;
      // }
      let processId;
      if (vm.parentPaymentitemObj.PendingchildPaymentitems[0].NextProcess) {
        processId =
          vm.parentPaymentitemObj.parentPaymentDetails.NextPaymentStatusId;
      } else {
        processId =
          vm.parentPaymentitemObj.parentPaymentDetails.NextPaymentStatusId2;
      }
      if (processId == 6 || processId == 8) {
        vm.FeeCollected = null;
      }
      if (
        vm.parentPaymentitemObj.PendingchildPaymentitems[0].BalanceAmount <=
          vm.checkAmount &&
        vm.parentPaymentitemObj.PendingchildPaymentitems[0].BalanceAmount > 0
      ) {
        let surchargeLedgerAcountId = vm.LedgerAcounts.filter((ledger) => {
          if (ledger.ledgerAccountName == "Payment Processing Fee") {
            return ledger;
          }
        });
        vm.disableMultiProcess = true;
        vm.$store.dispatch("dataRequestHandler", {
          key: "captureChargeOrRefund",
          params: {
            ModuleAction: "captureChargeOrRefund",
            payment: vm.parentPaymentitemObj.parentPaymentDetails,
            paymentDetails: vm.parentPaymentitemObj.PendingchildPaymentitems[0],
            paymentCardDetails: vm.selectedPaymentCardDetails,
            stripePlatformAccount: vm.stripePlatformAccount,
            stripeConnectedAccount: vm.stripeConnectedAccount,
            commissionAmmount: vm.commissionAmmount,
            guestInfo: vm.guestInfo,
            dateEffective: moment().format("YYYY-MM-DD HH:mm:ss"),
            surchargeAmount: vm.surchargeAmount,
            surchargeLedgerAcountId: surchargeLedgerAcountId.length
              ? surchargeLedgerAcountId[0].ledgerAccountID
              : null,
          },
          callback: function (err, response) {
            if (err) {
              vm.disableMultiProcess = false;
              // reTries++;
              // if (reTries <= 3) {
              // vm.captureChargeOrRefund();
              vm.$store.dispatch("toastr", {
                type: "error",
                header: "Error!",
                message: "Failed",
              });
              vm.save_Notification(
                3,
                28,
                vm.parentPaymentitemObj.PendingchildPaymentitems[0]
                  .BalanceAmount
              );
              // vm.chargeItem.chargeId = vm.parentPaymentitemObj && vm.parentPaymentitemObj.parentPaymentDetails && vm.parentPaymentitemObj.parentPaymentDetails.ChargeId ?
              //   vm.parentPaymentitemObj.parentPaymentDetails.ChargeId : null;
              // // }
              // vm.chargeItem.stripeConnectedAccount = vm.stripeConnectedAccount && vm.stripeConnectedAccount.PaymentAccountId ? vm.stripeConnectedAccount.PaymentAccountId : null;
              // vm.chargeItem.gatewayId = vm.stripePlatformAccount && vm.stripePlatformAccount.GatewayId ? vm.stripePlatformAccount.GatewayId : null;
              // vm.chargeItem.GatewayResponse = JSON.stringify(err);
              // vm.paymentProcessMethod = 3;

              // let ledgerAccountID = null;
              // let paymentInfoId = null;
              // if (vm.parentPaymentitemOb && vm.parentPaymentitemObj.PendingchildPaymentitems && vm.parentPaymentitemObj
              //   .PendingchildPaymentitems[0] && vm.parentPaymentitemObj.PendingchildPaymentitems[0].PaymentTypeId) {
              //   ledgerAccountID = vm.parentPaymentitemObj.PendingchildPaymentitems[0].PaymentTypeId
              // }
              // else {
              //   vm.Save_ErrorLogs(JSON.stringify({ err: err, PaymentTypeId: vm.parentPaymentitemObj }));
              //   return
              // }

              // if (vm.parentPaymentitemOb && vm.parentPaymentitemObj.PendingchildPaymentitems && vm.parentPaymentitemObj
              //   .PendingchildPaymentitems[0] && vm.parentPaymentitemObj.PendingchildPaymentitems[0].PaymentInfoId) {
              //   paymentInfoId = vm.parentPaymentitemObj.PendingchildPaymentitems[0].PaymentInfoId
              // }
              // else {
              //   vm.Save_ErrorLogs(JSON.stringify({ err: err, PaymentInfoId: vm.parentPaymentitemObj }));
              //   return
              // }
              // vm.addFolioItem({
              //   ledgerAccountID: ledgerAccountID,
              //   defaultAmount: vm.parentPaymentitemObj && vm.parentPaymentitemObj.PendingchildPaymentitems && vm.parentPaymentitemObj.PendingchildPaymentitems[0] && vm.parentPaymentitemObj.PendingchildPaymentitems[0]["BalanceAmount"] ?
              //     vm.parentPaymentitemObj.PendingchildPaymentitems[0]["BalanceAmount"] : null,
              //   paymentInfoId: paymentInfoId,
              //   dateEffective: moment().format("YYYY-MM-DD hh:mm:ss"),
              //   folioItemId:
              //     vm.parentPaymentitemObj.parentPaymentDetails.ItemId,
              //   fromPayment: true
              // });
              vm.showAddPaymentDetail = false;
              vm.parentPaymentitemObj.PendingchildPaymentitems = [];
              vm.parentPaymentitemObj = {};
              vm.checkAmount = null;
              vm.paymentProcessMethod = null;
              vm.paymentStatusId = null;
              vm.ShowDropdown = false;
              vm.selectedFolioItemToEdit = null;
              vm.getFolioSummary(true, null);
              vm.getPaymentDetails();
              // } else {
              //   console.log(err);
              //   vm.$store.dispatch("toastr", {
              //     type: "error",
              //     header: "Error!",
              //     message: "Failed"
              //   });
              //   return;
              // }
            }
            if (response) {
              vm.disableMultiProcess = false;
              console.log("response in Get_PaymentAccount_Details", response);
              if (response.message) {
                vm.paymentProcessMethod = 3;
                vm.$store.dispatch("toastr", {
                  type: "error",
                  header: "Error!",
                  message: "Error in creating refund/release/capture",
                });
                vm.save_Notification(
                  3,
                  28,
                  vm.parentPaymentitemObj.PendingchildPaymentitems[0]
                    .BalanceAmount
                );
              } else {
                if (
                  vm.parentPaymentitemObj.PendingchildPaymentitems[0]
                    .NextProcess
                ) {
                  vm.paymentProcessMethod =
                    vm.parentPaymentitemObj.parentPaymentDetails.NextPaymentStatusId;
                } else {
                  vm.paymentProcessMethod =
                    vm.parentPaymentitemObj.parentPaymentDetails.NextPaymentStatusId2;
                }
                vm.$store.dispatch("toastr", {
                  type: "success",
                  header: "success",
                  message: `${
                    vm.paymentProcessMethod == 6
                      ? "Refund"
                      : vm.paymentProcessMethod == 8
                      ? "Release"
                      : "Capture"
                  } successfull`,
                  // vm.parentPaymentitemObj.parentPaymentDetails
                  //   .NextPaymentStatusName + " successfull"
                });
                if (vm.paymentProcessMethod == 6) {
                  // || vm.paymentProcessMethod == 8) {
                  vm.getLogIdsByEventID(3, 13);
                  vm.save_Notification(
                    3,
                    13,
                    vm.parentPaymentitemObj.PendingchildPaymentitems[0]
                      .BalanceAmount
                  );
                } else if (vm.paymentProcessMethod == 2) {
                  vm.getLogIdsByEventID(3, 12);
                  console.log(
                    "vm.pendingPaymentDetails[0].surgeAmount",
                    Number(
                      vm.parentPaymentitemObj.PendingchildPaymentitems[0]
                        .BalanceAmount
                    ) + Number(vm.surchargeAmount)
                  );

                  vm.save_Notification(
                    3,
                    12,
                    Number(
                      vm.parentPaymentitemObj.PendingchildPaymentitems[0]
                        .BalanceAmount
                    ) + Number(vm.surchargeAmount)
                  );
                }
              }
              //   vm.$store.dispatch("toastr", {
              //     type: "error",
              //     header: "Error!",
              //     message: response.message ? response.message : vm.parentPaymentitemObj.parentPaymentDetails.NextPaymentStatusName + "failed"
              //   });
              // }else{
              // if(vm.parentPaymentitemObj.parentPaymentDetails.NextPaymentStatusId == 2){
              //   vm.chargeItem.chargeId = response.id;
              // }else if(vm.parentPaymentitemObj.parentPaymentDetails.NextPaymentStatusId == 6){
              // vm.chargeItem.chargeId = vm.parentPaymentitemObj && vm.parentPaymentitemObj.parentPaymentDetails ?
              //   vm.parentPaymentitemObj.parentPaymentDetails.ChargeId : null;
              // // }
              // vm.chargeItem.stripeConnectedAccount = vm.stripeConnectedAccount && vm.stripeConnectedAccount.PaymentAccountId ? vm.stripeConnectedAccount.PaymentAccountId : null;
              // vm.chargeItem.gatewayId = vm.stripePlatformAccount && vm.stripePlatformAccount.GatewayId ? vm.stripePlatformAccount.GatewayId : null;
              // vm.chargeItem.GatewayResponse = JSON.stringify(response);

              // let ledgerAccountID = null;
              // let paymentInfoId = null;
              // if (vm.parentPaymentitemObj && vm.parentPaymentitemObj.PendingchildPaymentitems && vm.parentPaymentitemObj
              //   .PendingchildPaymentitems[0] && vm.parentPaymentitemObj.PendingchildPaymentitems[0].PaymentTypeId) {
              //   ledgerAccountID = vm.parentPaymentitemObj.PendingchildPaymentitems[0].PaymentTypeId
              // }
              // else {
              //   vm.Save_ErrorLogs(JSON.stringify({ response: response, PaymentTypeId: vm.parentPaymentitemObj }));
              //   return
              // }

              // if (vm.parentPaymentitemObj && vm.parentPaymentitemObj.PendingchildPaymentitems && vm.parentPaymentitemObj
              //   .PendingchildPaymentitems[0] && vm.parentPaymentitemObj.PendingchildPaymentitems[0].PaymentInfoId) {
              //   paymentInfoId = vm.parentPaymentitemObj.PendingchildPaymentitems[0].PaymentInfoId
              // }
              // else {
              //   vm.Save_ErrorLogs(JSON.stringify({ response: response, PaymentInfoId: vm.parentPaymentitemObj }));
              //   return
              // }
              // vm.addFolioItem({
              //   ledgerAccountID: ledgerAccountID,
              //   defaultAmount: vm.parentPaymentitemObj && vm.parentPaymentitemObj.PendingchildPaymentitems && vm.parentPaymentitemObj.PendingchildPaymentitems[0] && vm.parentPaymentitemObj.PendingchildPaymentitems[0]["BalanceAmount"] ?
              //     vm.parentPaymentitemObj.PendingchildPaymentitems[0]["BalanceAmount"] : null,
              //   paymentInfoId: paymentInfoId,
              //   dateEffective: moment().format("YYYY-MM-DD hh:mm:ss"),
              //   folioItemId:
              //     vm.parentPaymentitemObj.parentPaymentDetails.ItemId,
              //   fromPayment: true
              // });
              vm.showAddPaymentDetail = false;
              vm.parentPaymentitemObj.PendingchildPaymentitems = [];
              vm.parentPaymentitemObj = {};
              vm.checkAmount = null;
              vm.paymentProcessMethod = null;
              vm.paymentStatusId = null;
              vm.ShowDropdown = false;
              vm.selectedFolioItemToEdit = null;
              vm.getFolioSummary(true, null);
              vm.getPaymentDetails();
              // }
            }
          },
        });
      } else {
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "warning!",
          message:
            "Amount sholud be equal to or less than the charged or authorized amount",
        });
        vm.disableMultiProcess = false;
      }
    },
    makeStripePayment(capture, directpayments) {
      let vm = this;
      let reTries = 1;
      vm.isModalVisible = false;
      if (
        (capture == null || capture == undefined) &&
        directpayments != "directpayments"
      ) {
        capture = true;
      }
      // if (
      //   vm.commissionAmmount && vm.commissionAmmount.IsPercent == true &&
      //   vm.commissionAmmount.CommissionValue
      // ) {
      //   vm.FeeCollected =
      //     (vm.commissionAmmount.CommissionValue / 100) *
      //     vm.pendingPaymentDetails[0].Amount;
      // } else if (vm.commissionAmmount && vm.commissionAmmount.CommissionValue) {
      //   vm.FeeCollected = vm.commissionAmmount.CommissionValue;
      // } else {
      //   vm.FeeCollected = 0;
      // }
      // if (!capture) {
      //   vm.FeeCollected = null;
      // }

      if (vm.stripeConnectedAccount) {
        let surchargeLedgerAcountId = vm.LedgerAcounts.filter((ledger) => {
          if (ledger.ledgerAccountName == "Payment Processing Fee") {
            return ledger;
          }
        });
        vm.disableMultiProcess = true;
        vm.$store.dispatch("dataRequestHandler", {
          key: "makeStripePayment",
          params: {
            ModuleAction: "makeStripePayment",
            paymentDetails: vm.pendingPaymentDetails[0],
            paymentCardDetails: vm.selectedPaymentCardDetails,
            stripePlatformAccount: vm.stripePlatformAccount,
            stripeConnectedAccount: vm.stripeConnectedAccount,
            commissionAmmount: vm.commissionAmmount,
            // FeeCollected: vm.FeeCollected,
            guestInfo: vm.guestInfo,
            roomInfo: vm.roomInfo,
            captureValue: capture,
            paymentStatusId: vm.paymentProcessMethod,
            dateEffective: moment().format("YYYY-MM-DD HH:mm:ss"),
            email:
              vm.additionalEmails.length > 0
                ? vm.additionalEmails[0].Emailaddress
                : "",
            phone:
              vm.additionalPhoneNumbers.length > 0
                ? vm.additionalPhoneNumbers[0].PhoneNumber
                : "",
            surchargeAmount: vm.surchargeAmount,
            surchargeLedgerAcountId: surchargeLedgerAcountId.length
              ? surchargeLedgerAcountId[0].ledgerAccountID
              : null,
          },
          callback: function (err, response) {
            if (err) {
              // reTries++;
              // if (reTries <= 3) {
              // vm.makeStripePayment(capture);
              vm.$store.dispatch("toastr", {
                type: "error",
                header: "Error!",
                message: "Failed",
              });
              vm.save_Notification(
                3,
                28,
                vm.pendingPaymentDetails[0]["Amount"]
              );
              // vm.paymentProcessMethod = 3;
              // vm.chargeItem.chargeId = null;
              // vm.chargeItem.stripeConnectedAccount = vm.stripeConnectedAccount && vm.stripeConnectedAccount.PaymentAccountId ?
              //   vm.stripeConnectedAccount.PaymentAccountId : null;
              // vm.chargeItem.gatewayId = vm.stripePlatformAccount && vm.stripePlatformAccount.GatewayId ? vm.stripePlatformAccount.GatewayId : null;
              // vm.chargeItem.GatewayResponse = JSON.stringify(err);
              // // let ledgerAccount = vm.paymentLedgerAcounts.filter(function (
              // //   ledgerAcc
              // // ) {
              // //   return (
              // //     ledgerAcc.PaymentMethod == "Cash" &&
              // //     vm.selectedPaymentCardDetails.PaymentInfoId == "Cash"
              // //   );
              // // });
              // let ledgerAccountID = null;
              // let paymentInfoId = null;

              // if (vm.selectedPaymentCardDetails && vm.selectedPaymentCardDetails.PaymentTypeId) {
              //   ledgerAccountID = vm.selectedPaymentCardDetails.PaymentTypeId
              // } else {
              //   vm.Save_ErrorLogs(JSON.stringify({ err: err, PaymentTypeId: vm.selectedPaymentCardDetails }));
              //   return
              // }

              // if (vm.selectedPaymentCardDetails && vm.selectedPaymentCardDetails.PaymentInfoId) {
              //   paymentInfoId = vm.selectedPaymentCardDetails.PaymentInfoId
              // } else {
              //   vm.Save_ErrorLogs(JSON.stringify({ err: err, PaymentInfoId: vm.selectedPaymentCardDetails }));
              //   return
              // }
              // vm.addFolioItem({
              //   ledgerAccountID: ledgerAccountID,
              //   defaultAmount: vm.pendingPaymentDetails && vm.pendingPaymentDetails[0] && vm.pendingPaymentDetails[0]["Amount"] ? vm.pendingPaymentDetails[0]["Amount"] : null,
              //   paymentInfoId: paymentInfoId,
              //   dateEffective: moment().format("YYYY-MM-DD hh:mm:ss"),
              //   fromPayment: true
              // });
              vm.showAddPaymentDetail = false;
              vm.disableMultiProcess = false;
              vm.parentPaymentitemObj = {};
              vm.checkAmount = null;
              vm.paymentProcessMethod = null;
              vm.paymentStatusId = null;
              vm.ShowDropdown = false;
              vm.selectedFolioItemToEdit = null;
              vm.getFolioSummary(true, null);
              vm.getPaymentDetails();

              // }
            }
            if (response) {
              vm.disableMultiProcess = false;
              console.log("response in makeStripePayment", response);
              // if(response.message){
              //   vm.$store.dispatch("toastr", {
              //     type: "error",
              //     header: "Error!",
              //     message: response.message
              //   });
              // }else{
              if (response.message) {
                // vm.paymentProcessMethod = 3;
                // vm.chargeItem.chargeId = null;
                vm.$store.dispatch("toastr", {
                  type: "error",
                  header: "Error!",
                  message: "Error in Authorized/Charged",
                });
                vm.save_Notification(
                  3,
                  28,
                  vm.pendingPaymentDetails[0]["Amount"]
                );
              } else {
                vm.paymentProcessMethod = vm.paymentStatusId;
                // vm.chargeItem.chargeId = response.id ? response.id : null;
                vm.$store.dispatch("toastr", {
                  type: "success",
                  header: "success!",
                  message: "Authorized/Charged successfully",
                });
                if (capture) {
                  //  vm.pendingPaymentDetails[0].surgeAmount= vm.surchargeAmount;
                  // vm.pendingPaymentDetails[0].Amount= vm.amountForSurge;
                  // +.pendingPaymentDetails[0]["Amount"] + +vm.surchargeAmount
                  console.log(
                    "totalAmount =================",
                    +vm.pendingPaymentDetails[0]["Amount"] + +vm.surchargeAmount
                  );

                  console.log(
                    "vm.pendingPaymentDetails[0].surgeAmount",
                    Number(vm.pendingPaymentDetails[0]["Amount"]) +
                      Number(vm.surchargeAmount)
                  );

                  vm.save_Notification(
                    3,
                    12,
                    Number(vm.pendingPaymentDetails[0]["Amount"]) +
                      Number(vm.surchargeAmount)
                  );
                } else {
                  vm.save_Notification(
                    3,
                    27,
                    vm.pendingPaymentDetails[0]["Amount"]
                  );
                }
              }

              // vm.chargeItem.stripeConnectedAccount = vm.stripeConnectedAccount && vm.stripeConnectedAccount.PaymentAccountId ?
              //   vm.stripeConnectedAccount.PaymentAccountId : null;
              // vm.chargeItem.gatewayId = vm.stripePlatformAccount && vm.stripePlatformAccount.GatewayId ? vm.stripePlatformAccount.GatewayId : null;
              // vm.chargeItem.GatewayResponse = JSON.stringify(response);
              // // let ledgerAccount = vm.paymentLedgerAcounts.filter(function (
              // //   ledgerAcc
              // // ) {
              // //   return (
              // //     ledgerAcc.PaymentMethod == "Cash" &&
              // //     vm.selectedPaymentCardDetails.PaymentInfoId == "Cash"
              // //   );
              // // });
              // let ledgerAccountID = null;
              // let paymentInfoId = null;

              // if (vm.selectedPaymentCardDetails && vm.selectedPaymentCardDetails.PaymentTypeId) {
              //   ledgerAccountID = vm.selectedPaymentCardDetails.PaymentTypeId
              // } else {
              //   vm.Save_ErrorLogs(JSON.stringify({ response: response, PaymentTypeId: vm.selectedPaymentCardDetails }));
              //   return
              // }

              // if (vm.selectedPaymentCardDetails && vm.selectedPaymentCardDetails.PaymentInfoId) {
              //   paymentInfoId = vm.selectedPaymentCardDetails.PaymentInfoId
              // } else {
              //   vm.Save_ErrorLogs(JSON.stringify({ response: response, PaymentInfoId: vm.selectedPaymentCardDetails }));
              //   return
              // }
              // vm.addFolioItem({
              //   ledgerAccountID: ledgerAccountID,
              //   defaultAmount: vm.pendingPaymentDetails && vm.pendingPaymentDetails[0] && vm.pendingPaymentDetails[0]["Amount"] ? vm.pendingPaymentDetails[0]["Amount"] : null,
              //   paymentInfoId: paymentInfoId,
              //   dateEffective: moment().format("YYYY-MM-DD hh:mm:ss"),
              //   fromPayment: true
              // });
              vm.showAddPaymentDetail = false;
              vm.parentPaymentitemObj = {};
              vm.checkAmount = null;
              vm.paymentProcessMethod = null;
              vm.paymentStatusId = null;
              vm.ShowDropdown = false;
              vm.selectedFolioItemToEdit = null;
              vm.getFolioSummary(true, null);
              vm.getPaymentDetails();
              // }
            }
          },
        });
      } else {
        vm.disableMultiProcess = false;
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "warning!",
          message: "No connected account",
        });
      }
    },
    closepopup() {
      let vm = this;
      vm.modalParams = null;
      vm.isModalVisible = false;
    },
    closeBTpopup() {
      let vm = this;
      vm.modalParams = null;
      vm.isBalanceTransferModalVisible = false;
    },
    makePaymentOnGateway(typeodPayment, processId) {
      let vm = this;
      let yespaymentOptioncall = null,
        amountval;
      if (typeodPayment == "makeStripePayment") {
        yespaymentOptioncall = vm.makeStripePayment;
        amountval = vm.pendingPaymentDetails[0]["Amount"];
      } else {
        yespaymentOptioncall = vm.captureChargeOrRefund;
        amountval =
          vm.parentPaymentitemObj.PendingchildPaymentitems[0]["BalanceAmount"];
      }
      vm.$store.dispatch("dataRequestHandler", {
        key: "getSurCharges",
        params: {
          stripeConnectedAccount: vm.stripeConnectedAccount,
          amount: amountval,
          paymentCardDetails: vm.selectedPaymentCardDetails,
        },
        callback: function (err, response) {
          if (err) {
            vm.$store.dispatch("toastr", {
              type: "error",
              header: "Error",
              message: err,
            });
            return;
          }
          if (response) {
            vm.surchargeAmount = response.reply.datablock.surcharge;
            vm.isModalVisible = true;
            let popupMessage = `<div class="dTable">
                <div class="dTHead">
                  <div class="dCell" style="text-align: left;padding-top: 0;font-weight: 600;">Item Description</div>
                  <div class="dCell" style="text-align: right;padding-top: 0;font-weight: 600;">Value</div>
                </div>
                <div class="dTBody folioBody" style="font-size: 13px">
                  <div class="dTBodyRow newFolio">
                    <div class="dCell" style="text-align: left;">Amount</div>
                    <div class="dCell" style="text-align: right;">${
                      amountval ? "$" : ""
                    } ${amountval}</div>
                  </div>
                  <div class="dTBodyRow newFolio">
                    <div class="dCell" style="text-align: left;"> Payment Processing Fee(#% Surcharge on Credit card)</div>
                    <div class="dCell" style="text-align: right;">${
                      response.reply.datablock.surcharge ? "$" : ""
                    } ${response.reply.datablock.surcharge}</div>
                  </div>
                </div>
                <div class="dTBody folioFooter" style="font-size: 14px">
                    <div class="dTBodyRow">
                      <div class="dCell pb-0" style="font-weight: bold; text-align: left;font-weight: 600 !important;font-size: 16px !important;">Total</div>
                      <div class="dCell pb-0" style="text-align: right;font-weight: 600 !important;font-size: 16px !important;">${
                        response.reply.datablock.amount ? "$" : ""
                      } ${response.reply.datablock.amount}</div>
                    </div>
                </div>
                </div>`;
            vm.modalParams = {
              popupTitle: "Confirm Payment Account",
              popupMessage: popupMessage,
              displayYesNoButtons: true,
              yesButtontext: "Process",
              noButtonText: "Cancel",
              yesButtonCallback: yespaymentOptioncall,
              noButtonCallback: vm.closepopup,
              cancelbuttonCallback: vm.closepopup,
              isFrom: "resFolio",
              html: true,
            };
          }
        },
      });
    },
    makePayment() {
      let vm = this;
      let capture;

      // vm.pendingPaymentDetails[0]["Amount"]=vm.pendingPaymentDetails[0]["Amount"].replace('$','')
      if (vm.$route.params.ReservationId != -1) {
        if (
          vm.parentPaymentitemObj.PendingchildPaymentitems &&
          vm.parentPaymentitemObj.PendingchildPaymentitems.length > 0
        ) {
          if (vm.stripeConnectedAccount) {
            let processId = null;
            if (
              vm.parentPaymentitemObj.PendingchildPaymentitems[0].NextProcess
            ) {
              processId =
                vm.parentPaymentitemObj.parentPaymentDetails
                  .NextPaymentStatusId;
            } else {
              processId =
                vm.parentPaymentitemObj.parentPaymentDetails
                  .NextPaymentStatusId2;
            }
            if (
              vm.stripeConnectedAccount.GatewayId == 2 &&
              processId != 6 &&
              processId != 8
            ) {
              vm.makePaymentOnGateway("captureChargeOrRefund", processId);
            } else {
              vm.captureChargeOrRefund();
            }
          } else {
            vm.$store.dispatch("toastr", {
              type: "warning",
              header: "warning!",
              message: "No connected account",
            });
          }
        } else {
          if (
            vm.paymentProcessMethod == 1 &&
            vm.pendingPaymentDetails &&
            vm.pendingPaymentDetails[0] &&
            vm.pendingPaymentDetails[0]["Amount"] > 0
          ) {
            console.log(vm.pendingPaymentDetails[0]);
            capture = false;
            vm.makeStripePayment(capture);
            vm.paymentStatusId = vm.paymentProcessMethod;
            //  vm.save_Notification(3,27,vm.pendingPaymentDetails[0]["Amount"]);
          } else if (
            vm.paymentProcessMethod == 7 &&
            vm.pendingPaymentDetails &&
            vm.pendingPaymentDetails[0] &&
            vm.pendingPaymentDetails[0]["Amount"] > 0
          ) {
            capture = true;
            if (vm.stripeConnectedAccount.GatewayId == 2) {
              vm.makePaymentOnGateway(
                "makeStripePayment",
                vm.paymentProcessMethod
              );
            } else {
              vm.makeStripePayment(capture, "directpayments");
            }
            vm.paymentStatusId = vm.paymentProcessMethod;
            vm.getLogIdsByEventID(3, 12);
            //  vm.save_Notification(3,12,vm.pendingPaymentDetails[0]["Amount"]);
          } else if (
            vm.selectedPaymentCardDetails &&
            (vm.selectedPaymentCardDetails.IsCreditcard == false ||
              vm.selectedPaymentCardDetails.IsCreditcard == 0)
          ) {
            vm.disableMultiProcess = true;
            // let ledgerAccount = vm.paymentLedgerAcounts.filter(function (ledgerAcc) {
            //   console.log("ledgerAccountledgerAccount", ledgerAccount)
            //   return (
            //     ledgerAcc.PaymentMethod == vm.selectedPaymentCardDetails.PaymentInfoId
            //   );
            // });
            // console.log("ledgerAccount", ledgerAccount);

            vm.FeeCollected = null;
            vm.chargeItem.chargeId = null;
            vm.chargeItem.stripeConnectedAccount = null;
            vm.chargeItem.gatewayId = null;
            vm.chargeItem.GatewayResponse = null;
            vm.addFolioItem(
              {
                ledgerAccountID: vm.selectedPaymentCardDetails.ledgerid,
                defaultAmount: vm.pendingPaymentDetails[0]["Amount"],
                paymentInfoId: null,
                dateEffective: moment(
                  vm.pendingPaymentDetails[0]["dateEffective"]
                ).format("YYYY-MM-DD HH:mm:ss"),
                fromPayment: true,
                TaxAmount: null,
              },
              null
            );
            if (vm.pendingPaymentDetails[0]["Amount"] > 0) {
              vm.getLogIdsByEventID(3, 12);
              vm.save_Notification(
                3,
                12,
                vm.pendingPaymentDetails[0]["Amount"]
              );
            } else {
              vm.getLogIdsByEventID(3, 13);
              vm.save_Notification(
                3,
                13,
                vm.pendingPaymentDetails[0]["Amount"]
              );
            }

            vm.showAddPaymentDetail = false;
            vm.disableMultiProcess = false;
            vm.chargeItem = {};
          } else {
            if (vm.pendingPaymentDetails[0]["Amount"] <= 0) {
              vm.$store.dispatch("toastr", {
                type: "warning",
                header: "warning",
                message: "Invalid Amount",
              });
            } else {
              vm.$store.dispatch("toastr", {
                type: "error",
                header: "Error",
                message: "Please select payment method/Transaction",
              });
            }
          }
        }
      } else {
        vm.$store.dispatch("toastr", {
          type: "error",
          header: "Error",
          message: "Please save room info",
        });
      }
    },

    selectPaymentDetails(cardDetails, type) {
      console.log("cardDetails", cardDetails);
      this.paymentProcessMethod = null;
      if (type == "manual") {
        this.selectedPaymentCardDetails = {
          PaymentInfoId: cardDetails.PaymentMethod,
          ledgerid: cardDetails.ledgerAccountID,
          IsCreditcard: cardDetails.IsCreditcard,
        };
        this.buttonName = "Save";
      } else {
        this.selectedPaymentCardDetails = cardDetails;
        this.buttonName = "Process";
      }
    },
    displayPaymentsSection() {
      this.displaySection("reservation3");
      this.isBgColor6 = false;
      this.isBgColor5 = true;
      this.isBgColor1 = false;
      this.isBgColor2 = false;
      this.isBgColor3 = false;
      this.isBgColor4 = false;
      this.isBgColor7 = false;
      this.showPaymentOptions = true;
      this.showPaymentList = true;
    },
    showAllPaymentOptions() {
      this.showPaymentOptions = true;
      this.showPaymentDetails = false;
    },
    cancelPayment() {
      this.showAddPaymentDetail = false;
      this.disableMultiProcess = false;
      this.parentPaymentitemObj.PendingchildPaymentitems = [];
      this.pendingPaymentDetails.splice(
        this.pendingPaymentDetails.length - 1,
        1
      );
      this.showNextProcessButton = true;
    },
    formatMoney(amount) {
      return this.$store.state.getFormattedAmount("$", amount);
    },
    formatFromNightlyCharges(amount) {
      let currency = accounting.formatMoney(amount, {
        symbol: "$",
        format: {
          pos: "%s %v",
          neg: "%s (%v)",
          zero: "%s  %v",
        },
        thousand: ",",
        precision: 0,
        decimal: ".",
      });

      return currency;
    },
    formatBalanceTransferAmount(amount) {
      if (
        amount != undefined &&
        amount != null &&
        amount != "null" &&
        amount != "undefined"
      ) {
        let currency = accounting.formatMoney(amount, {
          symbol: "$",
          format: {
            pos: "%s %v",
            neg: "%s %v",
            zero: "%s  %v",
          },
          thousand: ",",
          precision: 2,
          decimal: ".",
        });
        return currency;
      } else {
        return "";
      }
    },

    editFolioItem() {
      if (
        !this.isFolioDirty &&
        (this.selectedFolioItemToEdit === null ||
          JSON.stringify(this.selectedFolioItemToEdit) !=
            JSON.stringify(this.itemToEdit)) &&
        !this.itemToEdit.IsVoided
      ) {
        this.folioUpdate = true;
        this.selectedFolioItemToEdit = JSON.parse(
          JSON.stringify(this.itemToEdit)
        );
        this.selectedFolioItemActualJson = JSON.parse(
          JSON.stringify(this.itemToEdit)
        );
        console.log("folioItemfolioItem", this.itemToEdit.Ischecked);

        if (this.itemToEdit.Ischecked) {
          if (this.folioItemsToVoid.includes(this.itemToEdit.ItemId)) {
            var index = this.folioItemsToVoid.indexOf(this.itemToEdit.ItemId);

            if (index > -1) {
              this.folioItemsToVoid.splice(index, 1);
            }
          }
        } else {
          this.folioItemsToVoid.push(this.itemToEdit.ItemId);
        }

        // this.$set(folioItem, 'editable', true);
        if (this.selectedLedger) {
          this.selectedLedger.dateEffective = moment(
            this.selectedFolioItemToEdit.ActualDateEffective
          ).format("YYYY-MM-DD");
        }
      }
      this.itemToEdit = null;
      // this.ShowDropdown = false;
    },
    expandPreview() {
      let vm = this;
      // vm.previewItems = [];
      // // var pre = [],
      // //   currentDate = startDate,
      // var currDate = moment(vm.selectedLedger.dateEffective).startOf('day');
      // var lastDate = moment(vm.roomInfo.EndDate).startOf('day');

      // while (currDate.add(1, 'days').diff(lastDate) <= 0) {
      //   console.log(currDate.toDate());
      //   // dates.push(currDate.clone().toDate());
      //   let obj = {};
      //   obj.dateEffective = moment(currDate.toDate()).format("YYYY-MM-DD");
      //   obj.defaultAmount = vm.selectedLedger.defaultAmount
      //   obj.folioItemId = vm.selectedLedger.folioItemId
      //   obj.ledgerAccountID = vm.selectedLedger.ledgerAccountID
      //   obj.paymentInfoId = vm.selectedLedger.paymentInfoId

      //   vm.previewItems.push(obj);
      // }
      if (vm.selectedLedger && !vm.selectedLedger.ledgerAccountID) {
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "warning",
          message: "select the ledger",
        });
        return;
      }
      if (vm.selectedLedger.ledgerAccountID) {
        if (vm.selectedLedger.ledgerAccountTypeID) {
          if (
            vm.selectedLedger.ledgerAccountTypeID == 4 &&
            (!vm.selectedLedger.TaxAmount || vm.selectedLedger.TaxAmount == 0)
          ) {
            this.$store.dispatch("toastr", {
              type: "warning",
              header: "Warning",
              message: "Please enter amount",
            });
            return;
          }
        } else if (
          !vm.selectedLedger.ledgerAccountTypeID &&
          (!vm.selectedLedger.defaultAmount ||
            vm.selectedLedger.defaultAmount == 0)
        ) {
          this.$store.dispatch("toastr", {
            type: "warning",
            header: "Warning",
            message: "Please enter amount",
          });
          return;
        }
      }
      vm.getFolioSummary(false);
      // vm.ShowDropdown = false;
      vm.showPreviewButton = false;
    },
    updateFolioEffectiveDate(key, dateObj, objectPassedToParent) {
      objectPassedToParent.dateEffective = dateObj
        ? dateObj.format("DD MMM YYYY")
        : null;
      console.log("updateFolioEffectiveDateupdateFolioEffectiveDate", dateObj);
      if (objectPassedToParent.hasOwnProperty("ActualDateEffective"))
        objectPassedToParent.ActualDateEffective = dateObj
          ? dateObj.format("YYYY-MM-DD")
          : null;
      else if (objectPassedToParent.hasOwnProperty("dateEffective"))
        objectPassedToParent.ActualDateEffective = dateObj
          ? dateObj.format("YYYY-MM-DD")
          : null;

      if (objectPassedToParent.hasOwnProperty("ItemId")) {
        let folioList = this.folioItemsDetails.map((folioItem) => {
          return folioItem.ItemId;
        });
        let folioIndex = folioList.indexOf(objectPassedToParent["ItemId"]);
        if (folioIndex > -1) {
          console.log(this.folioItemsDetails[folioIndex].DateEffective);
          console.log(this.selectedFolioItemToEdit.DateEffective);
          if (
            moment(this.folioItemsDetails[folioIndex].DateEffective).isSame(
              dateObj.format("YYYY-MM-DD")
            )
          ) {
            this.folioDateChange = false;
          } else {
            this.folioDateChange = true;
          }
        } else {
          this.folioDateChange = false;
        }
      }
    },
    UpdateCurrentFolioItem() {
      if (this.selectedFolioItemToEdit) {
        if (this.selectedFolioItemToEdit.ledgerAccountTypeID) {
          if (
            this.selectedFolioItemToEdit.ledgerAccountTypeID == 4 &&
            (!this.selectedFolioItemToEdit.ActualTaxAmount ||
              this.selectedFolioItemToEdit.ActualTaxAmount == 0)
          ) {
            this.$store.dispatch("toastr", {
              type: "warning",
              header: "Warning",
              message: "Please enter amount",
            });
            return;
          }
        } else if (
          !this.selectedFolioItemToEdit.ledgerAccountTypeID &&
          (!this.selectedFolioItemToEdit.ActualFolioAmount ||
            this.selectedFolioItemToEdit.ActualFolioAmount == 0)
        ) {
          this.$store.dispatch("toastr", {
            type: "warning",
            header: "Warning",
            message: "Please enter amount",
          });
          return;
        }
        this.addFolioItem(
          {
            ledgerAccountID: this.selectedFolioItemToEdit.ledgerAccountId,
            defaultAmount:
              this.selectedFolioItemToEdit.ledgerAccountTypeID &&
              this.selectedFolioItemToEdit.ledgerAccountTypeID == 4
                ? this.selectedFolioItemToEdit.ActualTaxAmount
                : this.selectedFolioItemToEdit.ActualFolioAmount,
            paymentInfoId: null,
            folioItemId: this.selectedFolioItemToEdit.ItemId,
            dateEffective: this.selectedFolioItemToEdit.ActualDateEffective,
            fromPayment: false,
            TaxAmount: this.selectedFolioItemToEdit.ActualTaxAmount,
          },
          "folioChange"
        );
        this.isFolioDirty = false;
        this.selectAllFolio = false;
      }
    },
    VoidCurrentFolioItem() {
      let vm = this;
      vm.selectedVoidItem = false;
      console.log("fruits.join()", vm.folioItemsToVoid.join());
      vm.selectAllFolio = false;
      vm.$store.dispatch("dataRequestHandler", {
        key: "VoidFolioItem",
        params: {
          ItemId: vm.folioItemsToVoid.join(),
          Notes: null,
          unitId: vm.roomInfo.UnitId,
          reservationId: vm.guestInfo.ReservationId,
        },
        callback: function (err, response) {
          if (err) {
            console.log("err in VoidCurrentFolioItem", err);
            vm.$store.dispatch("toastr", {
              type: "error",
              header: "Error",
              message: "Error while voiding folio item",
            });
            return;
          }
          if (response) {
            vm.$store.dispatch("toastr", {
              type: "success",
              header: "Success!",
              message: "Folio Updated Successfully.",
            });
            console.log("response in void", response);
            vm.getFolioSummary(false, "folioChange");
            vm.getPaymentDetails();
            vm.selectedFolioItemToEdit = null;
            vm.folioUpdate = false;
            vm.isFolioDirty = false;
            vm.itemToEdit = null;
            vm.checkedItems = [];
            vm.selectedVoidItem = false;
            vm.selectedItemCount = true;
            vm.getLogIdsByEventID(2, 9);
            vm.save_Notification(2, 9, vm.notificationAmount);
          }
        },
      });
    },
    CancelUpdateFolioItem() {
      if (this.selectedFolioItemToEdit) {
        let previousFolioItemIndex = this.previousFolioItemDetails
          .map((x) => {
            return x.ItemId;
          })
          .indexOf(this.selectedFolioItemToEdit.ItemId);
        for (let folioItem of this.folioItemsDetails) {
          if (this.selectedFolioItemToEdit.ItemId == folioItem.ItemId) {
            folioItem.FolioAmount =
              this.previousFolioItemDetails[previousFolioItemIndex].FolioAmount;
            folioItem.TaxAmount =
              this.previousFolioItemDetails[previousFolioItemIndex].TaxAmount;
            // folioItem.FolioAmount = this.selectedFolioItemToEdit.FolioAmount
            // folioItem.TaxAmount = this.selectedFolioItemToEdit.TaxAmount
          }
        }
      }
      this.folioDateChange = false;
      this.selectAllFolio = false;
      this.selectedItemCount = true;
      this.selectedVoidItem = false;
      this.folioItemsToVoid.splice(0);
      this.selectedFolioItemToEdit = null;
      this.folioUpdate = false;
      this.isFolioDirty = false;
      this.ShowDropdown = false;
      this.selectedLedger = null;
      for (let folioItem of this.folioItemsDetails) {
        folioItem.Ischecked = false;
      }
      this.itemToEdit = null;
      this.checkedItems.splice(0);
    },

    saveCheckInCheckOutTime() {
      // if(isCheckInTimeOrCheckOutTime == "checkinTime"){

      // }
      // else if(isCheckInTimeOrCheckOutTime == "checkoutTime"){

      // }
      let vm = this;
      vm.$store.dispatch("dataRequestHandler", {
        key: "updateReservation_checkincheckoutTimes",
        params: {
          ReservationId: vm.guestInfo.ReservationId,
          checkInTime: vm.checkInTime,
          checkOutTime: vm.checkOutTime,
        },
        callback: function (err, response) {
          if (err) {
            console.log("err in updateReservation_checkincheckoutTimes", err);
            return;
          }
          if (response) {
            console.log(
              "response in updateReservation_checkincheckoutTimes",
              response
            );
          }
        },
      });
      // vm.$store.dispatch("dataRequestHandler", {
      //   key: "updateReservation_checkincheckoutTimes",
      //   params: {
      //     ReservationId: vm.guestInfo.ReservationId,
      //     checkInTime:
      //       vm.checkinTime.hh + ":" + vm.checkinTime.mm + "" + vm.checkinTime.a,
      //     checkOutTime:
      //       vm.checkoutTime.hh +
      //       ":" +
      //       vm.checkoutTime.mm +
      //       "" +
      //       vm.checkoutTime.a
      //     // UpdatedBy
      //   },
      //   callback: function(err, response) {
      //     if (err) {
      //       console.log("err in updateReservation_checkincheckoutTimes", err);
      //       return;
      //     }
      //     if (response) {
      //       console.log(
      //         "response in updateReservation_checkincheckoutTimes",
      //         response
      //       );
      //     }
      //   }
      // });
    },
    folioRecalculateCloseModal() {
      if (
        this.modalParams &&
        this.modalParams.popupTitle != "Folio surcharge calculations"
      ) {
        this.myValue =
          this.actualMyValue && this.actualMyValue[0]
            ? this.actualMyValue[0].id
            : null;
        this.guestInfo.RateplanName =
          this.actualMyValue && this.actualMyValue[0]
            ? this.actualMyValue[0].RatePlan_DisplayName
            : null;
        this.guestInfo.Promocode =
          this.actualMyValue && this.actualMyValue[0]
            ? this.actualMyValue[0].PromoCodes
            : null;
        this.showRatePlanSave = false;
        this.selectedFolioItemToEdit = false;
        this.ShowDropdown = false;
        if (
          this.modalParams &&
          this.modalParams.popupTitle != "Transaction Details"
        ) {
          this.getFolioSummary(false);
        }
      }
      this.isModalVisible = false;
    },
    CancelNotes() {
      let vm = this;
      for (let note of vm.notes) {
        note.showEditIcon = 0;
      }
      if (vm.notesDetailById && vm.notesDetailById.noteId == -1) {
        vm.notesDetailById = {};
        vm.notesDetailById.noteId = -1;
      } else if (vm.notesDetailById.noteId && vm.notesDetailById.noteId != -1) {
        // vm.notesDetailById =
        vm.getNotesDetailsById(vm.notesDetailById && vm.notesDetailById.noteId,null);
      }
    },
    showAddCompany() {
      let vm = this;
      // console.log("showAddCompany------",vm.guestInfo.CompanyProfileId,vm.companyInfo,"vm.guestInfo---",vm.guestInfo);
      if (
        !vm.guestInfo.CompanyProfileId ||
        (vm.guestInfo.ReservationId == -1 &&
          vm.guestInfo.GuestProfileId == -1 &&
          !vm.guestInfo.CompanyProfileId)
      ) {
        return true;
      }
      return false;
    },

    getBalanceTransferFolioSummary(
      startDate,
      endDate,
      showDateRange,
      dateRange
    ) {
      let vm = this;
      vm.showBTInvoice = true;
      vm.isDateRange = !showDateRange ? true : false;
      vm.modalParams = null;
      vm.showAddPaymentDetail = false;
      vm.Cancel(); //Cancelling add folio items
      vm.CancelUpdateFolioItem(); //Cancelling edit folio items
      vm.$store.dispatch("dataRequestHandler", {
        key: "getFolioSummaryDetails",
        params: {
          clientId: vm.RatePlanList[0].ClientId,
          reservationId: vm.guestInfo.ReservationId,
          // transferOnDate: showDateRange && startDate
          //   ? moment(startDate).format("YYYY-MM-DD")
          //   : moment().format("YYYY-MM-DD"),
          balanceOfStartDate:
            !showDateRange && dateRange
              ? moment(dateRange.startDate).format("YYYY-MM-DD")
              : moment(vm.roomInfo.StartDate).format("YYYY-MM-DD"),
          balanceOfEndDate:
            !showDateRange && dateRange
              ? moment(dateRange.endDate).format("YYYY-MM-DD")
              : showDateRange && endDate
              ? moment(endDate).format("YYYY-MM-DD")
              : moment(vm.roomInfo.EndDate).format("YYYY-MM-DD"),
          isDateRange: vm.isDateRange,
        },
        callback: function (err, response) {
          if (err) {
            console.log("err in get folio details---", err);
            return;
          }
          if (response) {
            console.log("response in get folio details---", response);
            vm.balanceTransferFolioDetail = response[0];
            vm.totalBTAmount = response[0].reduce((sum, currentVal) => {
              if (
                currentVal.isFolioItemInclude === true &&
                !currentVal.isPending
              ) {
                return sum + currentVal.FinalAmount;
              } else {
                return sum;
              }
            }, 0);

            console.log("totalBTAmount--", vm.totalBTAmount);
            // vm.DetailedOrConsolidated = value;
            vm.isBalanceTransferModalVisible = true;
            // var html = vm.getHTMLContent();
            // alert( vm.totalBTAmount)
            vm.modalParams = null;
            vm.modalParams = {
              popupTitle: `Balance Transfer to ${vm.guestInfo.CompanyProfileName}`,
              html: true,
              popupContent: vm.balanceTransferFolioDetail,
              cancelbuttonCallback: vm.closeBTpopup,
              yesButtontext: "Create Transfer",
              noButtonText: "Cancel",
              yesButtonCallback: vm.createTransfer,
              noButtonCallback: vm.closeBTpopup,
              dateRange: dateRange
                ? dateRange
                : {
                    startDate: moment(vm.roomInfo.StartDate).format(
                      "DD MMM YYYY"
                    ),
                    endDate: moment(vm.roomInfo.EndDate).format("DD MMM YYYY"),
                  },
              startDate: startDate
                ? moment(startDate).format("DD MMM YYYY")
                : moment().format("DD MMM YYYY"),
              endDate: endDate
                ? moment(endDate).format("DD MMM YYYY")
                : moment(vm.roomInfo.EndDate).format("DD MMM YYYY"),
              totalBTAmount: vm.totalBTAmount,
              balanceAmount: vm.folioCharges.Balance,
              includeBalanceTransfer:
                response[1] &&
                response[1][0] &&
                response[1][0].PreviousBalanceTransfer &&
                response[1][0].PreviousBalanceTransfer != 0
                  ? true
                  : false,
              BalanceTransferAmount:
                response[1] && response[1][0]
                  ? response[1][0].PreviousBalanceTransfer
                  : 0,
              MasterFolioAmount:
                response[1] && response[1][0]
                  ? response[1][0].MasterFolioAmount
                  : 0,
              includeMasterFolioBalanceTransfer: false,
              showMasterPendingItems: false,
            };
          }
        },
      });
    },
    createTransfer(
      event,
      balanceTransferFolioDetail,
      startDate,
      endDate,
      dateRange,
      isDateRange,
      includeBalanceTransfer,
      btObj
    ) {
      let vm = this;
      // console.log("isDateRange----",vm.isDateRange);
      let sendbalanceTransferFolioDetail;
      if (!btObj.includeMasterFolioBalanceTransfer) {
        sendbalanceTransferFolioDetail = balanceTransferFolioDetail.filter(
          (item) => item.isFolioItemInclude && !item.isPending
        );
      } else {
        sendbalanceTransferFolioDetail = balanceTransferFolioDetail.filter(
          (item) => item.isFolioItemInclude
        );
      }
      vm.$store.dispatch("dataRequestHandler", {
        key: "createInvoice",
        params: {
          // clientId: vm.RatePlanList[0].ClientId,
          reservationId: vm.guestInfo.ReservationId,
          totalBTAmount: vm.totalBTAmount,
          qbdata: sendbalanceTransferFolioDetail,
          transferOnDate: startDate,
          balanceOfStartDate:
            !isDateRange && dateRange
              ? dateRange.startDate
              : moment(vm.roomInfo.StartDate).format("YYYY-MM-DD"),
          balanceOfEndDate:
            !isDateRange && dateRange ? dateRange.endDate : endDate,
          CompanyProfileId: vm.guestInfo.CompanyProfileId,
          unitId: vm.roomInfo.UnitId,
          guestdata: vm.guestInfo,
          roomInfo: vm.roomInfo,
          isDateRange: vm.isDateRange,
          includeBalanceTransfer: includeBalanceTransfer,
          TempoConfirmationNumber: vm.guestInfo.TempoConfirmationNumber,
          includeMasterFolioBalanceTransfer:
            btObj.includeMasterFolioBalanceTransfer,
        },
        callback: function (err, response) {
          if (err) {
            console.log("err in get folio details---", err);
            vm.$store.dispatch("toastr", {
              type: "error",
              header: "Error!",
              message: `Error in creating balance transfer`,
            });
            return;
          }
          if (response) {
            console.log("response in get folio details---", response);
            vm.$store.dispatch("toastr", {
              type: "success",
              header: "Success!",
              message: `Balance transfer successfully created`,
            });
            vm.getFolioSummary(false);
            setTimeout(() => {
              vm.getBalanceTransferFolioList();
            }, 6000);
          }
        },
      });
      vm.closeBTpopup();
    },
    getBalanceTransferFolioList() {
      let vm = this;
      vm.$store.dispatch("dataRequestHandler", {
        key: "getBalanceTransferFolioList",
        params: {
          ModuleAction: "GetBalanceTransferFolioList",
          GuestProfileId: vm.guestInfo.CompanyProfileId,
          reservationId: vm.guestInfo.ReservationId,
          searchText: null,
        },
        callback: function (err, response) {
          if (err) {
            return;
          }
          if (response) {
            console.log("resppp---", response);
            vm.balanceTransferDetails.splice(
              0,
              vm.balanceTransferDetails.length,
              ...response[0]
            );
            vm.corporateFolioId = response[2][0].CorporateFolioId;
          }
        },
      });
    },
    selectInvoiceToVoid(invoiceItem,event){
      let vm = this;
      if(invoiceItem && !invoiceItem.isvoided && invoiceItem.Payments == 0){
        invoiceItem.isChecked = event.target.checked ? true : false
        return
      }
      for (let item of vm.balanceTransferDetails) {
        if(!item.isvoided && item.Payments == 0){
          item.isChecked = vm.selectAllInvocies;
        }
      }
    },
    
    voidSelectedInvocies(){
      let vm = this;
      vm.$store.dispatch("dataRequestHandler", {
        key: "voidInvoices",
        params: {
          ModuleAction: "voidInvoices",
          balanceTransferDetails: vm.balanceTransferDetails
        },
        callback: function (err, response) {
          if (err) {
            return;
          }
          if (response) {
            vm.getBalanceTransferFolioList()
            vm.getFolioSummary();
            vm.selectAllInvocies = false
          }
        },
      });
    },
    cancelInvocieVoid(){
      let vm =this
      vm.selectAllInvocies = false
      for (let item of vm.balanceTransferDetails) {
        item.isChecked = false;
      }
    },
    redirectToCompanyProfile(itemId,isvoided) {
      let vm = this;
      if(isvoided == 1){
        return
      }
      vm.$store.dispatch("setFolioItemId", itemId);
      vm.$router.push({
        path: "/companyProfileDetail/" + vm.guestInfo.CompanyProfileId,
        query: { name: "showCorpLedger" },
      });

      // return `/companyProfileDetail/${vm.guestInfo.CompanyProfileId}?name=showCorpLedger`
    },
    getFolioDetails(itemId) {
      let vm = this;
      console.log("itemId---", itemId);
      vm.selectedInvoiceId = itemId;
      if (itemId != "-99") {
        vm.showBTFolioDetails = true;
        vm.getBTFolioSummaryDetails(itemId);
      } else {
        vm.showBTFolioDetails = false;
      }
    },
    getBTFolioSummaryDetails(itemId) {
      let vm = this;
      vm.$store.dispatch("dataRequestHandler", {
        key: "getBalanceTransferFolioDetails",
        params: {
          ModuleAction: "GetBalanceTransferFolioDetails",
          GuestProfileId: vm.$route.params.GuestProfileId,
          itemId: itemId,
        },
        callback: function (err, response) {
          if (err) {
            return;
          }
          if (response) {
            console.log("resppp-detail--", response);
            vm.balanceTransferInvoiceDetails = response[0];
            vm.totalBalanceTransfer = response[1][0];
            vm.totalAmountVal = response[0].reduce(
              (sum, currVal) => sum + currVal.Amount,
              0
            );
            vm.totalTaxVal = response[0].reduce(
              (sum, currVal) => sum + currVal.Tax,
              0
            );
          }
        },
      });
    },
    getTotalAmount(amount, tax) {
      return (amount + tax).toFixed(2);
    },
    backToMasterFolio() {
      let vm = this;
      vm.showBTFolioDetails = false;
      vm.selectedInvoiceId = "-99";
    },
    getBalanceTransferDetails(value) {
      let vm = this;
      // vm.DetailedOrConsolidated = value;
      // vm.isBalanceTransferModalVisible = true;
      // // var html = vm.getHTMLContent();
      // vm.modalParams = {
      //   popupTitle: `Balance Transfer to [${vm.guestInfo.CompanyProfileName}]`,
      //   html: true,
      //   popupContent: vm.balanceTransferFolioDetail,
      //   cancelbuttonCallback: vm.closeBTpopup,
      //   yesButtontext: "Create Transfer",
      //   noButtonText: "Cancel",
      //   yesButtonCallback: vm.createTransfer,
      //   noButtonCallback: vm.closeBTpopup,
      //   startDate: moment().format("DD-MMM-YYYY"),
      //   endDate: moment(this.roomInfo.EndDate).format("DD-MMM YYYY"),
      //   totalBTAmount: vm.totalBTAmount,
      // };
    },
    getSelectedUnitData(){
      let vm = this;
      let unitData = vm.sharedSelectedUnitData
      if(unitData && unitData.UnitId){
        
        setTimeout(() => {
          vm.roomInfo.Persons = unitData.Persons
          vm.roomInfo.formattedStartDate = unitData.startDate
          vm.roomInfo.formattedEndDate = unitData.endDate
          vm.roomInfo.StartDate = unitData.startDate
          vm.roomInfo.EndDate = unitData.endDate
          vm.myValue = unitData.selectedRatePlan[0].id
          if(vm.guestInfo.IsHostMode == 1){
            vm.searchByUnit = false
          }else{
            if(unitData.IsAssigned != 0 ){
              vm.searchByUnit = true
            }else{
              vm.searchByUnit = false
            }
          }
          
          vm.changeSplitReservations()
          vm.GetAvailableRooms()
        }, 2000);
        
      }
    },
    showResFolioSetting() {
      let vm = this;
      console.log("corporateFolioId--", vm.corporateFolioId);
      vm.$store.dispatch("dataRequestHandler", {
        key: "getFolioSettingDetails",
        params: {
          ModuleAction: "getFolioSettingDetails",
          folioID: vm.folioCharges.FolioId,
          resId: vm.guestInfo.ReservationId,
          itemId: null,
        },
        callback: function (err, response) {
          if (err) {
            console.log("err in get folio setting details---", err);
            return;
          }
          if (response) {
            console.log("response--get--", response[0][0]);
            vm.showSettingModal = true;

            vm.folioSettingDetails.NextInvoiceDate = moment(
              vm.roomInfo.originalStartDate
            ).format("DD MMM YYYY");
            vm.folioSettingDetails.rateplanid = vm.guestInfo.RatePlanId;
            vm.folioSettingDetails.TempoConfirmationNumber =
              vm.guestInfo.TempoConfirmationNumber;
            if (
              response[0] &&
              response[0][0] &&
              response[0][0].NextInvoiceDate
            ) {
              response[0][0].NextInvoiceDate = moment
                .utc(response[0][0].NextInvoiceDate)
                .format("DD MMM YYYY");
            }
            vm.folioSettingDetails =
              response[0] && response[0][0]
                ? response[0][0]
                : vm.folioSettingDetails;
            vm.folioSettingDetails.CheckinDate = moment(
              vm.roomInfo.originalStartDate
            ).format("DD MMM YYYY");
            //  {
            //   selectedRatePlan: response[0][0] ? response[0][0].rateplanid : "-99",
            //   rateAmount: response[0][0] ? response[0][0].Amount : null,
            //   ratePlanDuration: response[0][0] ? response[0][0].CyclePeriod : null,
            //   invoiceFrequencyDuration: response[0][0] ? response[0][0].InvoiceFrequency : null,
            //   frequencyDate: response[0][0] && response[0][0].NextInvoiceDate ? moment(response[0][0].NextInvoiceDate).format("DD MMM YYYY") : moment().format("DD MMM YYYY"),
            //   invoiceTermsDuration: response[0][0] ? response[0][0].InvoiceTerms : null,
            //   cyclePeriod: response[0][0] ? response[0][0].CyclePeriodType : "day",
            //   InvoiceFrequencyCycle: response[0][0] ? response[0][0].InvoiceFrequencyType : "day",
            //   InvoiceTermsCycle: response[0][0] ? response[0][0].InvoiceTermsType : "day",
            //   tempoConfimationId: response[0][0] ? response[0][0].TempoConfirmationNumber : null
            // }
            console.log("folioSettingDetails--", vm.folioSettingDetails);
            vm.modalParams = {
              popupTitle: `Folio Settings`,
              html: true,
              folioSettingDetails: vm.folioSettingDetails,
              ratePlanList: vm.ratePlanList,
              resId: vm.guestInfo.ReservationId,
              cancelbuttonCallback: vm.closeSettingPopup,
              yesButtontext: "Save",
              noButtonText: "Cancel",
              yesButtonCallback: vm.saveFolioSetting,
              noButtonCallback: vm.closeSettingPopup,
            };
          }
        },
      });
    },
    saveFolioSetting(event, savetype, folioSettingDetails) {
      let vm = this;
      console.log("res--folioSettingDetails====--", vm.folioSettingDetails);
      vm.$store.dispatch("dataRequestHandler", {
        key: "saveFolioSettings",
        params: {
          ModuleAction: "saveFolioSettings",
          folioID: vm.folioCharges.FolioId,
          folioSettingDetails: folioSettingDetails,
          reservationId: vm.guestInfo.ReservationId,
          // amount: vm.folioSettingDetails.rateAmount,
          // cyclePeriod: vm.folioSettingDetails.ratePlanDuration,
          // cyclePeriodType: vm.folioSettingDetails.cyclePeriod,
          // invoiceFrequency: vm.folioSettingDetails.invoiceFrequencyDuration,
          // invoiceFrequencyType: vm.folioSettingDetails.InvoiceFrequencyCycle,
          // nextInvoiceDate: vm.folioSettingDetails.frequencyDate ? moment(vm.folioSettingDetails.frequencyDate).format("YYYY-MM-DD") : null,
          // invoiceTerms: vm.folioSettingDetails.invoiceTermsDuration,
          // invoiceTermsType: vm.folioSettingDetails.InvoiceTermsCycle,
          // ratePlanId: vm.folioSettingDetails.selectedRatePlan,
          folioSaveType: 0,
        },
        callback: function (err, response) {
          if (err) {
            vm.$store.dispatch("toastr", {
              type: "error",
              header: "Error!",
              message: `Error in saving folio setting details`,
            });
            return;
          }
          if (response) {
            console.log("response in get folio details---", response);
            vm.$store.dispatch("toastr", {
              type: "success",
              header: "Success!",
              message: `Folio setting saved successfully`,
            });
            vm.showSettingModal = false;
          }
        },
      });
    },
    closeSettingPopup() {
      let vm = this;
      vm.modalParams = null;
      vm.showSettingModal = false;
    },
    docusignSocketConnection(){
      let vm = this;
      let apiIp = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":1339" : '');
      let socket = io(apiIp);
      socket.on('connect', function () {
            console.log("docusign socket connected...!");
      });
      socket.on('docuSignNotes', function (response) {
          // console.log('Received data from docuSignNotes:======>', response);
          // window.location.reload();
          vm.getNotesDetails();
          vm.save_Notification(null,null,null);
       });
    },
    getCustomFields() {
      let vm = this;
      vm.$store.dispatch("dataRequestHandler", {
        key: "GetCustomFields",
        params: {
          CustomEntityID: 5,
        },
        callback: function (err, response) {
          if (response) {
            vm.customFieldsList = response.recordsets[0];
            console.log('GetCustomFields response', response);
          } else {
            console.log("GetCustomFields error",err);
          }
        }
      });
    },
    saveCustomFieldInstances() {
      let vm = this;
      console.log("Saving custom fields:", vm.customFieldsList);      
      vm.customFieldsList.forEach(currentField => {
        console.log('currentField', currentField);
        console.log('vm.$route.params.propertyId', vm.$route.params.propertyId);
        if(vm.$route.params.ReservationId != -1){
          vm.$store.dispatch("dataRequestHandler", {
            key: "SaveCustomFieldInstances",
            params: {
              CustomEntityID: currentField.CustomEntityID,
              FieldID: currentField.FieldID,
              FieldTypeID: currentField.FieldTypeID,
              FieldTypeName: currentField.FieldTypeName,
              FieldTypeValue: currentField.FieldTypeValue ? currentField.FieldTypeValue : "",
              CustomFieldName: currentField.CustomFieldName,
              PropertyID: vm.roomInfo && vm.roomInfo.PropertyId ? vm.roomInfo.PropertyId : null,
              ReservationID: vm.$route.params.ReservationId,
              // UnitId: vm.roomInfo.UnitId ? vm.roomInfo.UnitId : null,
              Config: "",
            },
            callback: function (err, response) {
              if (response) {
                console.log('SaveCustomFieldInstances response:', response);
                // vm.getCustomFields();
                // vm.getCustomFieldInstances();
                vm.$store.dispatch("toastr", {
                  type: "success",
                  header: "Success",
                  message: "Custom Fields Value Saved Successfully",
                });
              } else {
                console.log("SaveCustomFieldInstances error", err);
                vm.$store.dispatch("toastr", {
                  type: "error",
                  header: "Error",
                  message: "Error while Saving Custom Fields Value",
                });
              }
            }
          });
        }else{
          vm.$store.dispatch("toastr", {
            type: "warning",
            header: "Warning",
            message: "Please save room info",
          });
        }
      });
    },
    getCustomFieldInstances() {
      let vm = this;
      vm.$store.dispatch("dataRequestHandler", {
        key: "GetCustomFieldInstances",
        params: {
          PropertyID: vm.propertyId ? vm.propertyId : null,
          CustomEntityID: 5,
          ReservationID: vm.$route.params.ReservationId,
        },
        callback: function (err, response) {
          if (response) {
            console.log('GetCustomFieldInstances response', response);
            let customFieldInstances = response.recordsets[0];
            vm.customFieldsList.forEach(field => {
              let instance = customFieldInstances.find(instance => instance.FieldID === field.FieldID);
              field.FieldTypeValue = instance ? instance.FieldTypeValue : null;
            });
          } else {
            console.log("GetCustomFieldInstances error",err);
          }
        }
      });
    },
    isInputType(fieldType) {
      return ['Number', 'String'].includes(fieldType);
    },
    getInputType(fieldType) {
      let vm = this;
      switch (fieldType) {
        case 'Number':
          vm.customFieldPlaceHolder = 'Enter Numeric Value';
          return 'number';
        case 'String':
          vm.customFieldPlaceHolder = 'Enter Custom Field Value';
          return 'text';
        default:
          vm.customFieldPlaceHolder = 'Enter Custom Field Value';
          return 'text';
      }
    },
    parseLovJSON(value) {
      try {
          return JSON.parse(value);
      } catch {
          return [];
      }
    },
    parsedLovConfig(config) {
      return JSON.parse(config);
    },
    filteredListofValues(list) {
      let vm = this;
      const selectedValues = vm.parseLovJSON(list.FieldTypeValue) || [];
      const listOfValues = vm.parsedLovConfig(list.Config).ListOfValues || [];
      return listOfValues.filter(value => !selectedValues.includes(value.value) && (value.statusId !== -1 && value.statusId !== -2));
    },
    initializeShowLovList(fieldID) {
      if (typeof this.showLovList !== 'object') {
        this.showLovList = {};
      }
      if (!(fieldID in this.showLovList)) {
        this.$set(this.showLovList, fieldID, false);
      }
    },
    showLovListFnc(fieldID) {
      this.selectedLovDropdown = fieldID
      this.initializeShowLovList(fieldID);
      this.$set(this.showLovList, fieldID, !this.showLovList[fieldID]);
      setTimeout(() => {
        $("#Lovsdropdowns-" + fieldID).show();
      }, 10);
    },
    toggleDropdown(fieldID) {
      this.initializeShowLovList(fieldID);
      this.$set(this.showLovList, fieldID, !this.showLovList[fieldID]);
    },
    removeListOfValues(fieldID, index) {
      let vm = this;
      const list = vm.customFieldsList.find(field => field.FieldID === fieldID);
      if (list && Array.isArray(vm.parseLovJSON(list.FieldTypeValue))) {
          const parsedValue = vm.parseLovJSON(list.FieldTypeValue);
          parsedValue.splice(index, 1);
          list.FieldTypeValue = JSON.stringify(parsedValue) == '[]' ? '' : JSON.stringify(parsedValue);
      }
      vm.showLovListFnc(fieldID);
    },
    addListOfValues(fieldID, value) {
      let vm = this;
      const list = vm.customFieldsList.find(field => field.FieldID === fieldID);
      if (list) {
          let parsedValue = vm.parseLovJSON(list.FieldTypeValue);
          if (!Array.isArray(parsedValue)) {
              parsedValue = [];
          }
          parsedValue.push(value.value);
          list.FieldTypeValue = JSON.stringify(parsedValue);
      }
      vm.showLovListFnc(fieldID);
    },
    updateCustomFieldDate(key, dateObj, list) {
      const field = this.customFieldsList.find(field => field.FieldID === list.FieldID);
      if (field) {
        field.FieldTypeValue = dateObj ? dateObj.format("DD MMM YYYY") : null;
      } 
    },
    formatFieldTypeValue(value) {
      if (!value) {
          return '';
      }
      if (value.startsWith('["') && value.endsWith('"]')) {
          return value.slice(2, -2).split('","').join(',');
      }
      return value;
    }
  },
  computed: {
    checkSelectedInvoices(){
      return this.balanceTransferDetails.some(item => item.isChecked == true)
    },
    rules() {
      // console.log("in rules");
      let vm = this;
      return vm.addAdditionalEmail.length == "0" ? "required|email" : "email";
      // return vm.addAdditionalEmail.length == "0" ? 'required|email' : 'email';
    },
    fncIsMenuReservations() {
      let vm = this;
      if (
        vm.$store.state.userEntitlementList.hasOwnProperty(
          "fncMenuReservations"
        )
      ) {
        return vm.$store.state.userEntitlementList.hasOwnProperty(
          "fncMenuReservations"
        )
          ? vm.$store.state.userEntitlementList.fncMenuReservations
          : null;
      }
    },
    fncIsReservationUpdate() {
      let vm = this;
      if (
        vm.$store.state.userEntitlementList.hasOwnProperty(
          "fncReservationUpdate"
        )
      ) {
        return vm.$store.state.userEntitlementList.hasOwnProperty(
          "fncReservationUpdate"
        )
          ? vm.$store.state.userEntitlementList.fncReservationUpdate
          : null;
      }
    },
    fncIsReservationReports() {
      let vm = this;
      if (
        vm.$store.state.userEntitlementList.hasOwnProperty(
          "fncReservationReports"
        )
      ) {
        return vm.$store.state.userEntitlementList.hasOwnProperty(
          "fncReservationReports"
        )
          ? vm.$store.state.userEntitlementList.fncReservationReports
          : null;
      }
    },

    getMonthEndDate() {
      console.log("date getMonthEndDate");
      return this.roomInfo.EndDate
        ? moment(this.roomInfo.EndDate).format("MMM")
        : "";
    },
    getMonthStartDate() {
      console.log("date getMonthStartDate");
      return this.roomInfo.StartDate
        ? moment(this.roomInfo.StartDate).format("MMM")
        : "";
    },
    getDateStartDate() {
      console.log("date getDateStartDate");
      return this.roomInfo.StartDate
        ? moment(this.roomInfo.StartDate).format("DD")
        : "";
    },
    getDateEndDate() {
      console.log("date getDateEndDate");
      return this.roomInfo.EndDate
        ? moment(this.roomInfo.EndDate).format("DD")
        : "";
    },
    getYearStartDate() {
      console.log("date getYearStartDate");
      return this.roomInfo.StartDate
        ? moment(this.roomInfo.StartDate).format("YYYY")
        : "";
    },
    getYearEndDate() {
      console.log("date getYearEndDate");
      return this.roomInfo.EndDate
        ? moment(this.roomInfo.EndDate).format("YYYY")
        : "";
    },
    getDayStartDate() {
      console.log("date getDayStartDate");
      return this.roomInfo.StartDate
        ? moment(this.roomInfo.StartDate).format("ddd")
        : "";
    },
    getDayEndDate() {
      console.log("date getDayEndDate");
      return this.roomInfo.EndDate
        ? moment(this.roomInfo.EndDate).format("ddd")
        : "";
    },
    getFormatedStartDate(){
      return this.roomInfo.StartDate
        ? moment(this.roomInfo.StartDate).format("DD MMM YYYY")
        : "";
    },
    getFormatedEndDate(){
      return this.roomInfo.EndDate
        ? moment(this.roomInfo.EndDate).format("DD MMM YYYY")
        : "";
    },
    sortedAvailableRoomsList() {
      if (!this.availableRoomsList || !this.roomInfo) {
          return null;
      }
      const selectedAvailableUnitId = this.roomInfo.UnitId;
      const matchedRooms = this.availableRoomsList.filter(room => room.UnitId === selectedAvailableUnitId);
      const otherRooms = this.availableRoomsList.filter(room => room.UnitId !== selectedAvailableUnitId);
      return matchedRooms.concat(otherRooms);
      //  return this.availableRoomsList;
    },
    noUnitsAvailable() {
      let vm = this;
      if (vm.availableRoomsList && vm.availableRoomsList.length > 0) {
        let availableUnitsList = vm.availableRoomsList.filter(
          (unit) => unit.Unitactualinventory == 1
        );
        console.log("availableUnitsList", availableUnitsList);
        if (availableUnitsList.length == 0) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    showPhoneNumbers() {
      let vm = this;
      if (
        (vm.additionalPhoneNumbers &&
          vm.additionalPhoneNumbers.length > 0 &&
          vm.additionalPhoneNumbers[0].PhoneNumber != "") ||
        vm.guestInfo.PhoneNumber
      ) {
        return false;
      } else {
        return true;
      }
    },
    // fncIsReservationSave(){

    fncIsFolioView() {
      let vm = this;
      if (vm.$store.state.userEntitlementList.hasOwnProperty("fncFolioView")) {
        return vm.$store.state.userEntitlementList.hasOwnProperty(
          "fncFolioView"
        )
          ? vm.$store.state.userEntitlementList.fncFolioView
          : null;
      }
    },
    // fncIsReservationPayments() {
    //   let vm = this;
    //   if (
    //     vm.$store.state.userEntitlementList.hasOwnProperty(
    //       "fncReservationPayments"
    //     )
    //   ) {
    //     return vm.$store.state.userEntitlementList.hasOwnProperty(
    //       "fncReservationPayments"
    //     )
    //       ? vm.$store.state.userEntitlementList.fncReservationPayments
    //       : null;
    //   }
    // },

    fncIsFolioUpdate() {
      let vm = this;
      if (
        vm.$store.state.userEntitlementList.hasOwnProperty("fncFolioUpdate")
      ) {
        return vm.$store.state.userEntitlementList.hasOwnProperty(
          "fncFolioUpdate"
        )
          ? vm.$store.state.userEntitlementList.fncFolioUpdate
          : null;
      }
    },

    fncIsNotesNew() {
      let vm = this;
      if (vm.$store.state.userEntitlementList.hasOwnProperty("fncNotesNew")) {
        return vm.$store.state.userEntitlementList.hasOwnProperty("fncNotesNew")
          ? vm.$store.state.userEntitlementList.fncNotesNew
          : null;
      }
    },

    fncIsNotesUpdate() {
      let vm = this;
      if (
        vm.$store.state.userEntitlementList.hasOwnProperty("fncNotesUpdate")
      ) {
        return vm.$store.state.userEntitlementList.hasOwnProperty(
          "fncNotesUpdate"
        )
          ? vm.$store.state.userEntitlementList.fncNotesUpdate
          : null;
      }
    },

    fncIsNotesSave() {
      let vm = this;
      // if (vm.notesDetailById.noteId === "-1" || vm.notesDetailById.noteId === -1) {
      //   return vm.$store.state.userEntitlementList.hasOwnProperty(
      //     "fncNotesSave"
      //   )
      //     ? vm.$store.state.userEntitlementList.fncNotesSave
      //     : null;
      // } else if (vm.notesDetailById.noteId > 0) {
      //   return vm.$store.state.userEntitlementList.hasOwnProperty(
      //     "fncNotesUpdate"
      //   )
      //     ? vm.$store.state.userEntitlementList.fncNotesUpdate
      //     : null;
      // }

      if (vm.notesDetailById.noteId > 1) {
        return vm.$store.state.userEntitlementList.hasOwnProperty(
          "fncNotesUpdate"
        )
          ? vm.$store.state.userEntitlementList.fncNotesUpdate
          : null;
      } else {
        return vm.$store.state.userEntitlementList.hasOwnProperty(
          "fncNotesSave"
        )
          ? vm.$store.state.userEntitlementList.fncNotesSave
          : null;
      }
    },

    fncIsNotesView() {
      let vm = this;
      if (vm.$store.state.userEntitlementList.hasOwnProperty("fncNotesView")) {
        return vm.$store.state.userEntitlementList.hasOwnProperty(
          "fncNotesView"
        )
          ? vm.$store.state.userEntitlementList.fncNotesView
          : null;
      }
    },

    fncIsFolioNew() {
      let vm = this;
      if (vm.$store.state.userEntitlementList.hasOwnProperty("fncFolioNew")) {
        return vm.$store.state.userEntitlementList.hasOwnProperty("fncFolioNew")
          ? vm.$store.state.userEntitlementList.fncFolioNew
          : null;
      }
    },
    fncIsPaymentAdd() {
      let vm = this;
      if (
        vm.$store.state.userEntitlementList.hasOwnProperty("fncAddPayments")
      ) {
        return vm.$store.state.userEntitlementList.hasOwnProperty(
          "fncAddPayments"
        )
          ? vm.$store.state.userEntitlementList.fncAddPayments
          : null;
      }
    },
    fncIsPaymentUpdate() {
      let vm = this;
      if (
        vm.$store.state.userEntitlementList.hasOwnProperty("fncUpdatePayments")
      ) {
        return vm.$store.state.userEntitlementList.hasOwnProperty(
          "fncUpdatePayments"
        )
          ? vm.$store.state.userEntitlementList.fncUpdatePayments
          : null;
      }
    },
    fncIsPaymentView() {
      let vm = this;
      if (
        vm.$store.state.userEntitlementList.hasOwnProperty("fncViewPayments")
      ) {
        return vm.$store.state.userEntitlementList.hasOwnProperty(
          "fncViewPayments"
        )
          ? vm.$store.state.userEntitlementList.fncViewPayments
          : null;
      }
    },
    fncIsPaymentTransaction() {
      let vm = this;
      if (
        vm.$store.state.userEntitlementList.hasOwnProperty(
          "fncPaymentTransaction"
        )
      ) {
        return vm.$store.state.userEntitlementList.hasOwnProperty(
          "fncPaymentTransaction"
        )
          ? vm.$store.state.userEntitlementList.fncPaymentTransaction
          : null;
      }
    },

    // fncIsHousekeepingTaskList() {
    //   let vm = this;
    //   if(vm.entitlements.fncHousekeepingTaskList.isAssigned === 1){
    //    return false;
    //   }
    //   else{
    //      return true;
    //   }
    // },

    fncIsReservationSave() {
      let vm = this;
      if (vm.$route.params.ReservationId === "-1") {
        return vm.$store.state.userEntitlementList.hasOwnProperty(
          "fncReservationSave"
        )
          ? vm.$store.state.userEntitlementList.fncReservationSave
          : null;
      } else if (vm.$route.params.ReservationId > 0) {
        return vm.$store.state.userEntitlementList.hasOwnProperty(
          "fncReservationUpdate"
        )
          ? vm.$store.state.userEntitlementList.fncReservationUpdate
          : null;
      }
    },

    expiryYears() {
      let currYear = new Date().getFullYear();
      let years = [];
      years.push(currYear);
      for (let yIndex = 1; yIndex <= 16; yIndex++) {
        years.push(currYear + yIndex);
      }
      return years;
    },
    folioItemCount() {
      if (this.folioItemsDetails.length > 0) {
        let actualItems = this.folioItemsDetails.filter(function (fItem) {
          return fItem.IsVoided === 0;
        });
        return actualItems.length;
      }
      // else if(this.balanceTransferInvoiceDetails.length > 0 && this.showBTFolioDetails){
      //   return this.balanceTransferInvoiceDetails.length;
      // }
      return 0;
    },
    defaultPaymentCard() {
      let card = null;
      if (this.guestPaymentCards && this.guestPaymentCards.length > 0) {
        let defaultCard = this.guestPaymentCards.filter(function (pCard) {
          return pCard.IsDefault;
        });
        if (defaultCard && defaultCard.length > 0) {
          return defaultCard[0];
        } else {
          return this.guestPaymentCards[0];
        }
      }
      return card;
    },
    userEntitlementList() {
      let entitlementList = this.$store.getters.getUserEntitlements();
      if (entitlementList && Object.keys(entitlementList).length > 0) {
        return entitlementList;
      }
      return {};
    },
    showDefaultAmount() {
      let vm = this;
      for (let ledger of vm.LedgerAcounts) {
        if (
          vm.selectedLedger &&
          ledger.ledgerAccountID == vm.selectedLedger.ledgerAccountID &&
          ledger.ledgerAccountTypeID == 4
        ) {
          vm.selectedLedger.ledgerAccountTypeID = ledger.ledgerAccountTypeID;
          return true;
        } else if (vm.selectedLedger) {
          vm.selectedLedger.ledgerAccountTypeID = null;
        }
        if (
          vm.selectedFolioItemToEdit &&
          ledger.ledgerAccountID ==
            vm.selectedFolioItemToEdit.ledgerAccountId &&
          ledger.ledgerAccountTypeID == 4
        ) {
          vm.selectedFolioItemToEdit.ledgerAccountTypeID =
            ledger.ledgerAccountTypeID;
          for (let folioItem of vm.folioItemsDetails) {
            if (vm.selectedFolioItemToEdit.ItemId == folioItem.ItemId) {
              folioItem.FolioAmount = null;
            }
          }
          return true;
        }
      }
      if (vm.selectedFolioItemToEdit) {
        for (let folioItem of vm.folioItemsDetails) {
          let previousFolioItemIndex = vm.previousFolioItemDetails
            .map((x) => {
              return x.ItemId;
            })
            .indexOf(folioItem.ItemId);
          if (vm.selectedFolioItemToEdit.ItemId == folioItem.ItemId) {
            folioItem.FolioAmount =
              vm.previousFolioItemDetails[previousFolioItemIndex].FolioAmount;
            folioItem.TaxAmount = null;
            vm.selectedFolioItemToEdit.ledgerAccountTypeID = null;
          } else {
            if (previousFolioItemIndex > -1) {
              folioItem.FolioAmount =
                vm.previousFolioItemDetails[previousFolioItemIndex].FolioAmount;
              folioItem.TaxAmount =
                vm.previousFolioItemDetails[previousFolioItemIndex].TaxAmount;
            }
          }
        }
      }
    },
    sharedSelectedUnitData(){
      let vm = this
      return vm.$store.getters.getUnitsData;
    },
    showTransferCount() {
      let vm = this;
      if (
        vm.balanceTransferInvoiceDetails.length > 0 &&
        vm.showBTFolioDetails
      ) {
        let actualItems = this.balanceTransferInvoiceDetails.filter(function (fItem) {
          return !fItem.isvoided;
        });
        return actualItems.length;
        // return vm.balanceTransferInvoiceDetails.length;
      } else if (
        vm.balanceTransferDetails.length > 0 &&
        !vm.showBTFolioDetails
      ) {
        let actualItems = this.balanceTransferDetails.filter(function (fItem) {
          return !fItem.isvoided;
        });
        return actualItems.length;
        // return vm.balanceTransferDetails.length;
      }
      return 0;
    },
  },
  watch: {
    showactualinventory() {
      let vm = this;
      if (vm.availableRoomsList && vm.availableRoomsList.length > 0) {
        for (var i = 0; i < vm.availableRoomsList.length; i++) {
          console.log("showactualinventory", vm.availableRoomsList[i]);
          vm.availableRoomsList[i].ShowRates = false;
        }
      }
    },
    "guestInfo.CompanyProfileId": function () {
      if (
        this.guestInfo.CompanyProfileId == null ||
        this.guestInfo.CompanyProfileId == undefined ||
        !this.guestInfo.CompanyProfileId
      ) {
        // console.log("this.companyInfo-----",this.companyInfo,this.guestInfo);
        this.companyInfo.GuestFirstName = "";
        this.companyInfo.Address = "";
        this.companyInfo.shortAddress = "";
        this.companyInfo.AddressDetails2 = "";
        this.companyInfo.CityName = "";
        this.companyInfo.StateName = "";
        this.companyInfo.PostalCode = "";
        this.companyInfo.CountryName = "";
        this.additionalCompanyEmails = [
          {
            Emailaddress: null,
            ReservationId: null,
          },
        ];
        this.additionalCompanyPhoneNumbers = [
          {
            PhoneNumber: null,
            ReservationId: null,
          },
        ];
      }
    },

    //     "guestInfo.GuestFirstName"(value, oldvalue) {
    //       let vm = this;

    //       console.log("here1 checkit", )
    //       if ((vm.guestInfo.ReservationId == -1 || vm.guestInfo.ReservationId == "") && value) {
    //         console.log("here2values", value);
    //         clearTimeout(vm.timeout);
    //           vm.timeout = setTimeout(function () {
    //               console.log('searching:', value);
    //               vm.GetGuestProfile_BySearchText();
    //           }, 4000);
    //       }

    //     },

    //     "guestInfo.GuestLastName"(value, oldvalue) {
    //       let vm = this;

    //       console.log("here1 checkit",value)
    //       if ((vm.guestInfo.ReservationId == -1 || vm.guestInfo.ReservationId == "") && value) {
    //         console.log("here2values", value);
    //         clearTimeout(vm.timeout);
    //         vm.timeout = setTimeout(function () {
    //             console.log('searching:', value);
    //             vm.GetGuestProfile_BySearchText();
    //         }, 4000);

    //       }

    //     },
    // "guestInfo.Address"(value, oldvalue) {
    //   let vm = this;

    //   console.log("here1 checkit",value)
    //   if ((vm.guestInfo.ReservationId == -1 || vm.guestInfo.ReservationId == "") && value) {
    //     console.log("here2values", value);
    //     clearTimeout(vm.timeout);
    //     vm.timeout = setTimeout(function () {
    //         console.log('searching:', value);
    //         vm.GetGuestProfile_BySearchText();
    //     }, 4000);

    //   }

    // },
    //       "guestInfo.AddressDetails2"(value, oldvalue) {
    //       let vm = this;

    //       console.log("here1 checkit",value)
    //       if ((vm.guestInfo.ReservationId == -1 || vm.guestInfo.ReservationId == "") && value) {
    //         console.log("here2values", value);
    //         clearTimeout(vm.timeout);
    //         vm.timeout = setTimeout(function () {
    //             console.log('searching:', value);
    //             vm.GetGuestProfile_BySearchText();
    //         }, 4000);

    //       }

    //     },
    //   "guestInfo.CityName"(value, oldvalue) {
    //       let vm = this;

    //       console.log("here1 checkit",value)
    //       if ((vm.guestInfo.ReservationId == -1 || vm.guestInfo.ReservationId == "") && value) {
    //         console.log("here2values", value);
    //         clearTimeout(vm.timeout);
    //         vm.timeout = setTimeout(function () {
    //             console.log('searching:', value);
    //             vm.GetGuestProfile_BySearchText();
    //         }, 4000);

    //       }

    //     },
    //     "guestInfo.StateName"(value, oldvalue) {
    //       let vm = this;

    //       console.log("here1 checkit",value)
    //       if ((vm.guestInfo.ReservationId == -1 || vm.guestInfo.ReservationId == "") && value) {
    //         console.log("here2values", value);
    //         clearTimeout(vm.timeout);
    //         vm.timeout = setTimeout(function () {
    //             console.log('searching:', value);
    //             vm.GetGuestProfile_BySearchText();
    //         }, 4000);

    //       }

    //     },
    //           "guestInfo.CountryName"(value, oldvalue) {
    //       let vm = this;

    //       console.log("here1 checkit",value)
    //       if ((vm.guestInfo.ReservationId == -1 || vm.guestInfo.ReservationId == "") && value) {
    //         console.log("here2values", value);
    //         clearTimeout(vm.timeout);
    //         vm.timeout = setTimeout(function () {
    //             console.log('searching:', value);
    //             vm.GetGuestProfile_BySearchText();
    //         }, 4000);

    //       }

    //     },

    //     additionalEmails: {

    //     handler: function (newobj, oldVal) {
    //            let vm = this;
    //             if ((vm.guestInfo.ReservationId == -1 || vm.guestInfo.ReservationId == "") && newobj && newobj[0].Emailaddress) {
    //      console.log("emailsssss===>",newobj[0].Emailaddress);

    //      clearTimeout(vm.timeout);
    //      vm.timeout = setTimeout(function () {
    //          console.log('searching:', newobj);
    //          vm.GetGuestProfile_BySearchText();
    //      }, 4000);

    //             }
    //    },
    //    deep: true
    // },
    //    additionalPhoneNumbers: {

    //     handler: function (newobj, oldVal) {
    //            let vm = this;
    //             if ((vm.guestInfo.ReservationId == -1 || vm.guestInfo.ReservationId == "") && newobj && newobj[0].PhoneNumber) {
    //      console.log("Phonenumbers===>",newobj[0].PhoneNumber);
    //      clearTimeout(vm.timeout);
    //      vm.timeout = setTimeout(function () {
    //          console.log('searching:', newobj);
    //          vm.GetGuestProfile_BySearchText();
    //      }, 4000);

    //             }
    //    },
    //    deep: true
    // },
    //    "guestInfo.PostalCode"(value, oldvalue) {
    //       let vm = this;

    //     console.log("here1 checkit")
    //       if ((vm.guestInfo.ReservationId == -1 || vm.guestInfo.ReservationId == "") && value) {
    //         console.log("here2values", value);

    //         clearTimeout(vm.timeout);
    //         vm.timeout = setTimeout(function () {
    //             console.log('searching:', value);
    //             vm.GetGuestProfile_BySearchText();
    //         }, 4000);

    //       }

    //     },

    // updateEndDate: function(){

    // },
    // dispalyVoidItems(){
    //   let vm = this;
    //   console.log("in show void items", vm.dispalyVoidItems);
    // },
    // myValue(newValue, oldValue) {
    //   let ratePlanValue = this.actualMyValue && this.actualMyValue[0] ? this.actualMyValue[0].id : null
    //   if (newValue && oldValue && newValue != ratePlanValue) {
    //     let RatePlanId = this.RatePlanList.filter(obj => obj.id == this.myValue);
    //     this.ratePlanId = RatePlanId && RatePlanId[0] ? RatePlanId[0].RatePlanId : null;
    //     this.Promocode = RatePlanId && RatePlanId[0] ? RatePlanId[0].PromoCodes : null;
    //     this.guestInfo.RateplanName = RatePlanId && RatePlanId[0] ? RatePlanId[0].RatePlan_DisplayName : null;
    //     this.guestInfo.Promocode = this.Promocode;
    //     this.showRatePlanSave = true;
    //     this.selectedFolioItemToEdit = true;
    //     this.ShowDropdown = true;
    //     this.GetFolioLedgerTransDetails_beforesave()
    //   }
    // },
    checkInTime() {
      let vm = this;
      if (
        vm.checkInTime != "00:00 AM" &&
        vm.previousRoomInfo.checkInTime != vm.checkInTime
      ) {
        console.log("scope.checkintime ", vm.checkInTime);
        vm.saveCheckInCheckOutTime();
      }
    },
    checkOutTime() {
      let vm = this;
      if (
        vm.checkOutTime != "00:00 AM" &&
        vm.previousRoomInfo.checkOutTime != vm.checkOutTime
      ) {
        console.log("scope.checkintime ", vm.checkOutTime);
        vm.saveCheckInCheckOutTime();
      }
    },
    filterSearchPropertyText(newValue, oldValue) {
      if (newValue) this.getPropertiesBySearchText(oldValue);
    },
    filterSearchUnitTypeText(newValue, oldValue) {
      if (newValue) this.getUnitTypeList(oldValue);
    },
    filterSearchUnitClassText(newValue, oldValue) {
      if (newValue) {
        this.GetUnitClasssListBySearchText(newValue);
      }
    },
    filterSearchRatePlanText(newValue, oldValue) {
      if (newValue) this.getRatePlanList(oldValue);
    },
    // filterSearchPromoCodeText(newValue, oldValue) {
    //   if (newValue) this.getPromoCodeList(oldValue);
    // },
    searchCity(newValue, oldValue) {
      let vm = this;
      vm.cityList = [];
      // vm.isCitySelected = false;
      vm.guestInfo.CityName = newValue;
      // console.log("vm.selectedStateAndCountry.CityName", vm.selectedStateAndCountry.CityName)
      console.log("Firing search", newValue.length + newValue);
      if (vm.searchCityOldValue != vm.searchCity) {
        if (newValue.length > 0) {
          vm.$store.dispatch("dataRequestHandler", {
            key: "GetCitySearch",
            params: {
              ModuleAction: "GetCitySearch",
              SearchLocation: newValue,
              SearchId: 1,
            },
            callback: function (err, response) {
              if (err) {
                return;
              }
              if (response) {
                //console.log("response in search city", response);

                if (
                  (newValue && oldValue) ||
                  (newValue && vm.$route.params.ReservationId === "-1")
                ) {
                  //console.log("vm.cityList", vm.cityList)
                  vm.cityList = response;
                  if (response.length == 0) {
                    vm.enableStateCountry = true;
                    vm.isCitySelected = false;
                  } else {
                    vm.enableStateCountry = false;
                    vm.isCitySelected = false;
                  }
                }
              }
            },
          });
        }
      }
    },

    searchState(newValue, oldValue) {
      let vm = this;
      vm.stateList = [];
      // vm.isCitySelected = false;
      if (vm.selectedStateAndCountry.StateName != newValue && oldValue)
        vm.selectedStateAndCountry.StateId = null;

      vm.guestInfo.StateName = newValue;
      // console.log("vm.selectedStateAndCountry.CityName", vm.selectedStateAndCountry.CityName)
      console.log("Firing search", newValue.length + newValue);
      if (vm.searchStateOldValue != vm.searchState) {
        if (newValue.length > 0) {
          vm.$store.dispatch("dataRequestHandler", {
            key: "GetCitySearch",
            params: {
              ModuleAction: "GetCitySearch",
              SearchLocation: newValue,
              SearchId: 2,
            },
            callback: function (err, response) {
              if (err) {
                return;
              }
              if (response) {
                //console.log("response in search city", response);

                if (
                  (newValue && oldValue) ||
                  (newValue && vm.$route.params.ReservationId === "-1")
                ) {
                  //console.log("vm.cityList", vm.cityList)
                  vm.stateList = response;
                }
                // vm.selectedStateAndCountry.CityName = vm.searchCity;
              }
            },
          });
        }
      }
    },

    searchCountry(newValue, oldValue) {
      let vm = this;
      vm.countryList = [];
      // vm.isCitySelected = false;
      if (vm.selectedStateAndCountry.CountryName != newValue && oldValue)
        vm.selectedStateAndCountry.CountryId = null;

      vm.guestInfo.CountryName = newValue;
      // console.log("vm.selectedStateAndCountry.CityName", vm.selectedStateAndCountry.CityName)
      console.log("Firing search", newValue.length + newValue);
      if (vm.searchCountryOldValue != vm.searchCountry) {
        if (newValue.length > 0) {
          vm.$store.dispatch("dataRequestHandler", {
            key: "GetCitySearch",
            params: {
              ModuleAction: "GetCitySearch",
              SearchLocation: newValue,
              SearchId: 3,
            },
            callback: function (err, response) {
              if (err) {
                return;
              }
              if (response) {
                //console.log("response in search city", response);

                if (
                  (newValue && oldValue) ||
                  (newValue && vm.$route.params.ReservationId === "-1")
                ) {
                  vm.countryList = response;
                }
              }
            },
          });
        }
      }
    },
    selectedFolioItemToEdit: {
      handler: function (after, before) {
        if (this.selectedFolioItemToEdit && this.selectedFolioItemActualJson) {
          if (
            this.selectedFolioItemToEdit.ledgerAccountId !=
              this.selectedFolioItemActualJson.ledgerAccountId ||
            moment(this.selectedFolioItemToEdit.DateEffective).diff(
              moment(this.selectedFolioItemActualJson.DateEffective)
            ) != 0 ||
            this.selectedFolioItemToEdit.FolioAmount !=
              this.selectedFolioItemActualJson.FolioAmount
          ) {
            this.isFolioDirty = true;
          } else {
            this.isFolioDirty = false;
          }
        } else {
          this.isFolioDirty = false;
        }
      },
      deep: true,
    },
    $route: "fetchData",
  },
  beforeRouteEnter(to, from, next) {
    let vm = this;
    next((vm) => {
      vm.prevRoute = from;
    });
  },
  created() {
    let vm = this;
    // refreshtagcomponent
    vm.$store.state.bus.$on("refreshtagcomponent", function () {
      vm.refreshtagcomponent = false;
      setTimeout(function () {
        vm.refreshtagcomponent = true;
      }, 5);
    });
    vm.$store.state.bus.$on("sendGuestInfoToDetail", function (selected) {
      // console.log("sendGuestInfoToDetail", vm.prevRoute);
      vm.isFromGuestPannel = true;
      const oldObject = selected.guestInfo;
      console.log("created-----oldObject---", oldObject, vm.guestInfo);

      let noReservationId = Object.assign({}, oldObject, {
        ReservationId: vm.guestInfo.ReservationId,
        CompanyProfileId: oldObject.AccountType == 7 ? oldObject.GuestProfileId : vm.guestInfo.CompanyProfileId, // acount issue fix 
        SourceId: vm.guestInfo.SourceId,
        SourceName: vm.guestInfo.SourceName,
        SubSourceName: vm.guestInfo.SubSourceName,
        SubsourceId: vm.guestInfo.SubsourceId,
        TempoConfirmationNumber: vm.guestInfo.TempoConfirmationNumber,
        ClientCode: vm.guestInfo.ClientCode,
        ClientEmail: vm.guestInfo.ClientEmail,
        ClientEmailPassword: vm.guestInfo.ClientEmailPassword,
        ConfirmationNumber: vm.guestInfo.ConfirmationNumber,
        CrsConfirmationNumber: vm.guestInfo.CrsConfirmationNumber,
        CrsId: vm.guestInfo.CrsId,
        CrsName: vm.guestInfo.CrsName,
        Ext_ConfirmationNumber: vm.guestInfo.Ext_ConfirmationNumber,
        IsHostMode: vm.guestInfo.IsHostMode,
        LastminuteBooking: vm.guestInfo.LastminuteBooking,
        Promocode: vm.guestInfo.Promocode,
        PropertyAddress: vm.guestInfo.PropertyAddress,
        PropertyOwnerName: vm.guestInfo.PropertyOwnerName,
        RatePlanId: vm.guestInfo.RatePlanId,
        RateplanName: vm.guestInfo.RateplanName,
        ReservationNumber: vm.guestInfo.ReservationNumber,
        SubSourceConfirmationNumber: vm.guestInfo.SubSourceConfirmationNumber,
        emailservice: vm.guestInfo.emailservice,
        sendemail: vm.guestInfo.sendemail,
        DefaultSettingforCompanyprofile:
          vm.guestInfo.DefaultSettingforCompanyprofile,
      });
      // noFoo is { foo: undefined, baz: 42 }
      // this call is also equivalent to this
      noReservationId = {
        ...oldObject,
        ReservationId: vm.guestInfo.ReservationId,
        CompanyProfileId: oldObject.AccountType == 7 ? oldObject.GuestProfileId : vm.guestInfo.CompanyProfileId, // acount issue fix ,
        SourceId: vm.guestInfo.SourceId,
        SourceName: vm.guestInfo.SourceName,
        SubSourceName: vm.guestInfo.SubSourceName,
        SubsourceId: vm.guestInfo.SubsourceId,
        TempoConfirmationNumber: vm.guestInfo.TempoConfirmationNumber,
        ClientCode: vm.guestInfo.ClientCode,
        ClientEmail: vm.guestInfo.ClientEmail,
        ClientEmailPassword: vm.guestInfo.ClientEmailPassword,
        ConfirmationNumber: vm.guestInfo.ConfirmationNumber,
        CrsConfirmationNumber: vm.guestInfo.CrsConfirmationNumber,
        CrsId: vm.guestInfo.CrsId,
        CrsName: vm.guestInfo.CrsName,
        Ext_ConfirmationNumber: vm.guestInfo.Ext_ConfirmationNumber,
        IsHostMode: vm.guestInfo.IsHostMode,
        LastminuteBooking: vm.guestInfo.LastminuteBooking,
        Promocode: vm.guestInfo.Promocode,
        PropertyAddress: vm.guestInfo.PropertyAddress,
        PropertyOwnerName: vm.guestInfo.PropertyOwnerName,
        RatePlanId: vm.guestInfo.RatePlanId,
        RateplanName: vm.guestInfo.RateplanName,
        ReservationNumber: vm.guestInfo.ReservationNumber,
        SubSourceConfirmationNumber: vm.guestInfo.SubSourceConfirmationNumber,
        emailservice: vm.guestInfo.emailservice,
        sendemail: vm.guestInfo.sendemail,
        DefaultSettingforCompanyprofile:
          vm.guestInfo.DefaultSettingforCompanyprofile,
      };
      console.log("noReservationId-created-", noReservationId);
      if (selected.guestInfo.AccountType == 3) {
        vm.guestInfo = noReservationId;
        // console.log("if--noReservationId--",noReservationId);
        vm.guestInfo.IsGuestProfilelinked = true;
        vm.CreateGuestProfile = false;
        vm.additionalEmails = [];
        vm.additionalPhoneNumbers = [];

        vm.additionalEmails.push({
          ReservationId: "",
          Emailaddress: selected.guestInfo.Emailaddress,
        });

        vm.additionalPhoneNumbers.push({
          ReservationId: "",
          PhoneNumber: selected.guestInfo.PhoneNumber,
        });
      } else {
        vm.companyInfo = noReservationId;
        // console.log("guestInfo.DefaultSettingforCompanyprofile----",vm.guestInfo.DefaultSettingforCompanyprofile);
        console.log("created-----compmnyy---", vm.companyInfo);
        vm.additionalCompanyEmails = [];
        vm.additionalCompanyPhoneNumbers = [];
        vm.CreateCompanyProfile = false;
        vm.additionalCompanyEmails.push({
          ReservationId: "",
          Emailaddress: selected.guestInfo.Emailaddress,
        });

        vm.additionalCompanyPhoneNumbers.push({
          ReservationId: "",
          PhoneNumber: selected.guestInfo.PhoneNumber,
        });
      }
    });

    // closepannel
    vm.$store.state.bus.$on("closepannel", function (selected) {
      vm.slectedClosedprofiletype =
        selected.profileType == 7 ? "company" : "Guest";
      if (vm.ShowCompanyData == "Guest") {
        if (selected.isClosed == false) {
          vm.dontOpenPannel = true;
        } else {
          vm.dontOpenPannel = false;
        }
      }
      if (vm.ShowCompanyData == "company") {
        if (selected.isClosed == false) {
          vm.dontOpenCompanyPannel = true;
        } else {
          vm.dontOpenCompanyPannel = false;
        }
      }

      vm.pannelOpened = false;
      // vm.dontOpenPannel = true;
    });
    vm.$store.state.bus.$on("inputChange", function (selected) {
      // if ((vm.guestInfo.ReservationId == -1 || vm.guestInfo.ReservationId == "")) {
      console.log("here2values");
      if (vm.ShowCompanyData == "Guest") {
        vm.guestInfo.Address = selected.value;
      } else {
        vm.companyInfo.Address = selected.value;
      }

      clearTimeout(vm.timeout);
      vm.timeout = setTimeout(function () {
        if (
          vm.guestInfo.ReservationId == -1 ||
          vm.guestInfo.ReservationId == ""
        ) {
          console.log("searching:");
          vm.GetGuestProfile_BySearchText();
        }
      }, 3000);
      // }
    });

    vm.$store.state.bus.$on("guestListLength", function (selected) {
      console.log("guestListLength", selected);

      vm.guestList = selected;
      if (selected.length > 0) {
        vm.pannelOpened = true;
      }
    });
    // vm.$store.state.bus.$on("createReservationWithThisGuest", function (selected) {
    //   console.log("createReservationWithThisGuest", selected);

    // });
    vm.getSelectedUnitData()
  },
  mounted() {
    let vm = this;
    // vm.getCustomFields();
    // vm.getCustomFieldInstances();
    vm.docusignSocketConnection();
    console.log("cmmm----", vm.companyInfo, vm.guestInfo);
    // when navigating to reservation screen the previouse entered guest info is showing making it as null.
    if(vm.$store.state.selectedUnitData === null){
      vm.guestInfo = null
    }
    vm.companyInfo = {};
    vm.$store.dispatch("GetUserEntitlementsAndDefaultProperty");
    if (vm.$route.params.ReservationId == -1) {
      console.log("here");
      vm.CreateGuestProfile = true;
      vm.CreateCompanyProfile = true;
    } else {
      vm.CreateGuestProfile = false;
      vm.CreateCompanyProfile = false;
    }

    // vm.getPaymentCardDetails();
    vm.GetUserEntitlementsAndDefaultProperty();
    // vm.getPaymentDetails();
    vm.getPropertiesBySearchText();
    vm.GetUnitClasssListBySearchText();
    vm.getUnitTypeList();
    vm.getRatePlanList();
    vm.getRatePlanDetailList();
    vm.getPromoCodeList();
    if (vm.$route.params.guestProfileId) {
      vm.Get_GuestProfile_Detail(
        vm.$route.params.guestProfileId,
        "redirectfromaccount"
      );
    }
    // if(vm.$store.getters.getUnitsData != {}){
    //   vm.selectRoom(vm.$store.getters.getUnitsData)
    // }
    // vm.conversationId = 278
    // $(function () {

    // })

    $(document).click(function (e) {
      //console.log("clicked on doc");
      $(".form-control.searchResultsAmenities").hide();
      vm.selectedFilterColumn = null;
      $(".searchLocations").hide();
      $("#Lovsdropdowns-"+vm.selectedLovDropdown).hide();
      if (vm.isCitySelected == false && vm.cityList.length > 0) {
        console.log("here in click");
        vm.enableStateCountry = true;
      }
      vm.emailList = [];
      // $(".card-block button:last-child").click(function (event) {
      //   console.log("herelastchild")
      //   var $scroller = $('.availabilitySearchFixedHeader');
      //   $scroller.scrollTop($scroller.prop("scrollHeight"));
      //   // var scrollTo = $scroller.get(0).scrollHeight;
      //   // $scroller.animate({ scrollTop:scrollTo });
      //   // $('.availabilitySearchFixedHeader').scrollTop($('.availabilitySearchFixedHeader')[0].scrollHeight);
      // });

      // vm.showAmenitiesList =false;
    });
  },
  beforeDestroy() {
    // $(document).unbind( "click");
  },

  components: {
    foliomodal,
    balanceTransferModal,
    folioSettingModal,
    foliomodal_new
  },
};
</script>
<style>
@media screen {
  #printSection {
    display: none;
  }
}

@media print {
  /* body * {
    visibility:hidden;
  }
  #printSection, #printSection * {
    visibility:visible;
  } */
  /* #printSection {
    position:absolute;
    left:0;
    top:0;
  } */
}
.customField_div{
  text-align: center;
}
.customFieldHeading{
  color: #007bff;
  margin-right: 15px;
}
.customFieldHeading_afterRes{
  color: rgb(55, 55, 55); 
  font-size: 16px; 
  font-weight: 600; 
  position: relative; 
  top: -15px;
}
.disabled_customField_class {
  pointer-events: none;
  opacity: 0.5;
}
/* assignOrUnassignModal */
/* .customTab .modal{
    min-width: 30% !important;
  } */
</style>
